import { j as s, $ as bi, a as yi, b as xi, c as _i, d as Ci, e as vi, g as wi, h as Si, i as Ii, n as L, O as ki, k as Bs, l as Hs, w as Hn, Z as Di, H as Ti, m as An, o as xe, p as ho, r as yr, q as ji, t as Ws, W as Ni, u as Fi, A as Pi, F as Ri, v as xr, x as _r, y as Ms, z as Cr, B as Wn, C as Ei, D as Li, E as Ai, G as $i, I as Oi, J as Bi, K as vr, L as Hi, M as Wi } from "./vendor-B4O8kiwH.js";
import f from "classnames";
import { I as P, T as $, a as q, r as Ns, B as le, b as en, c as te, d as Me, S as zs, e as Xe, f as Mi, g as zi } from "./emoji-r0LV8WWJ.js";
import { E as VD, N as KD, j as UD, h as qD, i as GD } from "./emoji-r0LV8WWJ.js";
import { createContext as Ie, useContext as We, useRef as Q, useLayoutEffect as Vi, useState as V, useCallback as N, useEffect as Z, cloneElement as rn, isValidElement as Se, Component as me, PureComponent as k, forwardRef as M, Children as Ee, createRef as B, memo as wr, useMemo as G, Fragment as et, createElement as Ki, lazy as Ui, Suspense as qi, useReducer as Gi, useImperativeHandle as an } from "react";
import { useKey as Sr, useMount as ht, useUnmount as tt, useUpdateEffect as Je, useToggle as Yi, useSetState as Qi, useClickAway as Ir, usePrevious as tn, useDebounce as Xi } from "react-use";
import j from "moment-timezone";
import { v4 as nn } from "uuid";
import { noop as Zi } from "ts-essentials";
import Ji from "react-dom";
function ea(i) {
  let e = i;
  const t = [];
  function n(r) {
    if (r !== e) {
      for (const { type: a, handler: l, options: c } of t)
        e.removeEventListener(a, l, c), r.addEventListener(a, l, c);
      e = r;
    }
  }
  return { proxy: new Proxy({}, {
    get(r, a) {
      if (a === "addEventListener")
        return (c, d, h) => {
          t.push({ type: c, handler: d, options: h }), e.addEventListener(c, d, h);
        };
      if (a === "removeEventListener")
        return (c, d, h) => {
          const u = typeof h == "boolean" ? h : h?.capture ?? !1, p = t.findIndex((m) => {
            const g = typeof m.options == "boolean" ? m.options : m.options?.capture ?? !1;
            return m.type === c && m.handler === d && g === u;
          });
          p !== -1 && t.splice(p, 1), e.removeEventListener(c, d, h);
        };
      const l = e[a];
      return typeof l != "function" ? l : new Proxy(l, {
        apply(c, d, h) {
          return l.apply(e, h);
        }
      });
    }
  }), setWindow: n };
}
const qn = Ie(
  typeof window < "u" ? window : {}
);
function $k({
  value: i,
  children: e
}) {
  const t = Q(null);
  return t.current || (t.current = ea(i)), Vi(() => {
    t.current.setWindow(i);
  }, [i]), /* @__PURE__ */ s.jsx(qn.Provider, { value: t.current.proxy, children: e });
}
function Vs() {
  return We(qn);
}
const ta = "h-tooltip--tooltip__content", na = "h-tooltip--tooltip__contentLight", sa = "h-tooltip--tooltip__contentHasHead", oa = "h-tooltip--tooltip__body", ra = "h-tooltip--tooltip__head", ia = "h-tooltip--tooltip__arrow", mt = {
  content: ta,
  contentLight: na,
  contentHasHead: sa,
  body: oa,
  head: ra,
  arrow: ia
}, aa = 400;
function re({
  children: i,
  content: e,
  onOpenChange: t,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = aa,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...y
}) {
  const C = Vs(), [w, S] = V(
    g ? !1 : void 0
  ), v = N(() => {
    S(!1), C.removeEventListener("click", v);
  }, [C]);
  Z(() => () => {
    C.removeEventListener("click", v);
  }, [v, C]);
  const x = bi();
  if (c || !e)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const _ = (D) => {
    D.stopPropagation(), C[w ? "removeEventListener" : "addEventListener"](
      "click",
      v
    ), S(!w);
  }, I = f(
    mt.content,
    {
      [mt.contentHasHead]: !!r,
      [mt.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(yi, { children: /* @__PURE__ */ s.jsxs(
    xi,
    {
      open: w ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: t,
      children: [
        /* @__PURE__ */ s.jsx(_i, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? _ : void 0,
            ...m,
            ...y,
            children: i
          }
        ) : g && Se(i) ? rn(i, { onClick: _ }) : i }),
        /* @__PURE__ */ s.jsx(Ci, { container: C.document.body, children: /* @__PURE__ */ s.jsx(
          vi,
          {
            id: x,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: mt.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: mt.body, children: e }),
              /* @__PURE__ */ s.jsx(wi, { className: mt.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const la = "h-attachment--attachment__root", ca = "h-attachment--attachment__icon", da = "h-attachment--attachment__name", ha = "h-attachment--attachment__buttons", fn = {
  root: la,
  icon: ca,
  name: da,
  buttons: ha
}, uo = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function ua(i) {
  const e = i.split(".").pop()?.toLowerCase();
  return !e || !uo[e] ? "file" : uo[e];
}
const Ok = (i) => {
  const {
    className: e,
    nameClassName: t,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: a,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = i, u = f(
    {
      [fn.root]: !0
    },
    e
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      P,
      {
        className: fn.icon,
        name: ua(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      re,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(fn.name, t) },
        children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: fn.buttons, children: [
      a && /* @__PURE__ */ s.jsx(
        q,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : a
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        q,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, pa = {
  onError(i, e) {
    console.error(i, e);
  }
}, ma = Ie(pa), po = { error: null };
class Pt extends me {
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  constructor(e) {
    super(e), this.state = po, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(e, t) {
    this.props.onError?.(e, t), this.context?.onError?.(e, t);
  }
  static contextType = ma;
  resetErrorBoundary(...e) {
    this.props.onReset?.(...e), this.resetInternally();
  }
  resetInternally() {
    this.setState(po);
  }
  hasError(e) {
    return e !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: e, fallbackRender: t } = this.props, n = this.hasFallbackElement(e), o = this.hasFallbackRenderer(t);
    if (!n && !o)
      throw new Error(
        `${Pt.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(e) {
    return typeof e == "function";
  }
  hasFallbackElement(e) {
    return e === null || typeof e == "string" || Se(e);
  }
  render() {
    const { error: e } = this.state, { fallbackRender: t, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(e))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(t))
      return t({
        error: e,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function ln(i, e) {
  const t = i.displayName || i.name || "Unknown";
  return Si(
    class extends me {
      static displayName = `withErrorBoundary(${t})`;
      static defaultProps = i.defaultProps;
      render() {
        const o = i;
        return /* @__PURE__ */ s.jsx(Pt, { ...e, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    i
  );
}
const ga = "h-avatar--avatar__root", $n = {
  root: ga,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, fa = {
  24: 16,
  32: 20,
  40: 24
}, ba = ({
  icon: i,
  size: e,
  color: t = "inherit"
}) => /* @__PURE__ */ s.jsx(P, { name: i, size: fa[e], color: t }), ya = "h-image--image__image", xa = "h-image--image__error", _a = "h-image--image__complete", is = {
  image: ya,
  error: xa,
  complete: _a
};
class Ks extends me {
  static defaultProps;
  mounted;
  constructor(e) {
    super(e), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: e } = this.props;
    this.handleSource(e);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { src: t } = this.props;
    e.src !== t && this.handleSource(e.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(e) {
    typeof e == "string" ? this.setState({
      imageSrc: e
    }) : e().then((t) => {
      this.mounted && typeof t == "string" && this.setState({
        imageSrc: t
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(e) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(e);
  }
  onError(e) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(e);
  }
  render() {
    const { className: e, src: t, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [is.image]: !0,
        [is.error]: !!a,
        [is.complete]: !!l
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Ks.defaultProps = {
  className: "",
  alt: ""
};
const Ca = "h-avatar--imageAvatar__root", va = {
  root: Ca
}, wa = ({
  src: i,
  alt: e = "avatar"
}) => /* @__PURE__ */ s.jsx(Ks, { src: i, alt: e, className: va.root }), Sa = "h-avatar--textAvatar__root", On = {
  root: Sa,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, Ia = {
  24: On["avatar-24"],
  32: On["avatar-32"],
  40: On["avatar-40"]
}, ka = ({ text: i = "", size: e }) => /* @__PURE__ */ s.jsx("div", { className: f(On.root, Ia[e]), children: i.trim().split(" ").map(
  (t, n, o) => o.length === 1 ? t : t[0]
).join("").slice(0, 2) }), Da = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Ta {
  constructor(e) {
    this.colors = e, this.colors = e;
  }
  colors;
  generate(e) {
    const t = this.getRandomIndex(e);
    return this.colors[t];
  }
  getRandomIndex(e) {
    const t = Ii(e);
    return Math.floor(t() * this.colors.length);
  }
}
var ee = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(ee || {});
function gt(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function _e(i) {
  return !!i && i.trim().length !== 0;
}
function ja(i) {
  if (i.icon)
    return {
      type: ee.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: e } = i;
  if (!e)
    return {
      type: ee.Icon,
      icon: "user-slash"
    };
  if (_e(e.avatar_url))
    return {
      type: ee.Image,
      src: e.avatar_url,
      alt: e.name || e.display_name || e.email || e.phone_number || e.given_name || e.family_name || ""
    };
  if (_e(e.name)) {
    const t = gt(e.name.trim()).split(" ");
    if (t.length === 1)
      return {
        type: ee.Text,
        text: t[0]?.[0] ?? ""
      };
    const n = t[0], o = t[t.length - 1];
    return {
      type: ee.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (_e(e.display_name))
    return {
      type: ee.Text,
      text: gt(e.display_name.trim())
    };
  if (_e(e.given_name) && _e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.given_name.trim())[0] + gt(e.family_name.trim())[0]
    };
  if (_e(e.given_name) && !_e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.given_name.trim())[0]
    };
  if (!_e(e.given_name) && _e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.family_name.trim())[0]
    };
  if (_e(e.email)) {
    const [t] = e.email.split("@");
    return {
      type: ee.Text,
      text: t.trim()
    };
  }
  return _e(e.phone_number) ? {
    type: ee.Text,
    text: e.phone_number.slice(-2)
  } : e.id ? {
    type: ee.Icon,
    icon: "user-secret"
  } : {
    type: ee.Icon,
    icon: "user-slash"
  };
}
const Ce = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, mo = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...Ce,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": Ce,
  "user-slash": Ce,
  "map-pin": Ce,
  "web-form": Ce,
  code: Ce,
  history: Ce,
  smile: Ce,
  key: Ce,
  webhooks: Ce,
  plug: Ce
}, Na = {
  24: $n["avatar-24"],
  32: $n["avatar-32"],
  40: $n["avatar-40"]
};
class Fa extends k {
  static defaultProps = {
    size: "32",
    colorGenerator: new Ta(Da)
  };
  getAvatarChild(e, t) {
    if (e.type === ee.Icon)
      return /* @__PURE__ */ s.jsx(
        ba,
        {
          size: t,
          icon: e.icon,
          color: e.iconColor
        }
      );
    if (e.type === ee.Image)
      return /* @__PURE__ */ s.jsx(wa, { src: e.src, alt: e.alt });
    if (e.type === ee.Text)
      return /* @__PURE__ */ s.jsx(ka, { size: t, text: e.text });
  }
  calculateColor(e) {
    if (e.type === ee.Icon) {
      if (e.backgroundColor && e.iconColor)
        return {
          backgroundColor: e.backgroundColor,
          contentColor: e.iconColor
        };
      if (mo[e.icon])
        return mo[e.icon];
    }
    return e.type === ee.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : e.type === ee.Text ? this.props.colorGenerator.generate(e.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: e, size: t } = this.props, n = ja(this.props), o = this.getAvatarChild(n, t), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          $n.root,
          Na[t],
          e
        ),
        children: o
      }
    );
  }
}
const kr = ln(Fa, {
  fallback: null
}), Pa = "h-badge--badge__badge", Ra = "h-badge--badge__badgeSmall", Ea = "h-badge--badge__badgeMedium", La = "h-badge--badge__badgePrimary", Aa = "h-badge--badge__badgeSecondary", $a = "h-badge--badge__badgeSuccess", Oa = "h-badge--badge__badgeInfo", Ba = "h-badge--badge__badgeWarning", Ha = "h-badge--badge__badgeError", He = {
  badge: Pa,
  badgeSmall: Ra,
  badgeMedium: Ea,
  badgePrimary: La,
  badgeSecondary: Aa,
  badgeSuccess: $a,
  badgeInfo: Oa,
  badgeWarning: Ba,
  badgeError: Ha
}, Wa = {
  small: He.badgeSmall,
  medium: He.badgeMedium
}, Ma = {
  primary: He.badgePrimary,
  secondary: He.badgeSecondary,
  success: He.badgeSuccess,
  info: He.badgeInfo,
  warning: He.badgeWarning,
  error: He.badgeError
}, za = "badge";
function Hk(i) {
  const { className: e, size: t, variant: n, children: o, ...r } = i, a = f(
    He.badge,
    Wa[t],
    Ma[n],
    e
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": za, children: o });
}
const H = M(function({
  flexWrap: e,
  flexDirection: t,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...e && { flexWrap: e },
    ...t && { flexDirection: t },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Ns(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(le, { ...h, style: p, ref: u, children: d });
}), Va = "h-banner--banner__root", Ka = "h-banner--banner__rootWithClose", Ua = "h-banner--banner__iconContainer", qa = "h-banner--banner__closeIcon", Ga = "h-banner--banner__headline", Ya = "h-banner--banner__rootInfo", Qa = "h-banner--banner__icon", Xa = "h-banner--banner__description", Za = "h-banner--banner__rootWarning", Ja = "h-banner--banner__rootAnnouncement", el = "h-banner--banner__rootSuccess", tl = "h-banner--banner__rootFail", ye = {
  root: Va,
  rootWithClose: Ka,
  iconContainer: Ua,
  closeIcon: qa,
  headline: Ga,
  rootInfo: Ya,
  icon: Qa,
  description: Xa,
  rootWarning: Za,
  rootAnnouncement: Ja,
  rootSuccess: el,
  rootFail: tl
}, nl = (i, e) => {
  if (e !== void 0)
    return e;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Wk = ({
  actionSlot: i,
  className: e,
  description: t,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(ye.root, e, {
    [ye.rootInfo]: r === "info",
    [ye.rootAnnouncement]: r === "announcement",
    [ye.rootWarning]: r === "warning",
    [ye.rootSuccess]: r === "success",
    [ye.rootFail]: r === "fail",
    [ye.rootWithClose]: a
  }), c = nl(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(H, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: ye.iconContainer, children: /* @__PURE__ */ s.jsx(P, { name: c, size: 16, className: ye.icon }) }),
      /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          $.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: ye.headline,
            children: n
          }
        ),
        rn(t, {
          className: ye.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(H, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      q,
      {
        icon: "close",
        variant: "tertiary",
        className: ye.closeIcon,
        onClick: a
      }
    )
  ] });
}, sl = "h-buttonGroup--buttonGroup__root", ol = "h-buttonGroup--buttonGroup__button", rl = "h-buttonGroup--buttonGroup__buttonWithBorder", il = "h-buttonGroup--buttonGroup__buttonWithoutBorder", bn = {
  root: sl,
  button: ol,
  buttonWithBorder: rl,
  buttonWithoutBorder: il
}, Mk = ({
  className: i,
  children: e,
  variant: t,
  size: n,
  disabled: o
}) => {
  const r = f(bn.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Ee.map(e, (a) => {
    if (!Se(a))
      return null;
    const l = (t ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [bn.button]: !0,
      [bn.buttonWithBorder]: l,
      [bn.buttonWithoutBorder]: !l
    });
    return rn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: t ?? a.props.variant,
      size: n
    });
  }) });
}, al = "h-divider--divider__root", ll = "h-divider--divider__withChildren", cl = "h-divider--divider__horizontal", dl = "h-divider--divider__vertical", as = {
  root: al,
  withChildren: ll,
  horizontal: cl,
  vertical: dl
}, Gn = M(function({
  className: e,
  children: t,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (t ? "div" : "hr"), u = f(
    as.root,
    as[o],
    {
      [as.withChildren]: !!t
    },
    e
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": en(r) } : {},
    ...a ? { margin: Ns(a) } : {},
    ...l ? { padding: Ns(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof t == "string" ? /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: t }) : t
    }
  );
}), hl = "h-buttonList--buttonList__buttonList", ul = "h-buttonList--buttonList__inner", go = {
  buttonList: hl,
  inner: ul
};
let pl = class extends k {
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Gn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: e });
  }
};
const ml = "h-buttonList--item__item", gl = "h-buttonList--item__icon", fl = "h-buttonList--item__button", bl = "h-buttonList--item__buttonDisabled", yl = "h-buttonList--item__buttonCentered", xl = "h-buttonList--item__checkmark", _l = "h-buttonList--item__buttonLoading", Cl = "h-buttonList--item__buttonContent", ze = {
  item: ml,
  icon: gl,
  button: fl,
  buttonDisabled: bl,
  buttonCentered: yl,
  checkmark: xl,
  buttonLoading: _l,
  buttonContent: Cl
}, vl = function({
  icon: e,
  children: t,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [ze.item]: !0
    },
    n
  ), g = f(
    ze.button,
    {
      [ze.buttonCentered]: r,
      [ze.buttonLoading]: a,
      [ze.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: ze.buttonContent, children: [
          e && /* @__PURE__ */ s.jsx(P, { className: ze.icon, name: e }),
          /* @__PURE__ */ s.jsx($.Paragraph, { variant: o ? "1" : "2", children: t })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          P,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: ze.checkmark
          }
        )
      ]
    }
  ) });
}, wl = M(vl);
class fo extends k {
  static get Item() {
    return wl;
  }
  static get Header() {
    return pl;
  }
  static get Divider() {
    return Sl;
  }
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(
      {
        [go.buttonList]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: go.inner, children: e }) });
  }
}
const Sl = () => /* @__PURE__ */ s.jsx(Gn, { as: "li", margin: "100 0" }), Il = "h-checkbox--checkbox__root", kl = "h-checkbox--checkbox__rootDisabled", Dl = "h-checkbox--checkbox__rootChecked", Tl = "h-checkbox--checkbox__rootIndeterminate", jl = "h-checkbox--checkbox__checkbox", Nl = "h-checkbox--checkbox__input", ft = {
  root: Il,
  rootDisabled: kl,
  rootChecked: Dl,
  rootIndeterminate: Tl,
  checkbox: jl,
  input: Nl
};
class cn extends k {
  inputRef;
  constructor(e) {
    super(e), this.inputRef = B();
  }
  componentDidMount() {
    const e = this.inputRef.current;
    e && (e.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(e) {
    const t = this.inputRef.current;
    t && e.indeterminate !== this.props.indeterminate && (t.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: e,
      onChange: t,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [ft.root]: !0,
        [ft.rootDisabled]: l,
        [ft.rootChecked]: r,
        [ft.rootIndeterminate]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: ft.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: ft.input,
          onChange: t || L,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Fl = "h-collapseCard--collapseCard__card", Pl = {
  card: Fl
}, Us = Ie({
  isOpen: !1,
  onToggle: L
}), Rl = "h-collapseCard--content__content", El = "h-collapseCard--content__contentIsOpen", bo = {
  content: Rl,
  contentIsOpen: El
};
class Ll extends k {
  static displayName = "CollapseCard.Content";
  getRootClassName(e) {
    return f(bo.content, this.props.className, {
      [bo.contentIsOpen]: e
    });
  }
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Us.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: e
      }
    ) : null });
  }
}
function Yn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (e) => {
      e.key === "Enter" && i(e);
    }
  };
}
const Al = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], $l = ["Escape", "Esc"], Qn = (i) => Al.includes(i), Rt = (i) => $l.includes(i), Ol = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], yo = Ol.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Dr = wr(function({
  containerRef: e,
  children: t,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Q(null), u = Q(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = e || h;
  Sr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const y = p.current?.querySelectorAll(yo), C = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!y)
        return;
      const w = y[0], S = y[y.length - 1];
      if (!b.shiftKey && document.activeElement === S || !b.shiftKey && l && C)
        return w?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === w || b.shiftKey && l && C) && (S?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(yo)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return ht(() => {
    c || (m(), a?.(!0));
  }), tt(() => {
    c || (g(), a?.(!1));
  }), Je(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), e ? /* @__PURE__ */ s.jsx(s.Fragment, { children: t }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: t });
}), Bl = "h-dropdown--dropdown__dropdown", Hl = "h-dropdown--dropdown__dropdownOpen", Wl = "h-dropdown--dropdown__dropdownFromRight", Ml = "h-dropdown--dropdown__dropdownFromBottom", zl = "h-dropdown--dropdown__dropdownAnimating", Vl = "h-dropdown--dropdown__dropdownFixed", Kl = "h-dropdown--dropdown__loader", Ul = "h-dropdown--dropdown__error", ql = "h-dropdown--dropdown__errorIcon", $e = {
  dropdown: Bl,
  dropdownOpen: Hl,
  dropdownFromRight: Wl,
  dropdownFromBottom: Ml,
  dropdownAnimating: zl,
  dropdownFixed: Vl,
  loader: Kl,
  error: Ul,
  errorIcon: ql
};
class nt extends k {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(e) {
    super(e), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = B(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const e = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: e.width,
        oldHeight: e.height
      };
    }
    return null;
  }
  componentDidUpdate(e, t, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== e.isLoading || a !== e.errorMessage)) {
      const d = r !== e.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== e.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: e } = this.props;
    e();
  }
  animate(e, t, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: e,
        height: t,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(e) {
    if (!this.dropdownRef || !e.target) return;
    const t = e.target, { onClose: n } = this.props;
    this.dropdownRef.current && t !== this.dropdownRef.current && !this.dropdownRef.current.contains(t) && n();
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const e = this.dropdownRef.current.parentElement.getBoundingClientRect(), t = e.left + e.width / 2, n = e.top + e.height / 2, o = this.getWindow(), r = o.innerWidth / 2, a = o.innerHeight / 2;
      this.setState({
        fromRight: t > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: e, fromBottom: t, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, a = this.getWindow();
      return e ? r.right = `${a.innerWidth - o.right}px` : r.left = `${o.left}px`, t && (r.bottom = `${a.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: e,
      children: t,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: y, width: C, height: w } = this.state, S = f(
      {
        [$e.dropdown]: !0,
        [$e.dropdownOpen]: o,
        [$e.dropdownFromRight]: g,
        [$e.dropdownFromBottom]: b,
        [$e.dropdownAnimating]: y,
        [$e.dropdownFixed]: c
      },
      e
    );
    let v = { ...d };
    C && w && (v.width = `${C}px`, v.height = `${w}px`), c && (v = { ...v, ...this.getFixedPosition() });
    const x = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: S,
        ref: this.dropdownRef,
        style: v,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: $e.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: $e.error, children: [
            /* @__PURE__ */ s.jsx(P, { className: $e.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          x && /* @__PURE__ */ s.jsx(
            Dr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: t
            }
          )
        ]
      }
    );
  }
}
const Gl = "h-dropdownButton--dropdownButton__root", Yl = "h-dropdownButton--dropdownButton__wrapper", ls = {
  root: Gl,
  wrapper: Yl
}, dn = Ie({
  toggleDropdown: L,
  openDropdown: L,
  closeDropdown: L,
  dropdownOpen: !1
});
class ut extends me {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(e) {
    super(e);
    const t = e.show ?? !1;
    this.state = {
      dropdownOpen: t,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = B(), this.buttonRef = B(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: t
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(e) {
    this.toggleDropdownIfNeeded(e);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(e) {
    return e.show !== this.props.show;
  }
  handleKeyDown(e) {
    Rt(e.key) && this.state.dropdownOpen && (e.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(e) {
    this.shouldToggleDropdown(e) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(e, t = 0) {
    return this.win.setTimeout(e, t);
  }
  handleDropdownToggle() {
    const { dropdownOpen: e } = this.state, t = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!e);
      });
    }, n = this.shouldDropdownBeAboveButton();
    e ? t() : this.setState(
      { fromBottom: n },
      t
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(e) {
    const { allowEscClose: t, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = e ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), t && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const e = this.buttonWrapperRef.current?.getBoundingClientRect();
    return e ? e.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: e,
      buttonProps: t,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: t?.className,
        ...t,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Yn(this.handleDropdownToggle),
        children: n
      }
    ) : e && !n ? /* @__PURE__ */ s.jsx(
      q,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      te,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(P, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: e,
      children: t,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: y,
      destroyOnClose: C,
      ...w
    } = this.props, { dropdownOpen: S, pristine: v } = this.state, x = f({ [ls.root]: ls.root }, e);
    return /* @__PURE__ */ s.jsx(dn.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ...w, className: x, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: ls.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        nt,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: S,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (S || !v && !C) && o
        }
      )
    ] }) }) });
  }
}
const Ql = "h-collapseCard--header__header", Xl = "h-collapseCard--header__headerOpen", Zl = "h-collapseCard--header__headerHasDropdown", Jl = "h-collapseCard--header__headerStatic", ec = "h-collapseCard--header__titleWrapper", tc = "h-collapseCard--header__title", nc = "h-collapseCard--header__chevronPlaceholder", Ve = {
  header: Ql,
  headerOpen: Xl,
  headerHasDropdown: Zl,
  headerStatic: Jl,
  titleWrapper: ec,
  title: tc,
  chevronPlaceholder: nc
};
class sc extends k {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(e) {
    const { dropdown: t, className: n, nonCollapsible: o } = this.props;
    return f(
      Ve.header,
      {
        [Ve.headerOpen]: e,
        [Ve.headerHasDropdown]: !!t,
        [Ve.headerStatic]: !!o
      },
      n
    );
  }
  render() {
    const {
      children: e,
      className: t,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: a,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      compact: u,
      nonCollapsible: p,
      ...m
    } = this.props;
    return /* @__PURE__ */ s.jsx(Us.Consumer, { children: ({ isOpen: g, onToggle: b }) => {
      const y = this.getRootClassName(g);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...m,
          onClick: p ? void 0 : b,
          className: y,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              H,
              {
                alignItems: "center",
                padding: u ? "200 0" : "400 0",
                className: Ve.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: Ve.titleWrapper,
                      onMouseDown: (C) => C.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        $.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: Ve.title,
                          children: e
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(H, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                ut,
                {
                  onClick: (C) => C.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: a,
                  children: l
                }
              ),
              p ? (
                // Reserve the chevron's footprint so a slotAfter (e.g. a
                // timestamp) stays column-aligned with collapsible siblings.
                /* @__PURE__ */ s.jsx("span", { className: Ve.chevronPlaceholder, "aria-hidden": !0 })
              ) : /* @__PURE__ */ s.jsx(
                q,
                {
                  icon: g ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const oc = "h-collapseCard--line__line", rc = "h-collapseCard--line__lineHasLabel", ic = "h-collapseCard--line__value", ac = "h-collapseCard--line__lineHideOverflow", yn = {
  line: oc,
  lineHasLabel: rc,
  value: ic,
  lineHideOverflow: ac
};
class lc extends k {
  render() {
    const { label: e, children: t, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [yn.line]: !0,
        [yn.lineHasLabel]: !!e,
        [yn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      e && /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: e }),
      e ? /* @__PURE__ */ s.jsx("span", { className: yn.value, children: t }) : t
    ] });
  }
}
const cc = "h-collapseCard--readMore__readMore", dc = {
  readMore: cc
};
class hc extends k {
  render() {
    const { onClick: e, url: t, children: n, className: o, ...r } = this.props, a = f({ [dc.readMore]: !0 }, o);
    return t ? /* @__PURE__ */ s.jsx($.ExternalLink, { ...r, href: t, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      te,
      {
        variant: "secondary",
        ...r,
        onClick: e,
        className: a,
        children: n
      }
    );
  }
}
const uc = "h-collapseCard--status__status", pc = {
  status: uc
};
class mc extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f({ [pc.status]: !0 }, t);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: e });
  }
}
class gc extends k {
  static defaultProps = {
    isOpen: !1
  };
  constructor(e) {
    super(e), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = lc;
  static Header = sc;
  static Content = Ll;
  static ReadMore = hc;
  static Status = mc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(e) {
    return e?.type?.displayName === "CollapseCard.Header" && Se(e);
  }
  isContent(e) {
    return e?.type?.displayName === "CollapseCard.Content" && Se(e);
  }
  getHeaderChildren() {
    return Ee.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Ee.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: e } = this.props;
    return f(Pl.card, e);
  }
  render() {
    const {
      className: e,
      onToggle: t,
      isOpen: n,
      children: o,
      containerRef: r,
      ...a
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Us.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...a,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const Vk = ln(gc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), fc = "h-collapsible--collapsible__root", bc = "h-collapsible--collapsible__collapsible", yc = "h-collapsible--collapsible__children", cs = {
  root: fc,
  collapsible: bc,
  children: yc
};
class Kk extends k {
  childrenRef;
  resizeObserver = null;
  constructor(e) {
    super(e), this.childrenRef = B(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: e.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(e) {
    e.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const e = this.childrenRef.current;
    e && this.setState({
      childrenHeight: e.offsetHeight
    });
  }
  render() {
    const { className: e, header: t, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [cs.root]: !0
      },
      e
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: t }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: cs.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: cs.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const xc = "h-colorPicker--colorPicker__root", _c = {
  root: xc
}, Cc = "h-colorPicker-input--colorPickerInput__input", vc = {
  input: Cc
}, wc = ({
  className: i,
  ...e
}) => /* @__PURE__ */ s.jsx(Me, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  ki,
  {
    className: f(vc.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...e
  }
) }), Sc = "h-colorPicker-presets--colorPickerPresets__root", Ic = {
  root: Sc
}, kc = "h-colorPicker-presets-preset--colorPickerPreset__root", Dc = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Tc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", jc = "h-colorPicker-presets-preset--colorPickerPreset__preset", xn = {
  root: kc,
  rootIsSelected: Dc,
  rootAlpha: Tc,
  preset: jc
}, Nc = ({
  color: i,
  onSelect: e,
  isSelected: t,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(xn.root, o, {
      [xn.rootIsSelected]: t,
      [xn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: xn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          e?.(i);
        }
      }
    )
  }
);
Bs([Hs]);
const Fc = ({
  presets: i,
  className: e,
  onChange: t,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(Ic.root, e),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      Nc,
      {
        onSelect: t,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : Hn(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Bs([Hs]);
const Pc = ({
  onChange: i,
  color: e,
  alpha: t,
  className: n,
  ...o
}) => {
  const r = N((a) => {
    setTimeout(() => {
      i?.(Hn(a).toHex());
    });
  }, []);
  return t ? /* @__PURE__ */ s.jsx(
    Ti,
    {
      className: n,
      color: Hn(e ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    Di,
    {
      className: n,
      color: e,
      onChange: i,
      ...o
    }
  );
};
Bs([Hs]);
const Rc = "colorPickerTestId", Xn = ({
  className: i,
  color: e,
  onChange: t,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return G(() => {
    const c = e?.startsWith("#") ? e : Hn(e ?? "").toHex();
    l(c);
  }, [e]), /* @__PURE__ */ s.jsx(
    H,
    {
      flexDirection: "column",
      gap: "250",
      className: f(_c.root, i),
      "data-testid": Rc,
      ...r,
      children: Ee.map(
        o,
        (c) => Se(c) && rn(c, {
          onChange: t,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Xn.Input = wc;
Xn.Sliders = Pc;
Xn.Presets = Fc;
const Ec = "h-columns--columns__root", Lc = {
  root: Ec
}, Ac = "1fr", $c = M(function({ as: e = "div", children: t, className: n, style: o, ...r }, a) {
  const c = Ee.toArray(t).map((d) => d.props.size ?? Ac).join(" ");
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...r,
      ref: a,
      className: f(Lc.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: t
    }
  );
}), Oc = "h-columns-column--column__root", Bc = {
  root: Oc
}, Hc = "h-columns-column-row--columnRow__root", Wc = "h-columns-column-row--columnRow__noMinHeight", Mc = "h-columns-column-row--columnRow__noVerticalPadding", zc = "h-columns-column-row--columnRow__noHorizontalPadding", Vc = "h-columns-column-row--columnRow__borderTop", Kc = "h-columns-column-row--columnRow__borderBottom", Uc = "h-columns-column-row--columnRow__scrollable", qc = "h-columns-column-row--columnRow__slottable", Ke = {
  root: Hc,
  noMinHeight: Wc,
  noVerticalPadding: Mc,
  noHorizontalPadding: zc,
  borderTop: Vc,
  borderBottom: Kc,
  scrollable: Uc,
  slottable: qc
}, Gc = 1, Yc = M(function({
  as: e = "div",
  children: t,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Ke.root, {
    [Ke.slottable]: u,
    [Ke.noVerticalPadding]: u ?? o,
    [Ke.noHorizontalPadding]: r,
    [Ke.borderTop]: l,
    [Ke.borderBottom]: c,
    [Ke.scrollable]: d,
    [Ke.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? Gc : void 0
      },
      children: t
    }
  );
}), Qc = "h-columns-column-slot--columnSlot__root", Xc = "h-columns-column-slot--columnSlot__noVerticalPadding", xo = {
  root: Qc,
  noVerticalPadding: Xc
}, Zc = ({
  children: i,
  className: e,
  noVerticalPadding: t,
  placement: n = "start"
}) => {
  const o = f(xo.root, e, {
    [xo.noVerticalPadding]: t
  });
  return /* @__PURE__ */ s.jsx(
    H,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, ue = ({
  as: i,
  children: e,
  className: t
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: i,
    flexDirection: "column",
    className: f(Bc.root, t),
    children: e
  }
);
ue.Row = Yc;
ue.Slot = Zc;
const Jc = "h-copyToClipboard--copyToClipboard__copyToClipboard", ed = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", _o = {
  copyToClipboard: Jc,
  copyToClipboardTooltip: ed
};
class td extends me {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(e) {
    super(e), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(e) {
    const t = document.body;
    if (!e || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", t.appendChild(n), n.select(), document.execCommand("copy"), t.removeChild(n);
  }
  handleClick(e) {
    const { disabled: t, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    t || (typeof r == "function" && r(e), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: e, children: t, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      _o.copyToClipboard,
      { [_o.copyToClipboardTooltip]: r && o },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Ee.map(t, (l) => Se(l) ? rn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class Uk extends k {
  render() {
    const { buttonProps: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx(td, { ...t, children: /* @__PURE__ */ s.jsx(q, { icon: "copy", variant: "secondary", ...e }) });
  }
}
const nd = "h-simplePagination--simplePagination__paginationButton", Co = {
  paginationButton: nd
}, sd = "simplePaginationTestId", od = ({
  nextButtonClick: i = L,
  previousButtonClick: e = L,
  nextButtonText: t = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": sd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: r || h,
      onClick: e,
      variant: "secondary",
      ...d,
      className: f(
        Co.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        Co.paginationButton,
        c?.className
      ),
      children: h ? u : t
    }
  )
] }), Zn = Ie(
  void 0
);
var de = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(de || {});
const rd = "h-table-tfoot--tfoot__root", id = "h-table-tfoot--tfoot__rootIsLoading", vo = {
  root: rd,
  rootIsLoading: id
}, Tr = Ie(
  void 0
), wo = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Zn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(Tr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...t,
    ref: n,
    className: f(
      {
        [vo.rootIsLoading]: o?.status.loading
      },
      vo.root,
      i
    ),
    "data-testid": de.Foot,
    children: e
  }
) }) }), ad = Object.assign(M(wo), { name: wo.name }), ld = "h-table-thead--thead__root", cd = "h-table-thead--thead__rootIsLoading", So = {
  root: ld,
  rootIsLoading: cd
}, jr = Ie(
  void 0
), Io = ({ className: i, ...e }, t) => /* @__PURE__ */ s.jsx(Zn.Consumer, { children: (n) => {
  const o = f(So.root, i, {
    [So.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(jr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...e,
      ref: t,
      className: o,
      "data-testid": de.Head
    }
  ) });
} }), dd = Object.assign(M(Io), { name: Io.name }), Et = (i) => {
  const e = We(Zn);
  if (!e)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const t = We(jr) || {
    isTableHead: !1
  }, n = We(Tr) || {
    isTableFoot: !1
  };
  return i.children({
    ...e,
    ...t,
    ...n
  });
}, hd = "h-table-tableFooter--tableFooter__root", ud = "h-table-tableFooter--tableFooter__rootIsLoading", ko = {
  root: hd,
  rootIsLoading: ud
}, Do = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Et, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [ko.rootIsLoading]: o.loading
      },
      ko.root,
      e
    ),
    ...t,
    children: i
  }
) }), qs = Object.assign(M(Do), {
  name: Do.name
});
function pd(i) {
  return Ee.toArray(i).reduce(
    (e, t) => {
      const n = t;
      return n.type === qs ? e.footers.push(n) : e.children.push(n), e;
    },
    { children: [], footers: [] }
  );
}
var Mn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Mn || {});
const md = "h-pagination--pageNumber__button", gd = "h-pagination--pageNumber__text", fd = "h-pagination--pageNumber__textSelected", ds = {
  button: md,
  text: gd,
  textSelected: fd
}, bd = ({
  number: i,
  isSelected: e = !1,
  onClick: t
}) => {
  const n = f(ds.text, {
    [ds.textSelected]: e
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    te,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => t(i),
      "data-testid": Mn.PageNumber,
      className: ds.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, yd = "h-pagination--pagination__root", xd = "h-pagination--pagination__pageNumberSeparatorWrapper", To = {
  root: yd,
  pageNumberSeparatorWrapper: xd
};
class _d extends me {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(e) {
    super(e), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: e, pageCount: t, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [e, t, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(e) {
    const { currentPage: t, onPageChange: n } = this.props;
    e !== t && n(e);
  }
  areAllPagedDisplayable() {
    const { pageCount: e, pageRangeDisplayed: t } = this.props;
    return t >= e;
  }
  leadingTruncationIsNeeded() {
    const { start: t } = this.calculateMiddlePagesRange();
    return t - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: e } = this.props, { start: t, length: n } = this.calculateMiddlePagesRange(), o = t - 1 + n;
    return e - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: e } = this.props;
    return e - 2;
  }
  calculateMiddlePagesRange(e) {
    const { pageCount: t, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (e?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: An(
      n - r,
      2,
      t - o
    ), length: o };
  }
  createPageNumbers(e, t = 1) {
    return Array.from({ length: e }, (n, o) => o + t);
  }
  renderPageNumbers(e, t = 1) {
    return this.createPageNumbers(e, t).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(e) {
    const { currentPage: t } = this.props, n = e === t;
    return /* @__PURE__ */ s.jsx(
      bd,
      {
        number: e,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      e
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(e = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: To.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(P, { name: "dots-h" }) }, `gap-${e}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: e } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(e)] : this.renderSinglePageNumber(e);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: e, length: t } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(t, e);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: e } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(To.root, e), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Mn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Mn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const jo = ({ children: i, ...e }, t) => /* @__PURE__ */ s.jsx(Et, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(qs, { children: /* @__PURE__ */ s.jsx("div", { ref: t, ...e, "data-testid": de.PaginationRow, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  _d,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), Cd = Object.assign(M(jo), {
  name: jo.name
}), vd = "h-table-tbody--tbody__root", wd = "h-table-tbody--tbody__rootIsLoading", Sd = "h-table-tbody--tbody__rootIsLoadingFade", hs = {
  root: vd,
  rootIsLoading: wd,
  rootIsLoadingFade: Sd
}, Id = "h-emptyState--emptyState__textWrapper", kd = "h-emptyState--emptyState__rootSmall", Dd = "h-emptyState--emptyState__rootLarge", us = {
  textWrapper: Id,
  rootSmall: kd,
  rootLarge: Dd
}, Td = ({
  className: i,
  title: e,
  description: t,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [us.rootSmall]: r === "small",
      [us.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(P, { name: n, size: 20, color: en(o) }),
        /* @__PURE__ */ s.jsxs(
          H,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: us.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", children: e }),
              /* @__PURE__ */ s.jsx(
                $.Paragraph,
                {
                  variant: "2",
                  as: typeof t == "string" ? "p" : "div",
                  children: t
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(te, { ...a })
      ]
    }
  );
};
function jd(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Td, { ...i }) }) }) });
}
function Nd({
  onRetry: i,
  ...e
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.LoadingFailedRow, ...e, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(te, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function Fd({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(zs, {}),
        /* @__PURE__ */ s.jsx(le, { margin: "300", children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const No = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Et, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...t,
      "data-testid": de.Body,
      ref: n,
      className: f(
        {
          [hs.rootIsLoading]: o,
          [hs.rootIsLoadingFade]: o && c === "fade"
        },
        hs.root,
        e
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(Fd, {}),
        d && /* @__PURE__ */ s.jsx(Nd, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(jd, { ...l }),
        h && i
      ]
    }
  );
} }), Pd = Object.assign(M(No), { name: No.name }), Rd = "h-table-td--td__root", Ed = "h-table-td--td__rootExtraPaddingForFirstChild", Ld = "h-table-td--td__rootStickyFooterTd", ps = {
  root: Rd,
  rootExtraPaddingForFirstChild: Ed,
  rootStickyFooterTd: Ld
}, Fo = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Et, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    ps.root,
    {
      [ps.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [ps.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    le,
    {
      as: "td",
      ref: n,
      className: l,
      ...t,
      "data-testid": de.Td,
      children: e
    }
  );
} }), lt = Object.assign(M(Fo), { name: Fo.name }), Ad = "h-table-th--th__root", $d = "h-table-th--th__rootSticky", Od = "h-table-th--th__rootShowBG", Bd = "h-table-th--th__rootClickable", Hd = "h-table-th--th__icon", Wd = "h-table-th--th__contentWrapper", Md = "h-table-th--th__tooltip", st = {
  root: Ad,
  rootSticky: $d,
  rootShowBG: Od,
  rootClickable: Bd,
  icon: Hd,
  contentWrapper: Wd,
  tooltip: Md
};
class Po extends k {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (e) => e === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: e } = this.props, { context: t } = this;
    return {
      sortByThisColumn: t?.sorting.sortStatus?.sortBy === e,
      sortDirection: t?.sorting.sortStatus?.direction,
      columnIsSortable: t?.sorting.sortable && !xe(e) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(e) {
    const { sortByThisColumn: t, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: e,
      direction: "asc"
    };
    if (!t)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: e,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: e } = this.props, { context: t } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      e?.(n), o && !xe(r) && t?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(e) {
    return e ? /* @__PURE__ */ s.jsx(
      P,
      {
        className: st.icon,
        name: e === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Et, { children: (e) => {
      this.context = e;
      const { sorting: t, presentation: n } = e;
      t.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        st.root,
        {
          [st.rootClickable]: u,
          [st.rootSticky]: n.stickyHeader,
          [st.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [st.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        le,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": de.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: st.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(re, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Fs = Object.assign(
  M(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(Po, { ...e, thRef: t });
    }
  ),
  { name: Po.name }
), zd = (i) => i === !1, Vd = "h-table-tr--tr__trHoverable", Kd = "h-table-tr--tr__expansionTriggerWrapper", Ud = "h-table-tr--tr__expansionTriggerWrapperExpanded", qd = "h-table-tr--tr__checkboxCell", Gd = "h-table-tr--tr__checkboxCellExpanded", Yd = "h-table-tr--tr__expandedRowContentWrapper", ve = {
  trHoverable: Vd,
  expansionTriggerWrapper: Kd,
  expansionTriggerWrapperExpanded: Ud,
  checkboxCell: qd,
  checkboxCellExpanded: Gd,
  expandedRowContentWrapper: Yd
}, Qd = ({
  rowId: i,
  isExpandable: e,
  isExpanded: t,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [ve.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": de.Row,
        children: [
          e && /* @__PURE__ */ s.jsx(
            lt,
            {
              className: f(ve.expansionTriggerWrapper, {
                [ve.expansionTriggerWrapperExpanded]: t
              }),
              children: o && /* @__PURE__ */ s.jsx(
                q,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right",
                  "data-testid": de.RowExpansionTrigger,
                  onClick: () => {
                    xe(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            lt,
            {
              className: f(ve.checkboxCell, {
                [ve.checkboxCellExpanded]: t
              }),
              children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    xe(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    e && t && /* @__PURE__ */ s.jsxs("tr", { "data-testid": de.Row, children: [
      /* @__PURE__ */ s.jsx(lt, { className: ve.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(lt, { className: ve.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        lt,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: ve.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Xd = ({
  isExpandable: i,
  children: e,
  trRef: t,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: t, "data-testid": de.Row, children: [
  i && /* @__PURE__ */ s.jsx(lt, { className: ve.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e
] }), Zd = ({
  isExpandable: i,
  isSelectable: e,
  allRowsSelected: t,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": de.Row, children: [
  i && /* @__PURE__ */ s.jsx(Fs, { className: ve.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e && /* @__PURE__ */ s.jsx(Fs, { className: ve.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    cn,
    {
      checked: t,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Ro extends k {
  context = void 0;
  isRowExpanded(e, t) {
    return e.includes(t);
  }
  hasSelectableRow() {
    const { rowId: e } = this.props;
    return this.context?.rows.selectableRows === !0 && !xe(e);
  }
  hasExpandableRow() {
    const { expandableContent: e, rowId: t } = this.props;
    return this.context?.rows.expandableRows === !0 && !xe(e) && !xe(t);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(zd);
  }
  rowIdIsPresent(e) {
    return !xe(e);
  }
  render() {
    const { children: e, expandableContent: t, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Et, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          Zd,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: e
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Xd, { ...o, isExpandable: a.expandableRows, children: e });
      const l = xe(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = xe(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        Qd,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: t,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: e
        }
      );
    } });
  }
}
const Jd = Object.assign(
  M(function(e, t) {
    return /* @__PURE__ */ s.jsx(Ro, { ...e, trRef: t });
  }),
  { name: Ro.name }
), eh = "h-table--table__wrapper", th = "h-table--table__wrapperIsFramed", nh = "h-table--table__wrapperIsLoading", sh = "h-table--table__innerWrapper", oh = "h-table--table__wrapperIsDisabled", rh = "h-table--table__table", bt = {
  wrapper: eh,
  wrapperIsFramed: th,
  wrapperIsLoading: nh,
  innerWrapper: sh,
  wrapperIsDisabled: oh,
  table: rh
};
class zn extends k {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(e) {
    super(e), this.state = {
      expandedRows: e.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    H,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx($.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(e) {
    this.state.expandedRows.includes(e) ? this.setState(({ expandedRows: t }) => ({
      expandedRows: t.filter((n) => n !== e)
    })) : this.setState(({ expandedRows: t }) => ({
      expandedRows: [...t, e]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: e,
        stickyHeader: t,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!e,
        stickyHeader: !!t,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? L
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? L,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? L,
        onAllRowsSelect: a?.onAllRowsSelect ?? L,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: e,
      className: t,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = pd(n), h = f(bt.wrapper, o?.className, {
      [bt.wrapperIsFramed]: e,
      [bt.wrapperIsLoading]: this.props.loading,
      [bt.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [bt.innerWrapper]: !0
      },
      a
    ), p = f(bt.table, t), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Pt, { fallback: zn.fallback, children: /* @__PURE__ */ s.jsx(Zn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(Cd, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const pe = Object.assign(
  M(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(zn, { ...e, tableRef: t });
    }
  ),
  {
    name: zn.name,
    Thead: dd,
    Tbody: Pd,
    Tfoot: ad,
    Tr: Jd,
    Th: Fs,
    Td: lt,
    Footer: qs
  }
), ih = "h-helpIcon--helpIcon__infoIcon", ah = {
  infoIcon: ih
};
class Gs extends k {
  render() {
    const {
      side: e,
      text: t,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      re,
      {
        head: n,
        content: t,
        disabled: o,
        side: e,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(ah.infoIcon, a), children: /* @__PURE__ */ s.jsx(P, { name: "info" }) })
      }
    );
  }
}
const Nr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: e, style: t, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(pe.Th, { columnId: o || e, style: t, children: [
  e,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Gs, { side: "bottom", ...n })
] }, e || r)) }), lh = ({
  columns: i,
  data: e
}) => /* @__PURE__ */ s.jsxs(pe, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(pe.Thead, { children: /* @__PURE__ */ s.jsx(pe.Tr, { children: /* @__PURE__ */ s.jsx(Nr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(pe.Tbody, { children: e.map((t, n) => /* @__PURE__ */ s.jsx(pe.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(pe.Td, { children: o(t) }, r)) }, n)) })
] }), ch = ({
  data: i,
  rowId: e,
  columns: t,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  pe.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      lh,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: e,
    children: t.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(pe.Td, { children: r(i) }, a))
  }
), qk = ({
  columns: i,
  subTableColumns: e,
  data: t,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, y) => y.columnId ? [...b, y.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    pe,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(e && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(pe.Thead, { children: /* @__PURE__ */ s.jsx(pe.Tr, { children: /* @__PURE__ */ s.jsx(Nr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(pe.Tbody, { children: t.map((b, y) => /* @__PURE__ */ s.jsx(
          ch,
          {
            rowId: u ? u(b) : y,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: e
          },
          y
        )) }),
        a && /* @__PURE__ */ s.jsx(pe.Footer, { children: /* @__PURE__ */ s.jsx(od, { ...a }) })
      ]
    }
  );
}, dh = "h-datePickerOld--datePickerDay__root", hh = "h-datePickerOld--datePickerDay__rootActive", uh = "h-datePickerOld--datePickerDay__rootDisabled", ph = "h-datePickerOld--datePickerDay__rootDim", mh = "h-datePickerOld--datePickerDay__label", Bt = {
  root: dh,
  rootActive: hh,
  rootDisabled: uh,
  rootDim: ph,
  label: mh
};
class gh extends k {
  render() {
    const {
      className: e,
      dim: t,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [Bt.root]: !0,
        [Bt.rootDim]: t,
        [Bt.rootActive]: n,
        [Bt.rootDisabled]: !n && o
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: Bt.label, children: r })
      }
    );
  }
}
const fh = "h-datePickerOld--datePickerOld__grid", bh = "h-datePickerOld--datePickerOld__gridItem", yh = "h-datePickerOld--datePickerOld__day", xh = "h-datePickerOld--datePickerOld__month", _h = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", Ch = "h-datePickerOld--datePickerOld__timeButtonContainerRight", vh = "h-datePickerOld--datePickerOld__arrowTime", wh = "h-datePickerOld--datePickerOld__arrow", Sh = "h-datePickerOld--datePickerOld__dayNames", Ih = "h-datePickerOld--datePickerOld__dayName", kh = "h-datePickerOld--datePickerOld__time", Dh = "h-datePickerOld--datePickerOld__timeDisplay", X = {
  grid: fh,
  gridItem: bh,
  day: yh,
  month: xh,
  timeButtonContainerLeft: _h,
  timeButtonContainerRight: Ch,
  arrowTime: vh,
  arrow: wh,
  dayNames: Sh,
  dayName: Ih,
  time: kh,
  timeDisplay: Dh
}, Gk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class Zt extends k {
  static defaultProps;
  static getDateValue(e) {
    const t = e.value instanceof Date ? e.value : /* @__PURE__ */ new Date();
    return new Date(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes()
    );
  }
  constructor(e) {
    super(e);
    const t = Zt.getDateValue(e.input);
    this.state = {
      selectedDate: t,
      showDate: t
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { input: t } = this.props;
    e.input !== t && this.setState({
      selectedDate: Zt.getDateValue(e.input)
    });
  }
  generateGrid() {
    const { selectedDate: e, showDate: t } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      t.getFullYear(),
      t.getMonth(),
      1,
      e.getHours(),
      e.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Zt.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === t.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(e) {
    const { showDate: t } = this.state, n = new Date(t.getTime());
    n.setMonth(t.getMonth() + e), this.setState({
      showDate: n
    });
  }
  nextMonth = (e) => {
    e.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (e) => {
    e.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(e, t) {
    e.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: t
    };
    o.getMonth() !== t.getMonth() && (r.showDate = t), this.setState(r), n(t);
  }
  goToTime(e, t, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + t), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, 15, "minutes");
  };
  prevMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, -15, "minutes");
  };
  nextHour = (e) => {
    e.preventDefault(), this.goToTime(e, 1);
  };
  prevHour = (e) => {
    e.preventDefault(), this.goToTime(e, -1);
  };
  canGoPrevMonth() {
    const { minDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth(),
      1
    );
    return e < n;
  }
  canGoNextMonth() {
    const { maxDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return e > n;
  }
  canGoDirection(e = "hours", t) {
    const n = e === "minutes" ? "setMinutes" : "setHours", o = e === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + t), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: e,
      input: t,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, e), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: X.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(P, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(P, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: X.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: X.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: X.gridItem, children: /* @__PURE__ */ s.jsx(
        gh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: X.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: X.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: X.timeDisplay, children: `${ho(
          c.getHours().toString(),
          2,
          "0"
        )}:${ho(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(P, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Zt.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Th(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Ps(i) {
  return j(i, j.ISO_8601).isValid();
}
function jt(i) {
  return !!j.tz.zone(i ?? "");
}
const Pe = "HH:mm", Fr = yr(24), Pr = yr(0, 60, 15), Rr = (i) => j("1995-12-25").format(i);
function Er(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Lr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Ar({
  hour: i,
  minute: e,
  timeFormat: t
}) {
  const n = j({ hour: i, minute: e });
  return {
    id: n.format(Pe),
    name: n.format(t)
  };
}
function jh(i, e) {
  return e?.map(({ hour: t, minute: n }) => (Er(t), Lr(n), Ar({ hour: t, minute: n, timeFormat: i }))) || [];
}
function $r({
  hours: i,
  minutes: e,
  overrides: t,
  timeFormat: n
}) {
  return ji(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...e.map((l, c) => (c === 0 && Er(r), a === 0 && Lr(l), Ar({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(jh(n, t)),
    ["id"]
  );
}
const Nh = "h-datePicker--datePicker__root", Fh = "h-datePicker--datePicker__navigationButton", Ph = "h-datePicker--datePicker__nextMonthButton", Rh = "h-datePicker--datePicker__prevMonthButton", Tt = {
  root: Nh,
  navigationButton: Fh,
  nextMonthButton: Ph,
  prevMonthButton: Rh
}, Vn = {
  previousMonth({ ariaLabel: i, ...e }) {
    const t = f(
      Tt.navigationButton,
      Tt.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(P, { ...e, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...e }) {
    const t = f(
      Tt.navigationButton,
      Tt.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(P, { ...e, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Or = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Br = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Hr = (i) => {
  const { value: e, presets: t, onSelect: n } = i, o = N(
    (r) => {
      n(r.key === e ? null : r);
    },
    [n, e]
  );
  return /* @__PURE__ */ s.jsxs(et, { children: [
    /* @__PURE__ */ s.jsx(Gn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(fo, { children: t.map((r) => /* @__PURE__ */ s.jsx(
      fo.Item,
      {
        isSelected: r.key === e,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, Eh = "h-fieldLabel--fieldLabel__root", Lh = "h-fieldLabel--fieldLabel__label", Ah = "h-fieldLabel--fieldLabel__labelChildren", $h = "h-fieldLabel--fieldLabel__rootRequired", Oh = "h-fieldLabel--fieldLabel__helpIcon", Ht = {
  root: Eh,
  label: Lh,
  labelChildren: Ah,
  rootRequired: $h,
  helpIcon: Oh
}, Bh = "fieldLabel";
class Ys extends k {
  render() {
    const { required: e, helpIcon: t, className: n, children: o, ...r } = this.props, a = f(Ht.root, n, {
      [Ht.rootRequired]: e
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": Bh, children: [
      /* @__PURE__ */ s.jsx("label", { className: Ht.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Ht.labelChildren, children: o }) }),
      !!t?.text && /* @__PURE__ */ s.jsx(
        Gs,
        {
          ...t,
          className: f(Ht.helpIcon, t.className)
        }
      )
    ] });
  }
}
const Hh = "h-dropdownSelect--dropdownInfinite__item", Wh = "h-dropdownSelect--dropdownInfinite__list", Eo = {
  item: Hh,
  list: Wh
};
class Lo extends k {
  render() {
    const {
      item: e,
      itemComponent: t,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      t,
      {
        item: e,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(re, { ...n, children: m }, e.id) : m;
  }
}
const Mh = 6, zh = 48;
class Qs extends k {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(e) {
    super(e), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = B(), this.infiniteListRef = B();
  }
  componentDidUpdate(e) {
    const { activeItem: t, items: n, pagination: o } = this.props, r = typeof e.activeItem == "object" && e.activeItem ? e.activeItem.id : e.activeItem, a = typeof t == "object" && t ? t.id : t;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(e) {
    const { items: t } = this.props;
    return e < t.length;
  }
  isItemActive(e) {
    if (!e) return !1;
    const { activeItem: t } = this.props;
    return t ? typeof t == "object" && "id" in t ? e.id === t.id : e.id === t : !1;
  }
  isItemChecked(e) {
    if (!e) return !1;
    const { selectedItems: t } = this.props;
    return (t?.findIndex((o) => typeof o == "object" ? o.id === e.id : o === e.id) ?? -1) > -1;
  }
  isItemDisabled(e) {
    return e ? (this.props.disabledItems?.indexOf(e.id) ?? -1) >= 0 : !0;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !e || Ws(t?.[e.id]) ? null : t?.[e.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: e, activeItem: t } = this.props;
    if (!t || !this.listRef.current) return;
    const n = typeof t == "object" && "id" in t ? t.id : t, o = e.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(e) {
    const { id: t } = this.props;
    return t ? `${t}-option-${e}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: e,
    style: t
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(e), d = e === n.length - 1, h = c ? n[e] : { id: nn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: t, className: Eo.item, children: [
      /* @__PURE__ */ s.jsx(
        Lo,
        {
          id: this.getItemId(e),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(Ni, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: e,
      pagination: t,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = Mh,
      itemHeight: d = zh,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!t || !t.infinite || !t.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: Eo.list,
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: e.map((C, w) => {
            const S = Fi(C) ? C : C.id.toString() || C.name.toString() || C.toString();
            return /* @__PURE__ */ s.jsx(
              Lo,
              {
                id: this.getItemId(w),
                checked: this.isItemChecked(C),
                clearSearch: l,
                disabled: this.isItemDisabled(C),
                item: C,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(C),
                active: this.isItemActive(C)
              },
              S
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = t, g = m || (p ? e.length + c : e.length), b = {
      items: e,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, y = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Pi, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: C }) => /* @__PURE__ */ s.jsx(
      Ri,
      {
        ...b,
        ref: this.infiniteListRef,
        width: C,
        height: y,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const Vh = "h-selectItems-checkableBaseItem--checkableBaseItem__root", Kh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Uh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", qh = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Gh = "h-selectItems-checkableBaseItem--checkableBaseItem__content", Wt = {
  root: Vh,
  rootActive: Kh,
  rootDisabled: Uh,
  checkbox: qh,
  content: Gh
};
class Xs extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  handleKeyDown(e) {
    const { disabled: t, onKeyDown: n } = this.props;
    (e.key === "Enter" || e.key === " ") && !t && (e.preventDefault(), this.handleChange()), n && n(e);
  }
  noop(e) {
    e.preventDefault();
  }
  render() {
    const {
      item: e,
      onChange: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(Wt.root, {
      [Wt.rootDisabled]: r,
      [Wt.rootActive]: c
    }), m = r ? L : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            cn,
            {
              id: e?.id,
              name: "",
              className: Wt.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: Wt.content, children: l })
        ]
      }
    );
  }
}
const Yh = "h-selectItems-emptySelectItem--emptySelectItem__root", Qh = "h-selectItems-emptySelectItem--emptySelectItem__name", Ao = {
  root: Yh,
  name: Qh
};
class hn extends k {
  render() {
    const { label: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...t, className: Ao.root, children: /* @__PURE__ */ s.jsx("div", { className: Ao.name, children: e }) });
  }
}
const Xh = "h-selectItems-selectItem--selectItem__root", Zh = "h-selectItems-selectItem--selectItem__rootActive", Jh = "h-selectItems-selectItem--selectItem__name", eu = "h-selectItems-selectItem--selectItem__nameBold", tu = "h-selectItems-selectItem--selectItem__nameWithDescription", nu = "h-selectItems-selectItem--selectItem__description", su = "h-selectItems-selectItem--selectItem__icon", ot = {
  root: Xh,
  rootActive: Zh,
  name: Jh,
  nameBold: eu,
  nameWithDescription: tu,
  description: nu,
  icon: su
};
class Wr extends me {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = e, m = f(ot.root, {
      [ot.rootActive]: a
    }), g = f(ot.name, {
      [ot.nameBold]: o,
      [ot.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          t(e);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(P, { className: ot.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: ot.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const ou = "h-selectItems-checkableSelectItem--checkableSelectItem__name", ru = {
  name: ou
};
class Yk extends k {
  render() {
    const { item: e, isLoading: t } = this.props, { name: n } = t ? { name: "Loading..." } : e;
    return /* @__PURE__ */ s.jsx(Xs, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: ru.name, children: n }) });
  }
}
const iu = "h-selectItems-tagSelectItem--tagSelectItem__root", au = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", lu = "h-selectItems-tagSelectItem--tagSelectItem__name", cu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", du = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", hu = "h-selectItems-tagSelectItem--tagSelectItem__dot", yt = {
  root: iu,
  rootActive: au,
  name: lu,
  nameBold: cu,
  dotContainer: du,
  dot: hu
};
class Qk extends k {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = e, u = f(yt.root, {
      [yt.rootActive]: l
    }), p = f(yt.name, {
      [yt.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          t(e), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: yt.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: yt.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const uu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", pu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", mu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", gu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", _n = {
  name: uu,
  dotContainer: pu,
  dot: mu,
  nameContainer: gu
};
class Xk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  render() {
    const { item: e, isLoading: t, disabled: n } = this.props, { name: o, color: r } = t ? { name: "Loading...", color: "#000" } : e;
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: _n.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: _n.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: _n.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: _n.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const fu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", bu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", yu = "h-selectItems-avatarSelectItem--avatarSelectItem__names", xu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", _u = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", Cu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", vu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", wu = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Ue = {
  root: fu,
  rootActive: bu,
  names: yu,
  primaryName: xu,
  secondaryName: _u,
  namesBold: Cu,
  container: vu,
  containerCheckable: wu
};
class Su extends k {
  static defaultProps = {
    checked: !1
  };
  getNames(e) {
    const t = /* @__PURE__ */ new Set();
    typeof e.name == "string" && t.add(e.name), typeof e.name != "string" && typeof e.display_name == "string" && t.add(e.display_name), typeof e.phone_number == "string" && t.add(e.phone_number), typeof e.email == "string" && t.add(e.email);
    const n = Array.from(t);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(e) {
    return typeof e.icon == "string" ? /* @__PURE__ */ s.jsx(P, { name: e.icon, size: 16 }) : /* @__PURE__ */ s.jsx(kr, { user: e });
  }
  renderContent() {
    const e = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, t = this.getAvatar(e), n = this.getNames(e), o = f(Ue.container, {
      [Ue.containerCheckable]: this.props.checkable
    }), r = f(Ue.names, {
      [Ue.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      t,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Ue.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Ue.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const e = this.renderContent(), { checkable: t, ...n } = this.props;
    if (t) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Xs, { ...m, children: e });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Ue.root, {
      [Ue.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          e,
          d && /* @__PURE__ */ s.jsx(P, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Zk extends k {
  render() {
    return /* @__PURE__ */ s.jsx(Su, { checkable: !0, ...this.props });
  }
}
const Iu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", ku = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", Du = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Tu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", Cn = {
  root: Iu,
  rootActive: ku,
  suggestion: Du,
  icon: Tu
};
class Jk extends me {
  static defaultProps = {
    searchSuggestion: (e, t) => e.find((n) => n.name.toLowerCase() === t.toLowerCase()),
    renderSuggestion: (e) => `Add "${e}" tag`
  };
  constructor(e) {
    super(e), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(e) {
    const { searched: t, active: n } = this.props;
    t !== e.searched && this.searchItem(), n !== e.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: e, searched: t, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(e, t);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: e, onSuggest: t, clearSearch: n, triggerClose: o } = this.props;
    o?.(), t?.(e), n();
  }
  handleKeyDown(e) {
    this.props.active && e.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: e,
      triggerClose: t,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(e, Cn.root, {
      [Cn.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: Cn.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: Cn.icon, children: /* @__PURE__ */ s.jsx(P, { name: "plus" }) })
        ]
      }
    );
  }
}
const ju = "h-selectItems-deselectItem--deselectItem__root", Nu = "h-selectItems-deselectItem--deselectItem__rootDisabled", Fu = "h-selectItems-deselectItem--deselectItem__name", Pu = "h-selectItems-deselectItem--deselectItem__icon", vn = {
  root: ju,
  rootDisabled: Nu,
  name: Fu,
  icon: Pu
};
class Ru extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = e, l = f(vn.root, {
      [vn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: vn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: vn.icon,
          onClick: () => {
            t(e);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(P, { name: "close" })
        }
      )
    ] });
  }
}
const Eu = "h-selectItems-tagDeselectItem--tagDeselectItem__root", Lu = "h-selectItems-tagDeselectItem--tagDeselectItem__name", Au = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", $u = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", Ou = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Mt = {
  root: Eu,
  name: Lu,
  icon: Au,
  dotContainer: $u,
  dot: Ou
};
class eD extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = e, d = f(Mt.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Mt.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Mt.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Mt.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Mt.icon,
          onClick: () => {
            t(e);
          },
          children: /* @__PURE__ */ s.jsx(P, { name: "close" })
        }
      )
    ] });
  }
}
const Bu = "h-chip--chip__root", Hu = "h-chip--chip__rootLight", Wu = "h-chip--chip__rootNoBorder", Mu = "h-chip--chip__rootDisabled", zu = "h-chip--chip__rootInteractable", zt = {
  root: Bu,
  rootLight: Hu,
  rootNoBorder: Wu,
  rootDisabled: Mu,
  rootInteractable: zu
}, Vu = ({
  className: i,
  children: e,
  onClick: t,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [zt.root]: !0,
      [zt.rootLight]: n,
      [zt.rootNoBorder]: o,
      [zt.rootDisabled]: r,
      [zt.rootInteractable]: typeof t == "function" && !r
    },
    i
  ), c = typeof t == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(le, { ...a, as: c, className: l, onClick: t, children: e });
}, Ku = "h-tag--tag__tagName", Uu = "h-tag--tag__tagNameTruncated", qu = "h-tag--tag__icon", Gu = "h-tag--tag__deleteButton", Yu = "h-tag--tag__deleteButtonDisabled", Qu = "h-tag--tag__deleteIcon", xt = {
  tagName: Ku,
  tagNameTruncated: Uu,
  icon: qu,
  deleteButton: Gu,
  deleteButtonDisabled: Yu,
  deleteIcon: Qu
}, Nt = ({
  className: i,
  tagNameClassName: e,
  children: t,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [xt.tagName]: !0,
      [xt.tagNameTruncated]: !l
    },
    e
  ), u = f(xt.deleteButton, {
    [xt.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    Vu,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: xt.icon,
            style: { backgroundColor: en(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: t }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(P, { name: "close", className: xt.deleteIcon }) })
      ]
    }
  );
}, Xu = "h-select--select__root", Zu = "h-select--select__rootDisabled", Ju = "h-select--select__inputWrapper", ep = "h-select--select__control", tp = "h-select--select__rootHasIcon", np = "h-select--select__selection", sp = "h-select--select__selectionItem", op = "h-select--select__tag", rp = "h-select--select__tagName", ip = "h-select--select__tagLimiter", ap = "h-select--select__text", lp = "h-select--select__rootSearchable", cp = "h-select--select__rootDropdownOpen", dp = "h-select--select__rootIsSearching", hp = "h-select--select__search", up = "h-select--select__rootSingle", pp = "h-select--select__indicators", mp = "h-select--select__spinner", gp = "h-select--select__clearIndicator", fp = "h-select--select__dropdownIndicator", bp = "h-select--select__dropdown", yp = "h-select--select__dropdownFixed", xp = "h-select--select__pagination", Y = {
  root: Xu,
  rootDisabled: Zu,
  inputWrapper: Ju,
  control: ep,
  rootHasIcon: tp,
  selection: np,
  selectionItem: sp,
  tag: op,
  tagName: rp,
  tagLimiter: ip,
  text: ap,
  rootSearchable: lp,
  rootDropdownOpen: cp,
  rootIsSearching: dp,
  search: hp,
  rootSingle: up,
  indicators: pp,
  spinner: mp,
  clearIndicator: gp,
  dropdownIndicator: fp,
  dropdown: bp,
  dropdownFixed: yp,
  pagination: xp
};
class Ft extends k {
  static contextType = qn;
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: xr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Wr,
    emptyComponent: hn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(e) {
    super(e), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = B(), this.searchRef = B(), this.listRef = B();
    const t = this.initSelectedItems(), n = this.initHighlightedIndex(t);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: t,
      highlightedIndex: n
    }, !Ft.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Ft.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(e, t) {
    const { dropdownOpen: n } = this.state;
    if (n !== t.dropdownOpen)
      if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    _r(e.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: e } = this.state;
    e && (this.context ?? window).removeEventListener(
      "click",
      this.handleClickOutside
    );
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: e } = this.props, { highlightedIndex: t } = this.state, n = `${e}-label`, o = `${e}-dropdown`, r = t !== null ? `${o}-option-${t}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(e) {
    return typeof e == "string" || typeof e == "number";
  }
  initSelectedItems() {
    const { selectedItems: e = [] } = this.props;
    return e.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(e = this.state.selectedItems) {
    const { multiple: t, items: n, hideSelectedItems: o } = this.props;
    if (!t && !o && e.length) {
      const r = this.resolveItem(e[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(e) {
    return this.isItemIdType(e) ? this.props.items.find((n) => n.id === e) : e;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    this.setState({ search: n }, () => {
      t?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(e = "toggle") {
    const { dropdownOpen: t } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (e === "toggle")
      return o?.(!t), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !t });
    if (e === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (e === "close" && t)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(e) {
    if (!this.controlRef || !(e.target instanceof Node)) return;
    const t = this.controlRef.current, { target: n } = e;
    n && n !== t && !t?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(e, t = "smooth") {
    this.setState({ highlightedIndex: e }, () => {
      if (e === null || e === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[e]?.scrollIntoView({
        behavior: t,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(e) {
    const { search: t, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = e.key === "Escape", h = e.key === "Enter", u = e.key === "ArrowUp", p = e.key === "ArrowDown", m = e.key === "Backspace";
    if ((h || u || p) && e.preventDefault(), p && !n)
      return e.preventDefault(), this.handleDropdown("open");
    if (d && (n && e.stopPropagation(), this.handleDropdown("close")), m && a && !t) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(t), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const y = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(y);
        }
      }
    }
  }
  handleSelect(e) {
    const { multiple: t, keepOpen: n, onSelect: o } = this.props;
    if (t) {
      const r = this.isItemSelected(e);
      this.handleChange(e, !r);
    } else
      this.setState({
        selectedItems: [e],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(e);
  }
  handleChange(e, t) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: t ? [...o, e] : o.filter((r) => r.id !== e.id)
    }), this.resetSearch(), n?.(e, t);
  }
  handleRemove(e, t) {
    t && (t.preventDefault(), t.stopPropagation()), this.handleChange(e, !1);
  }
  handleClear(e) {
    e.stopPropagation();
    const { onClear: t } = this.props;
    t?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  getAvailableItems() {
    const { search: e } = this.state, { items: t, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(Ms(e), "i");
    return t.filter((c) => {
      const d = [];
      return e && !o && (r && typeof r == "function" ? d.push(r(c, e)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(e) {
    return this.state.selectedItems.some(
      (t) => t.id === e.id
    );
  }
  isItemDisabled(e) {
    return this.props.disabledItems?.includes(e.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(e) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: e } = this.props, { selectedItems: t } = this.state;
    if (e && e > 0)
      return /* @__PURE__ */ s.jsx(H, { flexDirection: "column", children: t?.slice(e).map((n) => /* @__PURE__ */ s.jsxs(
        H,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(le, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(e) {
    return this.props.renderSelection?.(e) ?? this.getItemName(e);
  }
  renderMultipleSelection() {
    const { selectedItems: e } = this.state, t = this.props.limit || e.length, n = t < e.length, o = e?.slice(0, t).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: Y.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            Nt,
            {
              className: Y.tag,
              tagNameClassName: Y.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        re,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            Nt,
            {
              className: f(Y.tag, Y.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                e.length - t
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: e, selectedItems: t } = this.state, n = t[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: Y.text,
        "aria-hidden": !!e,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: e } = this.props;
    return !e && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: Y.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (t) => t.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !e,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: e, highlightedIndex: t, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [Y.dropdown]: !0,
        [Y.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), y = this.getAvailableItems(), C = y[t ?? -1] ?? null, w = !y.length;
    return /* @__PURE__ */ s.jsxs(
      nt,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: e,
        "data-testid": "select-dropdown",
        children: [
          w && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: y,
              active: t === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !w && /* @__PURE__ */ s.jsx(
            Qs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: y,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: C,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: Y.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: e,
      disabled: t,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [Y.root]: !0,
        [Y.rootSingle]: !r,
        [Y.rootDisabled]: t,
        [Y.rootSearchable]: a,
        [Y.rootDropdownOpen]: m,
        [Y.rootIsSearching]: !!p,
        [Y.rootHasIcon]: !!h
      },
      e
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Me,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: t,
              className: Y.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: Y.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: t ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: Y.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: Y.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        zs,
                        {
                          className: Y.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        q,
                        {
                          tabIndex: -1,
                          className: Y.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        q,
                        {
                          tabIndex: -1,
                          className: Y.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (y) => {
                            y.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !t && m && this.renderDropdown()
        ]
      }
    );
  }
}
function _p(i) {
  return /* @__PURE__ */ s.jsx(
    Pt,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Ft, { ...i })
    }
  );
}
const Cp = "h-datePicker-timezoneSelector--timezoneSelector__root", vp = "h-datePicker-timezoneSelector--timezoneSelector__label", $o = {
  root: Cp,
  label: vp
}, Mr = ({
  disabled: i,
  tooltipProps: e,
  selectedTimezone: t,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = N((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = G(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: $o.root, children: [
    /* @__PURE__ */ s.jsx(Ys, { className: $o.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(re, { ...e, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      _p,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          jt(t) ? t : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, wp = "h-fieldAlert--fieldAlert__root", Sp = "h-fieldAlert--fieldAlert__alert", Ip = "h-fieldAlert--fieldAlert__icon", ms = {
  root: wp,
  alert: Sp,
  icon: Ip
}, kp = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Dp = {
  root: kp
};
function Tp({
  className: i,
  variant: e = "tertiary",
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    te,
    {
      ...t,
      variant: e,
      className: f(i, Dp.root)
    }
  );
}
const jp = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Jn({
  children: i,
  className: e,
  ...t
}) {
  const n = t.variant || "title", o = f(ms.root, e), [r, a] = V(!1), l = jp[n], c = N(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs($.Input, { ...t, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(P, { className: ms.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: ms.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(re, { content: i, children: i }) : i })
  ] });
}
Jn.Button = Tp;
const Np = "hmm A", Fp = (i, e) => {
  const t = `${i}`.padStart(2, "0"), n = `${e}`.padStart(2, "0");
  return `${t}:${n}`;
}, Oo = (i, e) => {
  const t = i.hours(), n = i.minutes();
  return {
    id: Fp(t, n),
    name: i.format(e)
  };
}, sn = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: e = !1,
  timeOptions: t,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Fr,
  selectableMinutes: a = Pr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), y = G(
    () => t || $r({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      t,
      r,
      a,
      n,
      l
    ]
  ), C = G(() => {
    const v = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, Np]
    );
    if (!v.isValid())
      return null;
    const _ = v.hours(), I = v.minutes();
    if (!d || d(_, I))
      return Oo(v, l);
    const D = _ <= 12, F = _ + 12, W = d(F, I);
    return D && W ? Oo(j({ hours: F, minutes: I }), l) : null;
  }, [u, g]), w = G(() => {
    if (!e)
      return y;
    const v = p ? y.filter(({ name: _ }) => _ !== C?.name) : y.filter(
      ({ name: _ }) => _.startsWith(g) && _ !== C?.name
    );
    if (!C)
      return v;
    const x = p !== C.id ? 0 : v.findIndex(
      (_) => j(_.id, [l]) > j(C.id, [l])
    );
    return v.splice(
      // If it's -1 then there was no later time, so add it to the end.
      x === -1 ? v.length : x,
      0,
      C
    ), v;
  }, [C, g, p, y]), S = N(
    (v) => {
      v?.id !== C?.id && b(""), c(v?.id || null), m(v?.id || null);
    },
    [C]
  );
  return Z(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Ft,
    {
      searchable: !0,
      placeholder: Rr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: e ? w : y,
      onChange: L,
      onClear: S,
      onSelect: S,
      ...e && { onSearch: b }
    }
  );
}, Pp = "h-timePicker-range--timeRangePicker__root", Rp = "h-timePicker-range--timeRangePicker__timePickerFrom", Ep = "h-timePicker-range--timeRangePicker__timePickerTo", Lp = "h-timePicker-range--timeRangePicker__arrowContainer", Ap = "h-timePicker-range--timeRangePicker__arrowContainerHasError", $p = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Op = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", rt = {
  root: Pp,
  timePickerFrom: Rp,
  timePickerTo: Ep,
  arrowContainer: Lp,
  arrowContainerHasError: Ap,
  arrowContainerHasWarning: $p,
  arrowContainerHasSuccess: Op
}, Bp = ({
  className: i,
  disabled: e,
  endTime: t,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Fr,
  selectableMinutes: l = Pr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: t || null
  }), y = G(
    () => $r({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), C = G(() => {
    const x = y.map(
      ({ id: D }) => j(D, [u])
    ), _ = j(m, [u]), I = m && x.findIndex(
      (D) => D > _
    ) || 0;
    return y.slice(I);
  }, [y, m, u]);
  Z(() => {
    const x = typeof d == "string", _ = typeof d == "string";
    (x && d !== m || _ && t !== g) && b((I) => ({
      ...I,
      ...x && { startTime: d },
      ..._ && { endTime: t }
    }));
  });
  const w = N(
    (x) => (_) => {
      b((I) => {
        const D = j(_, [u]), F = j(I.startTime, [u]), W = j(I.endTime, [u]), T = y.map(
          ({ id: ne }) => j(ne, [u])
        ), E = T.findIndex(
          (ne) => ne >= D
        ) || -1, A = x === "startTime" ? E : T.findIndex(
          (ne) => ne >= F
        ), U = x === "endTime" ? -1 : T.findIndex(
          (ne) => ne >= W
        ), ie = {
          ...I,
          [x]: _,
          ...I.endTime !== null && x !== "endTime" && A >= U && {
            endTime: y[E + 1]?.id || null
          }
        };
        return n(ie), ie;
      });
    },
    [n]
  ), S = N(
    (x, _) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const F = I.hours(), W = I.minutes();
      return F < x || F === x && W < _;
    },
    [m, u]
  ), v = (x) => r?.[x] || r || Rr(u);
  return /* @__PURE__ */ s.jsxs(le, { className: f(rt.root, i), children: [
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: rt.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: e,
        hasDropDownIndicator: !1,
        timeOptions: y,
        onSelect: w("startTime"),
        placeholder: v("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      le,
      {
        className: f(rt.arrowContainer, {
          [rt.arrowContainerHasError]: c === "error",
          [rt.arrowContainerHasWarning]: c === "warning",
          [rt.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(P, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: rt.timePickerTo,
        searchable: !0,
        disabled: e || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: C,
        onSelect: w("endTime"),
        placeholder: v("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: S
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Qe {
  constructor(e, t, n) {
    this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n, this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n;
  }
  dateFormat;
  dateParser;
  dateRangeConstraint;
  static validationOK = { isValid: !0, error: null };
  isValidDate(e) {
    try {
      return this.dateParser(e).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(e) {
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: t, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(e);
    return o.isBefore(t, "day") ? {
      isValid: !1,
      error: `Date must be after ${t.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  isTimeOrderValid({
    startDate: e,
    endDate: t
  }) {
    return !e || !t ? Qe.validationOK : e.isAfter(t) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Qe.validationOK;
  }
}
const Hp = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", Wp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Mp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", zp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Vp = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Kp = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Up = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", qe = {
  root: Hp,
  rootPlacementTop: Wp,
  rootPlacementTopWithTimezoneSelector: Mp,
  rootPlacementBottom: zp,
  fields: Vp,
  input: Kp,
  alert: Up
};
Array(24).fill(0).map((i, e) => e);
class Zs extends k {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      startDateInputValue: this.props.startDate?.format(t) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(t) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Zs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncStartDateWithProps(e), this.syncEndDateWithProps(e), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: e, endDate: t } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: e,
      endDate: t
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(e) {
    const { endDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.endDate || t?.isSame(e.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(e) {
    const { startDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.startDate || t?.isSame(e.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(e, t) {
    const n = e.target.value;
    switch (t) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (e === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(e))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (t === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(t))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  getOverrides(e) {
    if (e !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(e, t, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: y } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(Ys, { children: e === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Xe,
        {
          className: qe.input,
          placeholder: c.toLowerCase(),
          name: `input__${e}__${this.instanceId}`,
          value: r,
          onChange: (C) => this.handleInputValueChange(C, e),
          onFocus: () => u(e),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === e
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: qe.input, children: /* @__PURE__ */ s.jsx(
        re,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            sn,
            {
              disabled: !n,
              overrides: this.getOverrides(t),
              selectedItems: o ? [o] : void 0,
              status: y ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (C) => p(t, C)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: e, endDateError: t, timeOrderError: n } = this.state;
    return e || t || n || null;
  }
  renderErrors() {
    const e = this.getError();
    return /* @__PURE__ */ s.jsx(
      Jn,
      {
        className: qe.alert,
        variant: e ? "error" : void 0,
        children: e
      }
    );
  }
  render() {
    const {
      startDate: e,
      startTime: t,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(qe.root, {
      [qe.rootPlacementTop]: u === "top",
      [qe.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [qe.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: qe.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          e,
          t,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const qp = "dateRangePickerTestId";
class Gp extends k {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const {
      startDate: t,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = e;
    this.state = {
      startTime: t ? j(t).format(Pe) : null,
      endTime: n ? j(n).format(Pe) : null,
      timezone: jt(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey(e), this.updateTimezoneFromProps(e), this.updatePresetKey(e);
  }
  visibleCalendarMonthRef = B();
  updatePresetKey(e) {
    const { presetKey: t } = this.props;
    e.presetKey !== t && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === t)?.key ?? null
    });
  }
  updateTimezoneFromProps(e) {
    const { timezone: t } = this.props;
    e.timezone !== t && jt(t) && this.setState({ timezone: t });
  }
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props, n = this.dateFormat;
    return {
      minDate: t ? j(t, n) : j("0001-01-01"),
      maxDate: e ? j(e, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { startDate: t, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: e },
      () => this.onDatesChange({ startDate: t, endDate: n }, o)
    );
  }
  onStartDateChange(e) {
    this.onDatesChange({ startDate: e, endDate: this.props.endDate });
  }
  onEndDateChange(e) {
    this.onDatesChange({ endDate: e, startDate: this.props.startDate });
  }
  onDatesChange(e, t = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      e.startDate,
      r
    ), c = this.addTimezoneToDate(
      e.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = e.startDate?.clone().startOf(a) || null, p = e.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          startTime: e.startDate?.clone().startOf(a).format(Pe) ?? null,
          endTime: e.endDate?.clone().startOf(a).format(Pe) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      e.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(e.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    if (!e)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: t, endDate: n, key: o } = e;
      this.onDatesChange({ startDate: t, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(e, t) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [e]: t
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return jt(t) ? e.clone().tz(t, !0) : e.clone().startOf(n);
  }
  handleFocusChange(e) {
    this.setState({ focusedInput: e ?? "startDate" });
  }
  addTimeToDate(e, t, n) {
    if (!e)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = t.split(":");
    return !r || !a ? n === "startDate" ? e.clone().startOf(o) : e.clone().endOf(o) : e.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: t } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !e.isBetween(n, o, t);
  }
  updateTimeOnDateChange({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(e) || this.setState({
      startTime: n ? j(n).format(Pe) : null
    }), o?.isSame(t) || this.setState({
      endTime: o ? j(o).format(Pe) : null
    });
  }
  recalculateDatePickerKey({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (t && e && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !t) && !(!o && t)) {
      if (o && !t) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && t) {
        if (o.isSame(t, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: e,
      endDate: t,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!e || !!t, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Mr,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(e) {
    const {
      withDateInput: t,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== e || !t && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: y } = this.state, { minDate: C, maxDate: w } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: C,
        maxDate: w,
        disabled: a,
        withDateInput: t,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: e,
        timeRoundingStrategy: m,
        focusedInput: y
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Hr,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": qp,
        className: f(Tt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              Cr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Or,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Br,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...t
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Yp = "h-datePicker-single-inputFields--datePickerInputFields__root", Qp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Xp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Zp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Jp = "h-datePicker-single-inputFields--datePickerInputFields__input", em = "h-datePicker-single-inputFields--datePickerInputFields__alert", it = {
  root: Yp,
  rootPlacementTop: Qp,
  rootPlacementTopWithTimezoneSelector: Xp,
  rootPlacementBottom: Zp,
  input: Jp,
  alert: em
};
class Js extends k {
  dateValidators;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      dateInputValue: this.props.date?.format(t) ?? "",
      dateError: null
    }, this.instanceId = Js.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncDateWithProps(e);
  }
  static instanceCount = 0;
  syncDateWithProps(e) {
    const { date: t, timeRoundingStrategy: n } = this.props, o = j(t);
    if (!(t === e.date || o?.isSame(j(e.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(e) {
    const t = this.ensureValidChars(e.target.value);
    this.setState({ dateInputValue: t }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: e } = this.state;
    if (e === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: t, error: n } = this.dateValidators.isSingleDateValid(e);
    if (!t) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(e))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: e, dateFormat: t, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Xe,
      {
        className: it.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: t.toLowerCase(),
        disabled: e,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: e,
      time: t,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !e && !r, d = !e || r;
    return /* @__PURE__ */ s.jsx(
      re,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: it.input, children: /* @__PURE__ */ s.jsx(
          sn,
          {
            disabled: d,
            onSelect: a,
            selectedItems: t ? [t] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: e } = this.state;
    return /* @__PURE__ */ s.jsx(
      Jn,
      {
        className: it.alert,
        variant: e ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: e, placement: t } = this.props, n = f(it.root, {
      [it.rootPlacementTop]: t === "top",
      [it.rootPlacementTopWithTimezoneSelector]: t === "top" && e,
      [it.rootPlacementBottom]: t === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const tm = "datePickerTestId";
class nm extends k {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const { date: t, timezone: n, presets: o, presetKey: r } = e;
    this.state = {
      time: t ? j(t).format(Pe) : null,
      timezone: jt(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = B();
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props;
    return {
      minDate: t || j("0001-01-01"),
      maxDate: e || j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { date: t } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: e }, () => this.onDateChange(t, n));
  }
  onDateChange(e, t = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(e, o);
    let l = a?.clone().startOf(r) || null, c = e?.clone().startOf(r) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          time: e?.clone().startOf(r).format(Pe) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(e, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    e ? this.onDateChange(e.date, e.key) : this.onDateChange(null);
  }
  handleTimeChange(e) {
    const { date: t } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: e
      }),
      () => this.onDateChange(t)
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return jt(t) ? j(e).clone().tz(t, !0) : e.clone().startOf(n);
  }
  addTimeToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = t.split(":");
    return !o || !r ? e.clone().startOf(n) : e.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    const { disabled: t, timeRoundingStrategy: n } = this.props;
    if (t)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !e.isBetween(o, r, n);
  }
  updateTimeOnDateChange(e) {
    const { date: t } = this.props;
    e.date?.isSame(t) || this.setState({
      time: t ? j(t).format(Pe) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: e } = this.props, t = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (t && e && !e.isSame(t, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: e, disabled: t, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!e, l = !a && !t, c = !a || t || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Mr,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(e) {
    const {
      dateFormat: t,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== e || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: y } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Js,
      {
        dateFormat: t,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: y,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: e,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Hr,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": tm,
        className: f(Tt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              Cr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Or,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Br,
                initialVisibleMonth: () => o || j(),
                onFocusChange: L,
                focused: !0,
                transitionDuration: 0,
                ...t
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const sm = "h-dialer--dialer__dialer", om = "h-dialer--dialer__number", rm = "h-dialer--dialer__letters", im = "h-dialer--dialer__asterisk", Bn = {
  dialer: sm,
  number: om,
  letters: rm,
  asterisk: im
}, am = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Bn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class tD extends k {
  render() {
    const { className: e, onInput: t, ...n } = this.props, o = f(Bn.dialer, e);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: am.map((r) => /* @__PURE__ */ Ki(
      "div",
      {
        className: f(Bn.number),
        ...Yn(() => t(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: Bn.letters, children: r.letters }) })
    )) });
  }
}
const lm = "h-fieldWrapper--fieldWrapper__root", cm = "h-fieldWrapper--fieldWrapper__rootDisabled", dm = "h-fieldWrapper--fieldWrapper__label", hm = "h-fieldWrapper--fieldWrapper__alert", wn = {
  root: lm,
  rootDisabled: cm,
  label: dm,
  alert: hm
}, um = "fieldWrapper";
class z extends k {
  static hasStatus(e, t) {
    return e?.[t] ? e?.touched === void 0 || e.touched === !0 : !1;
  }
  static getStatusMessage(e, t) {
    if (this.hasStatus(e, t))
      return e?.[t];
  }
  static getStatus(e) {
    return z.hasStatus(e, "error") ? "error" : z.hasStatus(e, "warning") ? "warning" : z.hasStatus(e, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: e, description: t } = this.props;
    let n = t, o;
    return z.hasStatus(e, "error") ? (n = z.getStatusMessage(e, "error"), o = "error") : z.hasStatus(e, "warning") ? (n = z.getStatusMessage(e, "warning"), o = "warning") : z.hasStatus(e, "success") && (n = z.getStatusMessage(e, "success"), o = "success"), /* @__PURE__ */ s.jsx(Jn, { variant: o, className: wn.alert, children: n });
  }
  render() {
    const {
      className: e,
      labelFor: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      wn.root,
      {
        [wn.rootDisabled]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": um,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            Ys,
            {
              required: r,
              htmlFor: t,
              helpIcon: l,
              className: wn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Rs extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Xe,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const pm = "h-dropdownSelect--dropdownSelectContainer__search", mm = "h-dropdownSelect--dropdownSelectContainer__pagination", gm = "h-dropdownSelect--dropdownSelectContainer__selectionActions", fm = "h-dropdownSelect--dropdownSelectContainer__extra", Sn = {
  search: pm,
  pagination: mm,
  selectionActions: gm,
  extra: fm
}, bm = "DROP_SEARCH_INPUT";
class zr extends me {
  listRef;
  searchRef;
  static getDerivedStateFromProps(e, t) {
    const { dropdownOpen: n } = e, o = { ...t };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(e) {
    super(e), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = B(), this.searchRef = B();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(e) {
    const { dropdownOpen: t } = this.props;
    !e.dropdownOpen && t && this.onOpen();
  }
  getInput() {
    const { searchValue: e } = this.state;
    return {
      name: bm,
      value: e,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(e) {
    const { key: t } = e, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (t === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "Home")
      e.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "End")
      e.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "Enter") {
      e.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(e) {
    const { key: t } = e, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (t === "Escape")
      o();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else t === "Home" ? (e.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : t === "End" && (e.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    typeof t == "function" && t(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(e) {
    const { onSelect: t, keepOpen: n, triggerClose: o } = this.props;
    typeof t == "function" && t(e), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(e, t) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(e, t), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: e } = this.props;
    e ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: e } = this.props;
    if (e && this.searchRef.current) {
      const t = this.searchRef.current.querySelector("input");
      t && t.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: e } = this.props, { searchValue: t } = this.state;
    t && (typeof e == "function" && e(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: e,
      itemComponent: t,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: y,
      triggerClose: C,
      dropdownOpen: w,
      emptyMessage: S,
      selectedItems: v,
      disabledItems: x,
      tooltipItems: _,
      activeItem: I,
      itemsDisplayCount: D,
      itemHeight: F,
      renderSuggestion: W,
      searchSuggestion: T,
      ...E
    } = this.props;
    if (!w)
      return null;
    const { searchValue: A, activeItemIndex: U } = this.state, ie = a.length === 0, ne = a[U] ?? I ?? a[0] ?? null, O = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...E, className: O, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Sn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Rs,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Sn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: A,
            onSuggest: m,
            triggerClose: h ? void 0 : C,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: T,
            renderSuggestion: W
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !ie && /* @__PURE__ */ s.jsx(
          Qs,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: v,
            disabledItems: x,
            itemComponent: t,
            tooltipItems: _,
            itemsDisplayCount: D,
            itemHeight: F,
            activeItem: ne
          }
        ),
        ie && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: S || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Sn.selectionActions, children: /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          disabled: v?.length === 0,
          onClick: b,
          children: y || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Sn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class eo extends k {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: e,
      items: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: y,
      dropdownProps: C,
      containerProps: w,
      pagination: S,
      emptyComponent: v,
      emptyMessage: x,
      selectedItems: _,
      disabledItems: I,
      tooltipItems: D,
      activeItem: F,
      itemsDisplayCount: W,
      itemHeight: T,
      optionComponent: E,
      renderSuggestion: A,
      searchSuggestion: U,
      ...ie
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      ut,
      {
        ...ie,
        className: e,
        buttonProps: { variant: "secondary", ...y },
        dropdownProps: C,
        dropdown: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: ne, dropdownOpen: O }) => /* @__PURE__ */ s.jsx(
          zr,
          {
            ...w,
            items: t,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: ne,
            dropdownOpen: O,
            pagination: S,
            emptyComponent: v,
            emptyMessage: x,
            selectedItems: _,
            disabledItems: I,
            tooltipItems: D,
            activeItem: F,
            itemsDisplayCount: W,
            itemHeight: T,
            optionComponent: E,
            renderSuggestion: A,
            searchSuggestion: U
          }
        ) }),
        children: b
      }
    );
  }
}
const ym = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", xm = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", _m = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", gs = {
  items: ym,
  moreItemsDropdown: xm,
  tagName: _m
};
class Cm extends me {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: e } = this.props;
    return e;
  }
  render() {
    const {
      items: e,
      itemComponent: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: y,
      optionComponent: C,
      ...w
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      eo,
      {
        ...w,
        containerProps: g,
        items: this.getItems(),
        itemComponent: t,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: y,
        optionComponent: C,
        children: b
      }
    );
  }
}
class nD extends me {
  static defaultProps = {
    MoreItemsItemComponent: Ru,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(e) {
    super(e), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(e) {
    if (typeof e == "object")
      return e;
    const t = this.props.items.find((n) => n.id === e);
    return t || { id: xr(), name: "Unknown" };
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  isItemDisabled(e) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(e.id) >= 0 : !1;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !t || Ws(t[e.id]) ? null : t[e.id];
  }
  getListItem(e, t) {
    const { onRemove: n } = this.props, o = this.resolveItem(e), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      Nt,
      {
        className: gs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(re, { ...a, children: l }, t) : l;
  }
  getListMoreItem(e) {
    const { MoreItemsItemComponent: t, onRemove: n } = this.props, o = this.resolveItem(e), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      t,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: L,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(re, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: e,
      previewItemsNumber: t,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (t && e) {
      if (e.length > 0 && e.length < t)
        o = e.map(this.getListItem);
      else if (e.length >= t) {
        const h = e.slice(0, t), u = e.slice(
          t,
          e.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = e.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(gs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      t && e.length > t ? /* @__PURE__ */ s.jsxs(
        ut,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: e,
      selectedItems: t,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: y,
      emptyMessage: C,
      containerProps: w,
      moreItemsDropdownProps: S,
      MoreItemsItemComponent: v,
      hideSelectedItems: x,
      disabledItems: _,
      tooltipItems: I,
      optionComponent: D,
      ...F
    } = this.props, W = f(
      {
        [gs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: W, children: [
      /* @__PURE__ */ s.jsx(
        Cm,
        {
          items: e,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: y,
          emptyMessage: C,
          containerProps: w,
          selectedItems: t,
          disabledItems: _,
          tooltipItems: I,
          optionComponent: D,
          ...F
        }
      ),
      !x && this.getPreviewItems()
    ] });
  }
}
const vm = "h-fieldButton--fieldButton__button", wm = {
  button: vm
}, sD = M(
  function({
    className: e,
    buttonClassName: t,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(t, wm.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          te,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), Sm = "h-inputDatePicker--inputDatePicker__root", Im = "h-inputDatePicker--inputDatePicker__inputContainer", km = "h-inputDatePicker--inputDatePicker__input", Dm = "h-inputDatePicker--inputDatePicker__rootReadOnly", Tm = "h-inputDatePicker--inputDatePicker__iconsContainer", jm = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", Nm = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", Fm = "h-inputDatePicker--inputDatePicker__calendarIcon", Pm = "h-inputDatePicker--inputDatePicker__clearIcon", Oe = {
  root: Sm,
  inputContainer: Im,
  input: km,
  rootReadOnly: Dm,
  iconsContainer: Tm,
  rootHasClearIcon: jm,
  rootHasWrapperIcon: Nm,
  calendarIcon: Fm,
  clearIcon: Pm
}, Rm = "inputDatePickerTestId";
class Em extends k {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(e) {
    super(e), this.inputRef = B(), this.rootRef = B(), this.datePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Rt(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(e) {
    const { onChange: t, value: n } = this.props;
    typeof t == "function" && t(e), (n ?? e !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: e } = this.props;
    e || this.showDropdown();
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: e }) {
    Qn(e) && this.showDropdown();
  }
  handleCalendarIconClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: e,
      name: t,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: y,
      readOnly: C,
      ...w
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ s.jsx(
      Me,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: S,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Oe.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...w,
              id: t,
              name: t,
              className: Oe.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Wn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Wn(n) ? void 0 : L,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Oe.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      q,
      {
        className: Oe.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon() {
    const { clearable: e, value: t, disabled: n } = this.props;
    return !e || !t ? null : /* @__PURE__ */ s.jsx(
      q,
      {
        className: Oe.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(nt, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      nm,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: e ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: t,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(Oe.root, e, {
      [Oe.rootHasClearIcon]: n && t,
      [Oe.rootHasWrapperIcon]: !!r,
      [Oe.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Rm,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class oD extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      date: e?.date ? e.date.toISOString() : "",
      localDate: e?.localDate ? e.localDate.toISOString() : "",
      timezone: e?.timezone || "",
      localTimezone: e?.localTimezone || ""
    });
  }
  render() {
    const {
      className: e,
      input: { value: t, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          Em,
          {
            name: n,
            value: Ps(t?.localDate) ? j(t.localDate, j.ISO_8601) : null,
            timezone: t?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Lm = "h-inputDateRangePicker--inputDateRangePicker__root", Am = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", $m = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Om = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Bm = "h-inputDateRangePicker--inputDateRangePicker__input", Hm = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", Wm = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Mm = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", zm = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Vm = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Km = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Um = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", qm = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Gm = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", he = {
  root: Lm,
  inputsContainer: Am,
  arrowContainer: $m,
  inputContainer: Om,
  input: Bm,
  rootReadOnly: Hm,
  iconsContainer: Wm,
  rootStartDateHasClearIcon: Mm,
  startDateIconsContainer: zm,
  rootEndDateHasClearIcon: Vm,
  endDateIconsContainer: Km,
  rootHasWrapperIcon: Um,
  calendarIcon: qm,
  clearIcon: Gm
}, Ym = "inputDateRangePickerTestId";
class on extends k {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(e, t) {
    return e[t] || `${e}__${t}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(e) {
    super(e), this.inputsRef = {
      startDate: B(),
      endDate: B()
    }, this.rootRef = B(), this.dateRangePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== t.isDropdownOpen || o !== t.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: e } = this.state, t = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    e === "startDate" ? t?.[0]?.focus() : t?.[1]?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Rt(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(e) {
    const { onChange: t, value: n } = this.props, { focusedInput: o } = this.state;
    typeof t == "function" && t(e), (n?.[o] ?? e[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(e, t) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: t === "startDate" ? null : n?.startDate ?? null,
      localStartDate: t === "startDate" ? null : n?.localStartDate ?? null,
      endDate: t === "endDate" ? null : n?.endDate ?? null,
      localEndDate: t === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(e) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: e,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(e, t) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(t);
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: e }, t) {
    Qn(e) && this.showDropdown(t);
  }
  handleInputClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  handleCalendarIconClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: e, suffix: t, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      Me,
      {
        prefix: e,
        suffix: t,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: he.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: he.arrowContainer, children: /* @__PURE__ */ s.jsx(P, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(e, t) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: y,
      readOnly: C,
      status: w,
      suffix: S,
      tabIndex: v,
      timezone: x,
      value: _,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: he.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: on.getInputName(m, e),
          name: on.getInputName(m, e),
          className: he.input,
          ref: this.inputsRef[e],
          onClick: (D) => this.handleInputClick(D, e),
          onFocus: (D) => this.handleInputFocus(D, e),
          onBlur: (D) => this.handleInputBlur(D),
          onKeyDown: (D) => this.handleInputKeydown(D, e),
          disabled: l,
          placeholder: b?.[e] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: _ && j(_[e]).isValid() ? j(_[e]).format(this.dateFormat) : "",
          onChange: Wn(_) ? void 0 : L,
          tabIndex: t ?? v,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(he.iconsContainer, {
            [he.startDateIconsContainer]: e === "startDate",
            [he.endDateIconsContainer]: e === "endDate"
          }),
          children: [
            this.renderClearIcon(e),
            this.renderCalendarIcon(e)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(e) {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      q,
      {
        className: he.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, e),
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon(e) {
    const { clearable: t, value: n, disabled: o } = this.props;
    return !t || !n?.[e] ? null : /* @__PURE__ */ s.jsx(
      q,
      {
        className: he.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, e)
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(nt, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Gp,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: e?.startDate ?? null,
        endDate: e?.endDate ?? null,
        timezone: o ?? null,
        minDate: t,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(he.root, e, {
      [he.rootStartDateHasClearIcon]: n && t?.startDate,
      [he.rootEndDateHasClearIcon]: n && t?.endDate,
      [he.rootHasWrapperIcon]: !!r,
      [he.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Ym,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class rD extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      startDate: e?.startDate ? e.startDate.toISOString() : "",
      localStartDate: e?.localStartDate ? e.localStartDate.toISOString() : "",
      endDate: e?.endDate ? e.endDate.toISOString() : "",
      localEndDate: e?.localEndDate ? e.localEndDate.toISOString() : "",
      timezone: e?.timezone ?? "",
      localTimezone: e?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: e,
    localEndDate: t
  }) {
    const n = Ps(e) ? j(e, j.ISO_8601) : null, o = Ps(t) ? j(t, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: e,
      input: { name: t, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: y } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: on.getInputName(t, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          on,
          {
            name: t,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: y,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Qm = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], dt = (i) => Ei(i), to = (i, e = window) => e.getComputedStyle(i).display === "block", Ze = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function fs(i, e) {
  const t = {
    ctrlKey: [
      "Control",
      ...Ze ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Ze ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Ze ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (e.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(t).every(
      ([r, a]) => {
        const l = Li(
          a,
          o
        ).length;
        return e[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Xm = (i, e, t) => {
  if (!i || e < 0 || t < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(e > n || t > n);
}, Zm = (i, e) => i.document.queryCommandState(e), Jm = (i) => i.document.queryCommandValue("formatBlock"), eg = (i) => i.type.indexOf("image/") === 0, Bo = (i, e) => {
  const t = nn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(e),
    uid: t
  };
}, tg = (i) => {
  i && i.querySelectorAll("td").forEach((e) => {
    e.style.border = "1px solid currentColor";
  });
}, Es = (i) => {
  i.setAttribute("dir", "auto");
  const e = window.getComputedStyle(i).direction;
  i.setAttribute("dir", e);
}, Ho = (i) => {
  i && i.childNodes.forEach((e) => {
    e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE || dt(e) && to(e) && Es(e);
  });
}, no = (i, e = !0) => {
  const t = document.createElement("div");
  return t.style.display = "none", t.innerHTML = i, document.body.appendChild(t), t.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (dt(n) && to(n))
        n.innerHTML = no(n.innerHTML, !1), Es(n);
      else if (e) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Es(o);
      }
    }
  }), document.body.removeChild(t), t.innerHTML;
}, Wo = (i, e = { side: "both" }) => {
  const { side: t } = e, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (t === "both" || t === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (t === "both" || t === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Kn = (i, e) => i.split(/\r\n|\r|\n/g).map((t, n) => t ? e.inline && n === 0 ? Wo(t, { side: "end" }) : `<div>${Wo(t)}</div>` : "<br />").join("");
function ng(i) {
  const e = "&nbsp;", o = sg(i.anchorNode), r = og(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(e)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(e, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && Xm(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function sg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const e = document.createElement("span");
  return e.appendChild(i.cloneNode()), e.innerHTML;
}
function og(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const rg = "h-inputRichText-addonTrigger--addonTrigger__root", ig = {
  root: rg
};
function ag(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e) || null;
}
const In = (i, e) => {
  const t = Vr(i, e);
  return t && i.triggers.isAddonTrigger(t.matchedTrigger) ? t.matchedTrigger : null;
}, kn = (i, e) => {
  const t = Vr(i, e);
  return t ? t.match : null;
}, Vr = (i, e) => e ? i.triggers.test(e) : null, Mo = "input-rich-text-addon-trigger", lg = (i, e) => {
  const t = i.selection.recreate({ focus: !1 });
  if (!t || !e) return null;
  const n = t.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0).getBoundingClientRect() : null;
}, cg = (i, e) => {
  if (i.ref.current && e) {
    const t = i.ref.current.getBoundingClientRect();
    return {
      left: `${e.x - t.x}px`,
      top: `${e.y - t.y}px`,
      height: "0",
      width: `${e.width}px`,
      position: "absolute"
    };
  }
  return {};
}, Ge = (i) => ag(i.selection.recreate({ focus: !1 })) || "", bs = (i, e) => !!e && i.triggers.isAddonTrigger(e), ys = (i) => i?.nodeType === Node.ELEMENT_NODE, Ls = (i, e) => i.dataset.testid === e ? i : i.parentElement ? Ls(i.parentElement, e) : null, _t = {};
class dg extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(e, t, n) {
    super.addEventListener(e, t, n), t && this.callbacks[e].push(t);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(e) {
    this.callbacks[e].forEach((t) => {
      this.removeEventListener(e, t);
    }), this.callbacks[e] = [];
  }
}
const kt = new dg(), hg = Ie({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: kt
});
var ug = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(ug || {});
const pg = (i) => {
  const { editor: e } = i, [t, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = cg(e, a), [u] = V(nn()), { dismissText: p } = _t[u] ?? { dismissText: "" }, m = t?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = N(() => {
    const _ = In(e, Ge(e)), I = kn(e, Ge(e)), D = lg(e, _);
    bs(e, _) && _?.shouldHandleSelectionChange?.() !== !1 ? (r(_), n(I), l(D)) : (r(null), n(null), l(null)), d(!0);
  }, [e]), y = N(() => {
    const _ = In(e, Ge(e)), I = kn(e, Ge(e))?.[0];
    return bs(e, _) && !!I;
  }, [e]), C = N(() => {
    const _ = In(e, Ge(e)), I = kn(e, Ge(e))?.[0], D = _t[u]?.dismissText || "", F = D ? I?.startsWith(D) : !1;
    return bs(e, _) && !!I && !F;
  }, [e, u]), w = N(() => {
    e.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: C,
        callback: () => {
          kt.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: C,
        callback: () => {
          kt.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: C,
        callback: () => {
          kt.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: C,
        callback: () => {
          kt.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: C,
        callback: (_, I) => {
          const D = kn(e, Ge(e))?.[0];
          if (!D) {
            _t[u] = {
              dismissText: ""
            };
            return;
          }
          In(e, Ge(e))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), _t[u] = {
            dismissText: (D.trim().length === 1 ? "" : D) ?? ""
          };
        }
      }
    ]);
  }, [e, C, u]);
  Z(() => {
    y() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (_t[u] = {
      dismissText: ""
    });
  }, [p, g, y, m, u, o]);
  const S = N((_) => {
    const I = _.nativeEvent.relatedTarget, D = ys(I) && Ls(I, Jr), F = ys(I) && Ls(I, Mo);
    (!ys(I) || !D && !F) && d(!1);
  }, []), v = N(
    (_, { inline: I } = {}) => {
      const D = e.selection.recreate();
      if (!D || !o)
        return;
      const W = !!D.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        no(
          Kn(_, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Kn(_, { inline: !0 })
      );
      D?.rangeCount && D?.rangeCount > 0 && e.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        D.getRangeAt(0).createContextualFragment(W),
        {
          getSelection: () => {
            const T = e.selection.recreate();
            if (!T)
              return null;
            const { focusOffset: E } = T, ie = o.trigger.exec(m)?.[1]?.length ?? 0, ne = m.length - ie, O = E - ne;
            if (T?.anchorNode && O >= 0)
              try {
                T.extend(T.anchorNode, O);
              } catch {
              }
            return T;
          }
        }
      );
    },
    [e, m, o]
  );
  if (ht(() => {
    w(), e.selection.onUpdate(b), e.events.onBlur(S);
  }), tt(() => {
    delete _t[u];
  }), !o || !c || !m || g)
    return null;
  const x = o.customContainer?.current || e.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(Ai, { open: !0, children: [
    /* @__PURE__ */ s.jsx($i, {}),
    /* @__PURE__ */ s.jsx(Oi, { container: x, children: /* @__PURE__ */ s.jsx(
      Bi,
      {
        onOpenAutoFocus: (_) => _.preventDefault(),
        "data-testid": Mo,
        className: ig.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          hg.Provider,
          {
            value: { matchText: m, insertContent: v, eventEmitter: kt },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, mg = "h-inputRichText-toolbarButton--toolbarButton__root", gg = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", fg = "h-inputRichText-toolbarButton--toolbarButton__rootActive", bg = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", yg = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", Ct = {
  root: mg,
  rootDisabled: gg,
  rootActive: fg,
  rootWithBadge: bg,
  rootWithText: yg
};
function Re({
  className: i,
  isActive: e,
  icon: t,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [Ct.root]: Ct.root,
      [Ct.rootActive]: e,
      [Ct.rootDisabled]: n,
      [Ct.rootWithBadge]: o,
      [Ct.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(P, { name: t }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(re, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const xg = "h-inputRichText-attachmentButton--attachmentButton__dropzone", _g = "h-inputRichText-attachmentButton--attachmentButton__fileInput", Cg = "h-inputRichText-attachmentButton--attachmentButton__dropdown", vg = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", Dn = {
  dropzone: xg,
  fileInput: _g,
  dropdown: Cg,
  dropzoneIcon: vg
};
let wg = class extends k {
  static displayName = "AttachmentButtonDropzone";
  constructor(e) {
    super(e), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowAttachments: t } = this.props;
    !t || !e.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && t(e.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(e), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          t,
          h && /* @__PURE__ */ s.jsx(et, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const Sg = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class Ig extends k {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(e) {
    super(e), this.fileInputRef = B(), this.unsubscribeAddAttachment = Zi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (e) => {
    e.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  handleFileChanged = (e) => {
    const { onAttachFiles: t, editorWindow: n } = this.props, o = e.target;
    o !== null && o instanceof n.HTMLInputElement && (t(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: e, attachments: t, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: Dn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        wg,
        {
          className: Dn.dropzone,
          onAddAttachment: n,
          attachments: t,
          isAttachmentsUploading: e,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(P, { name: "paperclip", className: Dn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  render() {
    const {
      className: e,
      attachments: t,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Re,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: t.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(re, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: Dn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        ut,
        {
          ...u,
          className: e,
          noStyle: !0,
          fixed: h,
          ref: a,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const kg = "h-inputRichText-dropzone--dropzone__root", Dg = "h-inputRichText-dropzone--dropzone__inlineDropzone", Tg = "h-inputRichText-dropzone--dropzone__attachmentDropzone", jg = "h-inputRichText-dropzone--dropzone__rootDual", Ng = "h-inputRichText-dropzone--dropzone__icon", vt = {
  root: kg,
  inlineDropzone: Dg,
  attachmentDropzone: Tg,
  rootDual: jg,
  icon: Ng
};
class Fg extends k {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(e) {
    super(e), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowInlineAttachments: t, allowAttachments: n } = this.props;
    if (!t && !n || this.internalDrag) return;
    const o = e.dataTransfer?.types, r = o?.includes("Files"), a = o?.includes("text/uri-list");
    !r && !a || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(e, t) {
    if (e.files.length > 0) {
      t(e.files);
      return;
    }
    const n = e.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), a = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], a, { type: r.type }), c = new DataTransfer();
        c.items.add(l), t(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (e) => {
    e.preventDefault();
    const { onAddInline: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [vt.root]: !0,
        [vt.rootDual]: n && o
      },
      e
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragStart = this.handleDragStart, g.onDragEnd = this.handleDragEnd, g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          t,
          (h || u) && /* @__PURE__ */ s.jsxs(et, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: vt.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(P, { name: "upload", size: 24, className: vt.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: vt.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(P, { name: "paperclip", size: 24, className: vt.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Kr = (i, e) => i.split(new RegExp(`(${Ms(e)})`, "gi")).map(
  (t, n) => t.toLowerCase() === e.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: t }, n) : t
), Pg = "h-inputRichText-emoji--emoji__root", Rg = "h-inputRichText-emoji--emoji__decorator", Eg = "h-inputRichText-emoji--emoji__suggestion", Lg = "h-inputRichText-emoji--emoji__suggestionActive", Ag = "h-inputRichText-emoji--emoji__suggestionName", Jt = {
  root: Pg,
  decorator: Rg,
  suggestion: Eg,
  suggestionActive: Lg,
  suggestionName: Ag
}, $g = Ui(
  () => import("./emoji-r0LV8WWJ.js").then((i) => i.k).then((i) => ({
    default: i.EmojiPicker
  }))
), Un = {};
Mi.emojis.forEach((i) => {
  i.forEach(
    (e) => {
      e.shortNames && e.shortNames.forEach((t) => {
        Un[t.replace(/:/g, "")] = e.emoji;
      });
    }
  );
});
const Og = (i) => {
  const { active: e, item: t, match: n, onSelect: o } = i, r = n ? Kr(t, n) : t;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(t),
      type: "button",
      "aria-current": e,
      className: f(Jt.suggestion, {
        [Jt.suggestionActive]: e
      }),
      children: [
        Un[t],
        /* @__PURE__ */ s.jsx("span", { className: Jt.suggestionName, children: r })
      ]
    }
  );
};
class Bg extends k {
  constructor(e) {
    super(e), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Og,
      insertContent: this.insertContent
    });
  }
  insertContent(e, t = "", n) {
    this.insertEmoji(Un[e], t, n);
  }
  insertEmoji(e, t, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Jt.decorator), r.innerHTML = e, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return t && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (e) => Object.keys(Un).filter((n) => n.indexOf(e) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(qi, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ s.jsx(
    $g,
    {
      onSelect: (t) => {
        this.insertEmoji(t), e();
      }
    }
  ) }) });
  render() {
    const { className: e, fixed: t } = this.props, n = f(
      {
        [Jt.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      ut,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: t,
        children: /* @__PURE__ */ s.jsx(
          Re,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const Hg = "h-inputRichText--inputRichText__inputWrapper", Wg = "h-inputRichText--inputRichText__root", Mg = "h-inputRichText--inputRichText__toolbar", zg = "h-inputRichText--inputRichText__toolbarHint", Vg = "h-inputRichText--inputRichText__toolbarHintVisible", Kg = "h-inputRichText--inputRichText__toolbarHintHidden", Ug = "h-inputRichText--inputRichText__editorWrap", qg = "h-inputRichText--inputRichText__placeholder", Gg = "h-inputRichText--inputRichText__editor", Yg = "h-inputRichText--inputRichText__editorDisabled", Qg = "h-inputRichText--inputRichText__fileInput", Xg = "h-inputRichText--inputRichText__uiBlocker", ge = {
  inputWrapper: Hg,
  root: Wg,
  toolbar: Mg,
  toolbarHint: zg,
  toolbarHintVisible: Vg,
  toolbarHintHidden: Kg,
  editorWrap: Ug,
  placeholder: qg,
  editor: Gg,
  editorDisabled: Yg,
  fileInput: Qg,
  uiBlocker: Xg
};
function Ur(i, e) {
  const t = (n) => n.replace(/&/g, "&amp;");
  return `<a href="${t(i)}">${t(e)}</a>`;
}
function so(i) {
  if (!i || i.length === 0)
    return "";
  const [e = [], t = ""] = i[0];
  if (!t)
    return "";
  const n = e.map((r) => Zg(r)).filter(Boolean), o = Jg(t);
  return Ze ? [...n, o].join("") : [...n, o].join("+");
}
function Zg(i) {
  if (Ze)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Jg(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Ze ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Ze ? "⌫" : "Backspace";
    case "Delete":
      return Ze ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const ef = "h-inputRichText-linkButton--linkButton__linkOpener", tf = "h-inputRichText-linkButton--linkButton__dropdownContainer", zo = {
  linkOpener: ef,
  dropdownContainer: tf
}, nf = "h-inputRichText-linkButton--linkMenu__root", sf = "h-inputRichText-linkButton--linkMenu__field", xs = {
  root: nf,
  field: sf
};
class of extends k {
  constructor(e) {
    super(e);
    const { initialText: t, initialUrl: n } = e;
    this.state = {
      textValue: t,
      urlValue: n
    };
  }
  componentDidUpdate(e) {
    const { initialText: t, initialUrl: n } = this.props;
    (t !== e.initialText || n !== e.initialUrl) && this.setState({
      textValue: t,
      urlValue: n
    });
  }
  handleTextChange = (e) => {
    e && this.setState({
      textValue: e.target.value
    });
  };
  handleUrlChange = (e) => {
    e && this.setState({
      urlValue: e.target.value
    });
  };
  handleAddLink = (e) => {
    e?.preventDefault();
    const { onAddLink: t, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (t(o || void 0, r), n());
  };
  handleUnlink = (e) => {
    e.preventDefault();
    const { onUnlink: t, toggleDropdown: n } = this.props;
    t(), n();
  };
  handleKeyDown = (e) => {
    e.key === "Enter" && (e.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: e,
      initialText: t,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [xs.root]: !0 }, e);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Rs,
        {
          label: "Link title",
          noAlert: !0,
          className: xs.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Rs,
        {
          label: "Link URL",
          noAlert: !0,
          className: xs.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(H, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(te, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(te, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const qr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], rf = ({ editor: i }) => {
  const [e, t] = Gi((w) => w + 1, 0), [n, o] = Yi(!1), r = Q(null), a = Q(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Qi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  ht(() => {
    i.events.onMouseOver((w) => {
      m(w);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), tt(() => {
    a.current?.();
  });
  const p = () => {
    const w = i.selection.recreate();
    if (!w)
      return;
    const { anchorNode: S, focusNode: v } = w;
    if (S && v === S && S.parentElement?.nodeName === "A") {
      const { href: x, innerText: _ } = S.parentElement;
      u({
        selectedLink: x,
        selectedText: _
      });
    } else
      u({
        selectedLink: "",
        selectedText: w.toString()
      });
  }, m = N(
    (w) => {
      const { target: S } = w, { current: v } = i.ref;
      if (v && S && S instanceof HTMLAnchorElement) {
        const x = v.getBoundingClientRect(), _ = S.getBoundingClientRect();
        u({
          hoverLinkHref: S.getAttribute("href"),
          hoverLinkBounds: {
            top: _.top - x.top,
            left: _.left - x.left,
            width: _.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = N(() => {
    const w = i.selection.recreate();
    if (!w)
      return;
    const { anchorNode: S, focusNode: v } = w;
    if (S && S === v && S.parentElement?.nodeName === "A") {
      const x = document.createRange();
      x.selectNodeContents(S.parentElement), w.removeAllRanges(), w.addRange(x);
    }
  }, [i.selection]), b = N(
    (w, S) => {
      S && (g(), i.command.run("insertHTML", Ur(S, w || S)), t());
    },
    [i.command, g]
  ), y = N(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), C = N((w) => {
    w.preventDefault();
  }, []);
  return Ir(r, () => {
    o(!1);
  }), Sr("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(et, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: zo.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Re,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: C,
          onClick: () => o(),
          tooltip: `Insert link (${so(qr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(nt, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        of,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: y
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: zo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(P, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, af = "h-tabs--tabs__root", lf = "h-tabs--tabs__tabs", cf = "h-tabs--tabs__tab", df = "h-tabs--tabs__tabTop", hf = "h-tabs--tabs__tabTopActive", uf = "h-tabs--tabs__tabTopSelected", pf = "h-tabs--tabs__tabLeft", mf = "h-tabs--tabs__tabLeftActive", gf = "h-tabs--tabs__tabLeftSelected", ff = "h-tabs--tabs__tabBottom", bf = "h-tabs--tabs__tabBottomActive", yf = "h-tabs--tabs__tabBottomSelected", xf = "h-tabs--tabs__tabRight", _f = "h-tabs--tabs__tabRightActive", Cf = "h-tabs--tabs__tabRightSelected", vf = "h-tabs--tabs__tabDisabled", ae = {
  root: af,
  tabs: lf,
  tab: cf,
  tabTop: df,
  tabTopActive: hf,
  tabTopSelected: uf,
  tabLeft: pf,
  tabLeftActive: mf,
  tabLeftSelected: gf,
  tabBottom: ff,
  tabBottomActive: bf,
  tabBottomSelected: yf,
  tabRight: xf,
  tabRightActive: _f,
  tabRightSelected: Cf,
  tabDisabled: vf
}, wf = 13;
class Sf extends k {
  constructor(e) {
    super(e), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: e, onChange: t, disabled: n } = this.props;
    n || t(e);
  }
  handleOnKeyDown(e) {
    e.keyCode === wf && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: e,
      placement: t,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(ae.tab, n, {
      [ae.tabDisabled]: o,
      [ae.tabTop]: t === "top",
      [ae.tabRight]: t === "right",
      [ae.tabLeft]: t === "left",
      [ae.tabBottom]: t === "bottom",
      [ae.tabTopSelected]: t === "top" && e,
      [ae.tabRightSelected]: t === "right" && e,
      [ae.tabLeftSelected]: t === "left" && e,
      [ae.tabBottomSelected]: t === "bottom" && e,
      [ae.tabTopActive]: t === "top" && r,
      [ae.tabRightActive]: t === "right" && r,
      [ae.tabLeftActive]: t === "left" && r,
      [ae.tabBottomActive]: t === "bottom" && r
    });
    return a && (l = f(l, { [a]: e })), l;
  }
  render() {
    const { id: e, label: t, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(P, { name: n, className: "icon-vertical-fix" }),
          t,
          r
        ]
      },
      e
    );
  }
}
class oo extends k {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.containerRef = B(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: e,
    label: t,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Sf,
      {
        selected: e === l,
        className: u,
        selectedClassName: p,
        id: e,
        label: t,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: e === c,
        slotEnd: r,
        slotStart: a
      },
      e
    );
  }
  renderTabs() {
    const { tabs: e } = this.props;
    return e.map(this.renderTab);
  }
  render() {
    const {
      className: e,
      tabClassName: t,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(ae.root, e);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: ae.tabs, children: this.renderTabs() }) });
  }
}
const If = ln(oo, {
  fallback: null
}), kf = "h-inputRichText-quickResponseSelector--quickResponseItem__root", Df = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Tf = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Vt = {
  root: kf,
  rootActive: Df,
  name: Tf
};
class _s extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: e, onSelect: t, item: n } = this.props;
    e || t(n);
  }
  render() {
    const {
      className: e,
      item: t,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && t ? t : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [Vt.root]: Vt.root,
        [Vt.rootActive]: r
      },
      e
    ), m = u ? Kr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-3", className: Vt.name, children: m }),
          /* @__PURE__ */ s.jsx($.Paragraph, { variant: "4", className: Vt.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const jf = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", Nf = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", Ff = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", Pf = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", Rf = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Ef = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", wt = {
  container: jf,
  dropdownButtonContainer: Nf,
  tabbedDropdown: Ff,
  tabbedDropdownTabs: Pf,
  tabbedDropdownTabsContent: Rf,
  regularDropdown: Ef
}, Vo = /(^|\s)=/, Cs = "Quick replies";
class Lf extends me {
  constructor(e) {
    super(e), this.state = {
      searchTerm: "",
      selectedTab: e.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: Vo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: _s,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(e) {
    const { quickResponsesApi: t } = this.props;
    return {
      id: e.name,
      matched: t.params.search ?? "",
      ...e
    };
  }
  getTabDefinitions() {
    const { languages: e } = this.props;
    return e.map((t) => ({
      id: t.code,
      label: t.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: e } = this.props;
    return new Promise((t) => e.getItemsAsyncStatus === "loading" ? t(e.items.map(this.normalizeSuggestion)) : t(
      e.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  handleSelect = (e, t) => {
    this.insertContent(e)?.then(() => {
      t && t();
    });
  };
  insertContent = (e, t, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(e).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!t, h = d && !!c.anchorNode?.textContent?.match(
        `^${Vo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = no(
        Kn(r(l), { inline: !1 })
      ) : u = Kn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(e) {
    const { quickResponsesApi: t, languages: n } = this.props;
    e && (t.params.search !== "" || t.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: e } = this.props;
    return {
      nextEnable: e.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(e, t, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: e, locale: t }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(e) {
    this.setState({ searchTerm: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n);
    });
  }
  handleTabChange(e) {
    this.setState({ selectedTab: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Re,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: e, quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(re, { content: `${Cs} (=)`, children: /* @__PURE__ */ s.jsx(
      eo,
      {
        className: e,
        dropdownProps: {
          className: wt.regularDropdown
        },
        containerProps: { className: wt.container },
        items: t.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: _s,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: e } = this.props, { selectedTab: t } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: wt.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(re, { content: `${Cs} (=)`, children: /* @__PURE__ */ s.jsx(
      ut,
      {
        className: e,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: Cs },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: wt.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            oo,
            {
              className: wt.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: t,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: wt.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ dropdownOpen: t, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      zr,
      {
        dropdownOpen: t,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: e.items.map(this.normalizeSuggestion),
        itemComponent: _s,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: hn,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: e } = this.props;
    return e?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Af = "h-inputRichText-formatSelector--formatSelector__root", $f = "h-inputRichText-formatSelector--formatSelector__list", Of = "h-inputRichText-formatSelector--formatSelector__selector", Bf = "h-inputRichText-formatSelector--formatSelector__option", Hf = "h-inputRichText-formatSelector--formatSelector__optionActive", Wf = "h-inputRichText-formatSelector--formatSelector__button", St = {
  root: Af,
  list: $f,
  selector: Of,
  option: Bf,
  optionActive: Hf,
  button: Wf
}, As = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Ko = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Mf extends k {
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown() {
    const { editor: e } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ closeDropdown: t }) => /* @__PURE__ */ s.jsx("ul", { className: St.list, children: As.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(e)))
        return;
      const a = Ko[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(St.option, {
            [St.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: St.button,
              onClick: () => {
                n.callback?.(e), t();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(e) {
    const { formatBlock: t } = this.props;
    return !!(!t && e.default || e.tag === t || e.tag === `<${t.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return As.find(
      (e) => this.isActiveFormat(Ko[e.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: e, editor: t, formatBlock: n, ...o } = this.props, r = f(St.root, e);
    return /* @__PURE__ */ s.jsx(
      ut,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: St.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(P, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const zf = "h-inputRichText-stylingMenu--stylingMenu__menu", Vf = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Uo = {
  menu: zf,
  buttonsContainer: Vf
}, Gr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (i) => {
      const e = i.window.getSelection();
      if (!e) return;
      const t = e.anchorNode, o = !!(dt(t) ? t : t?.parentElement)?.closest("blockquote");
      i.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (i) => i.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], Yr = [...As, ...Gr];
class Kf extends k {
  domRef;
  constructor(e) {
    super(e), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = B(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(e, t) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== t.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: e } = this.state, { editorWindow: t } = this.props;
    e && t.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: e } = this.props;
    this.setState({
      currentFormat: Jm(e)
    });
  }
  handleClickOutside = (e) => {
    const { current: t } = this.domRef;
    t && e.target instanceof Element && e.target !== t && !t.contains(e.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (e) => {
    e.preventDefault();
    const { isOpen: t } = this.state;
    this.setState({
      isOpen: !t
    });
  };
  handleToolbarButtonClick(e) {
    return (t) => {
      const { editor: n } = this.props;
      t.preventDefault(), e && (Yr.find(
        (r) => r.name === e
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(e) {
    const { editor: t } = this.props;
    if (e === "blockquote") {
      const n = t.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(dt(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return t.command.active(e);
  }
  render() {
    const { className: e, isActive: t, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: Uo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Mf,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Uo.buttonsContainer, children: Gr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = so(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Re,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Re,
        {
          isActive: t,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Uf = "h-inputRichText-suggestions--suggestions__dropdown", qf = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Gf = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Yf = "h-inputRichText-suggestions--suggestions__dropdownTabs", Qf = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Kt = {
  dropdown: Uf,
  dropdownWithTabs: qf,
  dropdownWithoutTabs: Gf,
  dropdownTabs: Yf,
  dropdownTabsContent: Qf
};
function Xf(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e);
}
class Zf extends k {
  dropdownRef;
  tabsRef;
  constructor(e) {
    super(e), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = B(), this.tabsRef = B(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(this.handleSelectionChange), e.events.onBlur(this.handleBlur), e.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (t, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(e, t) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== t.suggestionIndex && this.updateSuggestionScroll(), o !== t.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: e } = this.state;
    return e === "suggestion" && this.hasSuggestions() || e === "tab" && this.hasTabs();
  }
  handleArrowKey(e) {
    const { selectionMode: t } = this.state;
    t === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(e) : t === "tab" && this.hasTabs() && this.tabsNavigate(e);
  }
  handleEscapeKey(e) {
    const { selectionMode: t } = this.state;
    this.shouldRenderDropdown() && e.stopPropagation(), t === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: e, tabIndex: t, suggestionTrigger: n } = this.state;
    if (e === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (e === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[t];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(e) {
    const {
      nativeEvent: { relatedTarget: t }
    } = e;
    t === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: e } = this.state;
    return !!e?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: e, selectedTab: t } = this.state;
    return this.hasTabs() ? e?.getTabs?.().findIndex((n) => n.id === t) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(e) {
    this.setState(({ suggestionIndex: t, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return e < 0 ? o = t > 0 ? t - 1 : n.length - 1 : o = (t + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(e) {
    this.setState(({ tabIndex: t, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return e < 0 ? r = t > 0 ? t - 1 : o.length - 1 : r = (t + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(e, t) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = Xf(n.selection.recreate({ focus: !1 }));
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (e ? p = {
            selectionMode: "suggestion",
            selectedTab: e,
            tabIndex: -1
          } : o ? e = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            e || this.lookForTriggers();
          }), !e)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], e, t)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(e, t) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - e >= 0)
              try {
                r.extend(l, a - e);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                t(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(e, t, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(e[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(t.trigger).exec(e[0])?.[1]?.length ?? 0, u = e[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: t,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: e[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: e } = this.state, { current: t } = this.dropdownRef;
    if (t) {
      if (t.infiniteListRef.current)
        t.infiniteListRef.current.scrollToItem(e);
      else if (t.listRef.current) {
        const n = t.listRef.current, r = t.listRef.current.children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: e } = this.state, { current: t } = this.tabsRef;
    if (!(e < 0 || !t) && t.containerRef.current) {
      const n = t.containerRef.current, r = t.containerRef.current.children[0].children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: e,
      suggestionIndex: t,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!e || !e[t] || !o))
      return o.insertContent(
        e[t],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: e } = this.state;
    e && this.lookForTriggers();
  }
  handleSuggestionClick(e) {
    this.setState(
      (t) => ({
        suggestionIndex: t.suggestions ? t.suggestions.indexOf(e) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - e.bottom + e.height,
        left: e.x - n.x + e.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        left: `${e.x - n.x}px`,
        top: `${e.y - n.y + e.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: e.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: e } = this.state;
    if (!e || !e.getPagination)
      return !1;
    const t = e.getPagination();
    return !t || !t.onNext ? !1 : {
      ...t,
      onNext: () => t.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(e) {
    this.lookForTriggers(e, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(hn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: e, suggestionTrigger: t, selectedTab: n, tabIndex: o } = this.state, r = t?.getTabs?.() ?? [], a = !!e?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        oo,
        {
          ref: this.tabsRef,
          className: Kt.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Kt.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: e, suggestionIndex: t, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Qs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: e || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? e?.[t] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: e, selectedTab: t, suggestions: n } = this.state;
    return !(!e || !this.hasTabs() && !n?.length || this.hasTabs() && !t);
  }
  render() {
    const { editor: e, onError: t, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Kt.dropdown, {
      [Kt.dropdownWithTabs]: this.hasTabs(),
      [Kt.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(nt, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function Jf({ children: i, className: e }) {
  const t = Q(null), [n, o] = V(0), r = () => t.current ? Array.from(
    t.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === t.current) : [];
  Z(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!t.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return Z(() => {
    const l = t.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      className: e,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function qo(i) {
  return i instanceof RegExp ? i.source : i;
}
function eb(i) {
  return i.replace(/\(/g, "(?:");
}
class Qr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (e) => `(?!${qo(e.trigger)})`
    ).join("");
  }
  add(e) {
    this.storedTriggers.push(e);
  }
  update(e) {
    const t = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === e.id
    );
    t !== -1 && (this.storedTriggers[t] = e);
  }
  test(e) {
    let t;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = eb(
        qo(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (t = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(e), t && (!l || t[1].length >= l))
        return {
          match: t,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(e) {
    return "getSuggestions" in e;
  }
  isAddonTrigger(e) {
    return !this.isSuggestionTrigger(e);
  }
}
function Xr(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return !1;
  let n = t.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function tb(i, e) {
  e?.();
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  const n = t.getRangeAt(0);
  if (Xr(i)) {
    nb(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  t.removeAllRanges(), t.addRange(n);
}
function nb(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  let n = t.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === e) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), t.removeAllRanges(), t.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const Tn = 25;
let we = null, ct = null;
function sb(i, e) {
  const t = e.document.createElement("div");
  return t.className = `image-resize-handle image-resize-handle-${i}`, t.dataset.handle = i, t;
}
function ob(i, e) {
  const t = e.document.createElement("div");
  return t.className = "image-resize-wrapper", t.contentEditable = "false", i.parentNode?.insertBefore(t, i), t.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = sb(o, e);
    t.appendChild(r);
  }), t;
}
function Zr(i) {
  const e = i.querySelector("img");
  e && i.parentNode && (i.parentNode.insertBefore(e, i), i.remove());
}
function rb(i, e, t) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = e - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < Tn && (c = Tn, d = Tn / a);
  const h = Tn / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function ro(i) {
  if (!we) return;
  i.preventDefault(), i.stopPropagation();
  const { width: e } = rb(
    we,
    i.clientX,
    i.clientY
  );
  we.img.style.width = `${e}px`, we.img.style.height = "auto";
}
function io(i) {
  if (!we) return;
  i.preventDefault(), i.stopPropagation();
  const { img: e } = we, t = e.ownerDocument.defaultView;
  t.document.removeEventListener("mousemove", ro), t.document.removeEventListener("mouseup", io), we = null;
  const n = new Event("input", { bubbles: !0 });
  e.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function ib(i, e, t) {
  i.preventDefault(), i.stopPropagation();
  const n = e.ownerDocument.defaultView, o = e.closest(".image-resize-wrapper");
  if (!o) return;
  const r = e.naturalWidth, a = e.naturalHeight, l = r / a, c = e.getBoundingClientRect(), d = c.width, h = c.height;
  we = {
    img: e,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: t,
    wrapper: o
  }, n.document.addEventListener("mousemove", ro), n.document.addEventListener("mouseup", io);
}
function ab(i, e) {
  ct && (Zr(ct), ct = null);
  const t = ob(i, e);
  ct = t, t.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => ib(a, i, r)
    );
  });
}
function vs() {
  if (ct && (Zr(ct), ct = null), we) {
    const i = we.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", ro), i.document.removeEventListener("mouseup", io), we = null;
  }
}
function lb(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Go(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const Jr = "input-rich-text-editor", ei = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], Yo = [
  ...ei,
  ...Yr,
  ...qr,
  ...Sg
], cb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, db = Ie({
  command: {
    run: L,
    active: () => !1
  },
  content: {
    insert: L,
    setUiBlocker: L
  },
  hotkeys: {
    add: L,
    updateKeybindings: L
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: L
  },
  events: {
    subscribe: () => L,
    publish: L,
    onMouseOver: L,
    onBlur: L
  },
  allowFormatting: [],
  triggers: new Qr(),
  ref: B(),
  window,
  history: {
    canUndo: () => !1,
    undo: L,
    takeSnapshot: L,
    reset: L
  }
});
class ao extends k {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Re;
  /** Context containing props and methods to interact with the editor. */
  static Context = db;
  static contextType = qn;
  get effectiveWindow() {
    return this.context ?? window;
  }
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: L,
    sendOnEnter: !1,
    onMount: L,
    onUnmount: L,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(e) {
    super(e), this.editorRef = B(), this.currentSuggestionRef = B(), this.fileInputRef = B(), this.attachmentDropdownButtonRef = B(), this.unsubscribeInlineAttachment = L, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Yo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: e.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Qr(),
      ref: this.editorRef,
      window: this.effectiveWindow,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const e = this.effectiveWindow, { onMount: t } = this.props;
    e.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), t(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(e) {
    this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
    const { fileUploadStatuses: t, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    t && t !== e.fileUploadStatuses && a && (Object.keys(t).forEach((l) => {
      this.updateFileLoader(l, t[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== e.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), _r(e.keybindings, o) || this.updateKeyCommandsKeybindings(o), e.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: e } = this.props;
    this.unsubscribeInlineAttachment?.(), vs(), e(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: e } = this.props;
    return Yo.map((t) => ({
      ...t,
      keybindings: e && t.name ? e[t.name] ?? [] : t.keybindings
    }));
  }
  subscribe(e, t) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [e]: [...n.pubsub[e] ?? [], t]
      }
    })), () => {
      this.setState((n) => vr(n, e));
    };
  }
  publish(e) {
    this.state.pubsub[e]?.forEach((t) => t(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: e, onSelectionChange: t } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), e(a));
    }
    o.forEach((a) => {
      a();
    }), t && t();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (e) => {
    const { mouseOverListeners: t } = this.state;
    t.forEach((n) => {
      n(e);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (e) => {
    const t = e.target, n = this.effectiveWindow;
    if (dt(t) && t.tagName === "IMG") {
      e.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(t), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      ab(t, n);
    } else lb(t) || vs();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (e) => {
    const { blurListeners: t } = this.state;
    t.forEach(
      (n) => {
        n(e);
      }
    );
  };
  handleKeyDown = (e) => {
    if (e.getModifierState(e.key))
      return;
    const { keyCommands: t } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(e), t.some(
      ({ preventDefaultKeybinding: a }) => a && fs(a, e)
    ) && e.preventDefault(), t.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (fs(l, e) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, e), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(e), e.stopPropagation();
      return;
    }
    if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const a = this.effectiveWindow, l = a.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (dt(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = a.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const m = u.createRange();
        m.setStart(p, 0), m.collapse(!0), l.removeAllRanges(), l.addRange(m), this.setKeyDownHandled(e), this.handleSelectionChange();
        return;
      }
    }
    if (fs([[["$metaOrCtrl"], "Enter"]], e)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    } else if (e.key === "Enter" && n && !e.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    }
    return null;
  };
  getBlockLevelParent = (e) => {
    const t = this.effectiveWindow;
    let n = dt(e) ? e : e.parentElement;
    for (; !to(n, t); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (e) => {
    const { current: t } = this.editorRef, n = e?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Ho(t), tg(t);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: e } = this.state;
    e || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (e) => {
    e.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (e) => {
    this.setState(({ keyCommands: t }) => ({
      keyCommands: [...t, ...e]
    }));
  };
  updateKeyCommandsKeybindings = (e) => {
    if (!e)
      return;
    const { keyCommands: t } = this.state;
    Object.entries(e).forEach(([n, o]) => {
      const r = t.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (t[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(e) {
    this.setState(({ selectionUpdateListeners: t }) => ({
      selectionUpdateListeners: [...t, e]
    }));
  }
  addMouseOverListener(e) {
    this.setState(({ mouseOverListeners: t }) => ({
      mouseOverListeners: [...t, e]
    }));
  }
  addBlurListener(e) {
    this.setState(({ blurListeners: t }) => ({
      blurListeners: [...t, e]
    }));
  }
  handlePaste = (e) => {
    const { onFileDropped: t, allowInlineAttachments: n, sanitize: o } = this.props, r = this.effectiveWindow, { clipboardData: a } = e;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      e.preventDefault(), this.commandRun("insertHTML", o?.(l));
      return;
    }
    if (c && cb.test(c)) {
      e.preventDefault();
      const h = r.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = Ur(c, p), this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && t) {
        const { src: h, uid: u } = Bo(r, d);
        this.insertImageLoader(h, u), t(d, u);
      }
      e.preventDefault();
    }
  };
  commandRun(e, t = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, r = this.effectiveWindow;
      if (o) {
        if (n || this.recreateSelection(), e === "inlineCode") {
          tb(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          e,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          t
        );
      }
    });
  }
  commandActive(e) {
    const { hasFocus: t } = this.state, n = this.effectiveWindow;
    return e === "inlineCode" ? !!(t && Xr(n)) : !!(t && Zm(n, e));
  }
  getText = () => {
    const { current: e } = this.editorRef;
    return e && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: e } = this.editorRef, t = (
      // innerHTML of <div></div> should count as empty
      e && this.hasContent(this.extractEditorContent()) ? e.innerText : ""
    );
    return t ? t.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(e) {
    const { current: t } = this.editorRef, n = this.props.sanitize?.(e);
    t && (t.innerHTML = n || "", Ho(t)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (e) => {
    if (e === null) return;
    const { onFileDropped: t } = this.props, n = this.effectiveWindow;
    e && t && Array.from(e).forEach((r) => {
      if (eg(r)) {
        const { src: a, uid: l } = Bo(n, r);
        this.insertImageLoader(a, l), t(r, l);
      } else {
        const a = nn();
        this.insertFileLoader(r.name, a), t(r, a);
      }
    });
  };
  handleAttachmentUpload = (e) => {
    const { onAttachmentsFile: t } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), e && typeof t == "function" && Array.from(e).forEach((r) => {
      const a = nn();
      t(r, a);
    });
  };
  handleDetachAttachmentFile = (e) => {
    const { onDetachAttacmentFile: t } = this.props;
    typeof t == "function" && t(e);
  };
  handleFileSelect = (e) => {
    const t = e.target;
    t?.ownerDocument?.defaultView && t instanceof t.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(t.files), t.value = "");
  };
  openFileBrowser = (e) => {
    e?.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  insertImageLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("src", e), this.insertContent(o);
  }
  insertFileLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("href", "#"), o.innerText = e, this.insertContent(o);
  }
  updateFileLoader(e, { link: t, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${e}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), t && a.tagName === "IMG" && (a.src = t, o && (a.title = o)), t && a.tagName === "A" && (a.href = t)));
    }
  }
  handleToggleSendOnEnter = (e) => {
    e.preventDefault();
    const { onToggleSendOnEnter: t } = this.props;
    t();
  };
  handleToggleAutocompleteSuggestions = (e) => {
    e.preventDefault();
    const { autocomplete: t } = this.props;
    t && t.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(e) {
    const { anchorNode: t } = e;
    let { parentElement: n = null } = t || {};
    const o = `.${ge.editor}`;
    let r = t !== null && t.nodeType === Node.ELEMENT_NODE ? t.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (e, t) => {
    this.contentInsertionQueue.push(e), t?.getSelection ? this.processContentInsertionQueue(t.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (e) => {
    if (!e || !this.isSelectionWithinEditor(e)) {
      this.contentInsertionQueue = [];
      return;
    }
    if (ng(e), e?.rangeCount && e?.rangeCount > 0) {
      const t = e.getRangeAt(0);
      if (e.isCollapsed || t.deleteContents(), this.contentInsertionQueue.length === 1)
        t.insertNode(this.contentInsertionQueue[0]);
      else if (this.contentInsertionQueue.length > 1) {
        const n = document.createElement("span");
        this.contentInsertionQueue.forEach((o) => {
          n.appendChild(o);
        }), t.insertNode(n);
      }
    }
    this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
      e.collapseToEnd();
    }), this.handleSelectionChange();
  };
  setUiBlocker(e) {
    this.setState({ uiBlocker: e });
  }
  getSelectionRange() {
    const e = this.effectiveWindow;
    if (e.document.activeElement === this.editorRef.current) {
      const t = e.document.getSelection();
      return t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection(e) {
    const { current: t } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
    return t && (!r || !this.isSelectionWithinEditor(r)) && e?.focus !== !1 && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const e = this.effectiveWindow;
    this.setState({
      hasFocus: !0
    }), e.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (e) => {
    const t = this.effectiveWindow, n = t.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    vs(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), t.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(e);
  };
  focus = () => {
    const { current: e } = this.editorRef, { hasFocus: t } = this.state;
    e && (t || e.focus());
  };
  moveCursorToEnd = () => {
    const { current: e } = this.editorRef, t = this.effectiveWindow;
    if (!e) return;
    const n = t.getSelection();
    if (n) {
      const o = t.document.createRange();
      o.selectNodeContents(e), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(e) {
    return e?.length ? !e.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: e } = this.props;
    return Array.isArray(e) ? e : e ? Qm : [];
  }
  lastExtractedContent = B();
  extractEditorContent() {
    const { editorContentExtractor: e, sanitize: t } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!e)
      return Go(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = e(n);
    return this.lastExtractedContent.current = Go(
      t?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: e } = this.state;
    if (e.length > 0) {
      const t = e[e.length - 1];
      this.setHtml(t), this.setState({
        undoStack: e.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: e,
      wrapperClassName: t,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: y,
      languages: C,
      disabled: w,
      status: S,
      onError: v,
      icon: x,
      prefix: _,
      suffix: I,
      id: D,
      autocomplete: F,
      toolbarAddons: W
    } = this.props, { htmlOld: T, uiBlocker: E } = this.state, A = this.effectiveWindow, U = f(ge.root, e);
    return /* @__PURE__ */ s.jsx(ao.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Me,
      {
        status: S,
        icon: x,
        prefix: _,
        suffix: I,
        disabled: w,
        className: f(ge.inputWrapper, t),
        children: /* @__PURE__ */ s.jsxs("div", { className: U, children: [
          /* @__PURE__ */ s.jsxs(
            Fg,
            {
              className: ge.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: D,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(ge.editor, {
                      [ge.editorDisabled]: u
                    }),
                    "data-testid": Jr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(T) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: ge.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(Jf, { className: ge.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Kf,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: A
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(rf, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Re,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${so(ei[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              Ig,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: A,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(Bg, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              Lf,
              {
                languages: C,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            F && F.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Re,
              {
                isActive: F.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            W,
            !y && /* @__PURE__ */ s.jsx(
              Re,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            F ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(ge.toolbarHint, {
                  [ge.toolbarHintVisible]: this.state.showHint,
                  [ge.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  F.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: ge.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Zf, { editor: this.editor, onError: v }),
          /* @__PURE__ */ s.jsx(pg, { editor: this.editor }),
          E && /* @__PURE__ */ s.jsx("div", { className: ge.uiBlocker, children: E })
        ] })
      }
    ) });
  }
}
const hb = "h-textarea--textarea__inputWrapper", ub = "h-textarea--textarea__input", Qo = {
  inputWrapper: hb,
  input: ub
}, pb = "textarea", ti = M(function(e, t) {
  const n = Q(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = e, [y, C] = V(p), w = {
    ...m,
    height: y ? `${y}px` : void 0
  }, S = N(() => {
    if (!n.current)
      return;
    const v = n.current.clientHeight, x = window.getComputedStyle(n.current), _ = parseInt(x.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + _, D = Math.max(
      p,
      Math.min(v, I)
    ), F = I > D ? I : D;
    n.current.style.height = `${F}px`, C(F);
  }, [p]);
  return Z(() => {
    if (g)
      return S(), window.addEventListener("resize", S), () => {
        window.removeEventListener("resize", S);
      };
  }, [g, S]), /* @__PURE__ */ s.jsx(
    Me,
    {
      className: Qo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": pb,
          className: Qo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (v) => {
            b?.onChange?.(v), g && S();
          },
          ref: n,
          style: w,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), mb = "h-fieldRichText--fieldRichText__editorContainer", gb = "h-fieldRichText--fieldRichText__fallbackTextArea", Xo = {
  editorContainer: mb,
  fallbackTextArea: gb
};
class aD extends k {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Pt,
          {
            fallback: /* @__PURE__ */ s.jsx(
              ti,
              {
                ...t,
                className: Xo.fallbackTextArea,
                disabled: a,
                value: t.value,
                onChange: (p) => t.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Xo.editorContainer, children: /* @__PURE__ */ s.jsx(
              ao,
              {
                disabled: a,
                status: z.getStatus(o),
                ...t,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: L
              }
            ) })
          }
        )
      }
    );
  }
}
class lD extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: e },
      items: t
    } = this.props;
    return typeof e == "string" && t?.some((n) => n.id === e) ? [e] : Array.isArray(e) && e.length && t?.some((n) => e.some((o) => o === n.id)) ? e : [];
  }
  handleSelect(e) {
    const {
      input: { onChange: t }
    } = this.props;
    typeof t == "function" && t(e === null ? "" : e.id.toString());
  }
  handleClear() {
    const {
      input: { value: e },
      onClear: t
    } = this.props;
    typeof e == "string" && this.handleSelect(null), typeof t == "function" && t();
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: o,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Ft,
          {
            ...u,
            id: t.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function un(i, e) {
  const t = Vs(), n = Q(e);
  n.current = e, Z(() => {
    function o(r) {
      n.current?.(r);
    }
    return t.addEventListener(i, o), () => t.removeEventListener(i, o);
  }, [t, i]);
}
function ni(i, e = "") {
  return Ee.toArray(i).reduce((t, n) => Se(n) ? n.type === et ? [
    ...t,
    ...ni(n.props.children, n.key)
  ] : [...t, { ...n, key: `${e}${n.key}` }] : t, []);
}
const es = (i) => G(() => ni(i), [i]), fb = "h-selectionList--selectionList__root", bb = "h-selectionList--selectionList__disabled", Zo = {
  root: fb,
  disabled: bb
}, Lt = Hi(
  () => Ie({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: L,
      register: L,
      isSelected: () => !1,
      onSelect: L,
      isOnlyVisibleItem: !1
    }
  })
), lo = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [e, t] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = N(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: y,
      keysTakenOverHandlingFromParent: C
    }, w) => {
      g !== void 0 && a((S) => {
        const v = g ? [...S, w].sort((x, _) => x - _) : S.filter((x) => x !== w);
        return g && b && o((x) => (v.includes(w) && !S.includes(w) || w !== x) && v.includes(x) && w !== v[i] ? x : v[i] ?? v[0] ?? x), v;
      }), y !== void 0 && t(y), C !== void 0 && c((S) => ({
        ...S,
        [w]: C
      }));
    },
    [i]
  ), h = N(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = N(
    (g) => {
      o(h(g));
    },
    [h]
  );
  Z(() => {
    if (n < 0 || n === void 0) {
      o(r[i]);
      return;
    }
    r.length && !r.includes(n) && o(
      r[i] ?? r[0]
    );
  }, [n, r, i]);
  const p = G(
    () => l[n] ?? [],
    [n, l]
  );
  return G(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: e,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      e,
      p,
      u
    ]
  );
}, Jo = ({
  className: i,
  selectedValues: e = [],
  isActive: t,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = L,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!t, source: "parent" }), y = Lt(), {
    activeItemIndex: C,
    setActiveItem: w,
    handleItemRegister: S,
    isOnlyActiveItemVisible: v,
    keysDelegatedHandlingToItem: x
  } = lo({ defaultActiveItemIndex: c }), _ = es(d), I = N(
    (T) => T !== void 0 && (e || []).some(
      (E) => a(E, T)
    ),
    [a, e]
  ), D = N(
    ({ value: T, meta: E }, A) => {
      w({ index: A }), T !== void 0 && r(o ? {
        selectedValues: I(T) ? e.filter(
          (U) => !a(U, T)
        ) : [...e, T],
        selectedItem: {
          isNode: E?.isNode,
          isSelected: !I(T),
          value: T
        },
        event: E?.event
      } : {
        selectedValues: [T],
        selectedItem: {
          isNode: E?.isNode,
          isSelected: !0,
          value: T
        },
        event: E?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      e,
      w
    ]
  ), F = G(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), W = (T) => {
    !F || x.includes(T.key) || (T.key === "Enter" ? T.preventDefault() : T.key === "Home" ? (w({ step: "first" }), T.preventDefault()) : T.key === "End" ? (w({ step: "last" }), T.preventDefault()) : T.key === "ArrowDown" ? (w({ step: 1 }), T.preventDefault()) : T.key === "ArrowUp" && (w({ step: -1 }), T.preventDefault()));
  };
  return Z(() => {
    b({ isActive: !!t, source: "parent" });
  }, [t]), un("keydown", W), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || t ? -1 : l,
      ...h,
      className: f(i, Zo.root, {
        [Zo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: _.map(
        (T, E) => Se(T) && (!v || E === C) && /* @__PURE__ */ s.jsx(
          y.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: F && E === C,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), w({ index: E });
                },
                register: (A) => S(A, E),
                isSelected: I,
                onSelect: (A) => D(A, E),
                isOnlyVisibleItem: v,
                isLastChild: E === _.length - 1
              }
            },
            children: T
          },
          E
        )
      )
    }
  );
}, er = ({ className: i, label: e, ...t }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = We(Lt());
  return ht(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), tt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    Gn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...t,
      children: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "4", color: "secondary", children: e })
    }
  );
}, si = Object.assign(M(er), {
  name: er.name
}), yb = "h-selectionList-subComponents-item--selectionListItem__root", xb = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", _b = "h-selectionList-subComponents-item--selectionListItem__rootActive", Cb = "h-selectionList-subComponents-item--selectionListItem__selectionState", vb = "h-selectionList-subComponents-item--selectionListItem__fixedSize", wb = "h-selectionList-subComponents-item--selectionListItem__content", Sb = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", at = {
  root: yb,
  rootDisabled: xb,
  rootActive: _b,
  selectionState: Cb,
  fixedSize: vb,
  content: wb,
  contentDisabled: Sb
}, tr = ({
  value: i,
  isDisabled: e = !1,
  isIndeterminate: t = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: y,
      isSelected: C,
      onSelect: w,
      isActive: S,
      isNode: v = !1,
      isLastChild: x = !1,
      setActive: _
    }
  } = We(Lt()), I = C(i), D = G(
    () => !m && (g || b),
    [g, m, b]
  ), F = G(
    () => !e && S && D,
    [S, e, D]
  ), W = Q(null);
  an(
    u,
    () => W.current
  );
  const T = N(
    (O) => {
      !e && !m && (c?.({ value: i, meta: { target: O?.target } }), w({
        value: i,
        meta: {
          target: O?.target,
          event: O || void 0
        }
      }));
    },
    [e, m, c, w, i]
  ), E = N(
    (O) => {
      F && O.key === "Enter" && !e && !m && (c?.({
        value: i,
        meta: { target: O.target ?? void 0 }
      }), w({
        value: i,
        meta: { target: O.target ?? void 0, event: O }
      }));
    },
    [F, e, m, c, w, i]
  );
  Z(() => {
    S && D && W.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [S]);
  const A = N(
    () => ({
      isActive: S,
      isSelected: I,
      isLastChild: x,
      isNode: v,
      value: i
    }),
    [S, x, v, I, i]
  ), U = tn(S), ie = tn(I);
  Je(() => {
    S !== U && a?.(A()), I !== ie && l?.(A());
  }, [
    A,
    S,
    I,
    a,
    l,
    U,
    ie
  ]), un("keydown", E), Z(() => (y({ isActivatable: !e, isLastChild: x }), () => y({ isActivatable: !1, isLastChild: x })), [e]);
  const ne = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: W,
      role: "option",
      "aria-selected": I,
      "aria-disabled": e,
      onClick: T,
      onMouseMove: _,
      className: f(at.root, n, {
        [at.rootActive]: F,
        [at.rootDisabled]: e
      }),
      ...h,
      children: [
        ne && /* @__PURE__ */ s.jsxs(
          H,
          {
            className: f(at.selectionState, {
              [at.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(P, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: I,
                  indeterminate: !I && t,
                  disabled: e,
                  onChange: L,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          le,
          {
            className: f(at.content, o, {
              [at.contentDisabled]: e
            }),
            children: d
          }
        ),
        v && /* @__PURE__ */ s.jsx(P, { name: "angle-right" })
      ]
    }
  );
}, Ib = Object.assign(M(tr), {
  name: tr.name
}), kb = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", Db = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", nr = {
  root: kb,
  rootActive: Db
}, sr = ({
  className: i,
  content: e,
  onActiveStateChange: t,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = We(Lt()), m = G(
    () => !a && (l || c),
    [l, a, c]
  ), g = G(
    () => h && m,
    [h, m]
  ), b = Q(null);
  an(
    r,
    () => b.current
  );
  const y = N(() => {
    u({}), n?.();
  }, [u, n]), C = N(
    (S) => {
      !g || a || S.key === "Enter" && y();
    },
    [y, g, a]
  );
  Z(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const w = tn(h);
  return Je(() => {
    h !== w && t?.({ isActive: h });
  }, [h, t, w]), un("keydown", C), ht(() => {
    d({ isActivatable: !0 });
  }), tt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(nr.root, i, {
        [nr.rootActive]: g
      }),
      onClick: y,
      onMouseMove: p,
      ...o,
      children: e || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(P, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx($.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, oi = Object.assign(
  M(sr),
  {
    name: sr.name
  }
), Tb = "h-selectionList-subComponents-list--selectionListList__list", jb = {
  list: Tb
}, or = ({
  parentItem: i,
  children: e,
  backItemProps: t = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Lt(), d = We(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: y,
      setActive: C,
      isLastChild: w = !1
    }
  } = d, S = G(
    () => !p && (u || h),
    [u, p, h]
  ), v = es(e), {
    activeItemIndex: x,
    setActiveItem: _,
    handleItemRegister: I,
    isOnlyActiveItemVisible: D,
    keysDelegatedHandlingToItem: F
  } = lo({ defaultActiveItemIndex: 1 }), W = N(
    (O, se) => {
      _({ index: se }), g(O);
    },
    [g, _]
  ), T = (O) => {
    !S || !b || F.includes(O.key) || (O.key === "Home" ? (_({ step: "first" }), O.preventDefault()) : O.key === "End" ? (_({ step: "last" }), O.preventDefault()) : O.key === "ArrowDown" ? (_({ step: 1 }), O.preventDefault()) : O.key === "ArrowUp" && (_({ step: -1 }), O.preventDefault()));
  }, E = tn(
    b
  );
  Je(() => {
    b !== E && r?.({
      isActive: b,
      isLastChild: w
    });
  }, [
    b,
    r,
    E
  ]), Z(() => {
    y(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), un("keydown", T);
  const A = N(
    ({ value: O, meta: se }) => {
      se?.target instanceof HTMLInputElement && se.target.type === "checkbox" ? g({ value: O, meta: { isNode: !0 } }) : y({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), U = N(() => {
    y({ isOnlyVisibleItem: !1 });
  }, []);
  Z(() => {
    b || _({ index: -1 });
  }, [b, _]);
  const ie = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: A,
        isNode: !0
      }
    }),
    [A, d]
  ), ne = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: U,
        isActive: x === 0,
        setActive: () => {
          C(), _({ index: 0 });
        },
        register: (O) => I(O, 0)
      }
    }),
    [
      x,
      U,
      I,
      d,
      C,
      _
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !D && /* @__PURE__ */ s.jsx(c.Provider, { value: ne, children: /* @__PURE__ */ s.jsx(oi, { ...t }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(jb.list, n),
        ...o,
        children: v.map((O, se) => {
          const ke = se + 1;
          return Se(O) && (!D || ke === x) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && ke === x,
                  setActive: () => {
                    C(), _({ index: ke });
                  },
                  register: (De) => I(De, ke),
                  onSelect: (De) => W(De, ke),
                  isOnlyVisibleItem: D,
                  isLastChild: se === v.length - 1
                }
              },
              children: O
            },
            se
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: ie, children: i });
}, Nb = Object.assign(M(or), {
  name: or.name
}), Fb = "h-selectionList-subComponents-section--selectionListSection__section", Pb = {
  section: Fb
}, rr = ({
  title: i,
  children: e,
  listProps: { className: t, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Lt(), c = We(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: y = !1
    }
  } = c, C = G(
    () => !u && (h || d),
    [h, u, d]
  ), w = es(e), {
    activatableItemIndices: S,
    activeItemIndex: v,
    setActiveItem: x,
    handleItemRegister: _,
    keysDelegatedHandlingToItem: I
  } = lo(), D = N(
    (T, E) => {
      x({ index: E }), g(T);
    },
    [g, x]
  ), F = (T) => {
    !C || I.includes(T.key) || (T.key === "Home" ? x({ step: "first" }) : T.key === "End" && x({ step: "last" }), p ? T.key === "ArrowDown" && v !== S[S.length - 1] ? (x({ step: 1 }), T.preventDefault()) : T.key === "ArrowUp" && v !== S[0] && (x({ step: -1 }), T.preventDefault()) : T.key === "ArrowDown" ? x({ step: "first" }) : T.key === "ArrowUp" && x({ step: "last" }));
  }, W = tn(p);
  return Je(() => {
    p !== W && o?.({
      isActive: p,
      isLastChild: y
    });
  }, [p, o, W]), Z(() => {
    const T = [];
    p && (v !== S[S.length - 1] && T.push("ArrowDown"), v !== S[0] && T.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: T });
  }, [S, v, p]), ht(() => b({ isActivatable: !0 })), tt(() => b({ isActivatable: !1 })), un("keydown", F), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(Pb.section, t),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(si, { label: i }),
        w.map(
          (T, E) => Se(T) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && E === v,
                  setActive: () => {
                    m(), x({ index: E });
                  },
                  register: (A) => _(A, E),
                  onSelect: (A) => D(A, E),
                  isLastChild: y && E === w.length - 1
                }
              },
              children: T
            },
            E
          )
        )
      ]
    }
  ) });
}, Rb = Object.assign(M(rr), {
  name: rr.name
}), Eb = Object.assign(M(Jo), {
  name: Jo.name,
  Item: Ib,
  BackItem: oi,
  Divider: si,
  Section: Rb,
  List: Nb
}), Lb = "h-inputSelectionList-chip--inputSelectionListChip__root", Ab = "h-inputSelectionList-chip--inputSelectionListChip__name", ir = {
  root: Lb,
  name: Ab
}, ws = ({
  onDelete: i,
  className: e,
  disabled: t,
  readOnly: n,
  ...o
}) => {
  const r = G(() => {
    if (!(!i || t || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [t, i, n]);
  return /* @__PURE__ */ s.jsx(
    Nt,
    {
      ...o,
      onDelete: r,
      className: f(ir.root, e),
      tagNameClassName: ir.name
    }
  );
}, $b = "h-inputSelectionList--inputSelectionList__root", Ob = "h-inputSelectionList--inputSelectionList__inputWrapper", Bb = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Hb = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Wb = "h-inputSelectionList--inputSelectionList__rootReadOnly", Mb = "h-inputSelectionList--inputSelectionList__titleContainer", zb = "h-inputSelectionList--inputSelectionList__filterInput", Vb = "h-inputSelectionList--inputSelectionList__placeholder", Kb = "h-inputSelectionList--inputSelectionList__titleBox", Ub = "h-inputSelectionList--inputSelectionList__iconContainer", qb = "h-inputSelectionList--inputSelectionList__iconButton", Gb = "h-inputSelectionList--inputSelectionList__dropdown", Yb = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Qb = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", ce = {
  root: $b,
  inputWrapper: Ob,
  inputWrapperChild: Bb,
  rootHasWrapperIcon: Hb,
  rootReadOnly: Wb,
  titleContainer: Mb,
  filterInput: zb,
  placeholder: Vb,
  titleBox: Kb,
  iconContainer: Ub,
  iconButton: qb,
  dropdown: Gb,
  hiddenItemsTooltip: Yb,
  hiddenItemsChip: Qb
}, Xb = "inputSelectionListTestId", ar = ({
  className: i,
  name: e,
  value: t,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: y,
  onToggleDropdown: C,
  autoFocus: w,
  onClick: S,
  onBlur: v,
  onKeyDown: x,
  limit: _ = Number.POSITIVE_INFINITY,
  clearable: I = !1,
  equalityFn: D = Object.is,
  defaultActiveItemIndex: F,
  valueArrayToStringFn: W = JSON.stringify,
  rootClassName: T,
  dropdownProps: E,
  selectionListProps: A,
  slotBeforeList: U,
  slotAfterList: ie,
  ...ne
}, O) => {
  const se = Vs(), ke = Q(null), De = Q(null), pn = Q(null), co = Q(null), [K, ii] = V(!1), [ns] = V(() => !!w);
  an(
    O,
    () => De.current
  );
  const mn = G(
    () => p?.value !== void 0 && p.onChange !== void 0,
    [p]
  ), pt = G(() => mn ? K ? !0 : ns && (!!m || !t?.length) : !1, [mn, ns, K, m, t?.length]), ss = G(() => !pt || !K && t?.length ? !0 : m && !!t?.length, [K, m, pt, t?.length]), ai = G(() => {
    if (!t?.length)
      return c;
    if (ss)
      return "";
    if (!m) {
      const R = g(t[0]);
      return typeof R == "object" ? "" : R?.toString();
    }
    return "";
  }, [m, c, g, ss, t]), os = N(
    (R) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: R
        },
        selectedValues: t?.filter((Ae) => !D(Ae, R)) ?? []
      });
    },
    [d, D, n, h, t]
  ), li = G(() => {
    if (!t?.length)
      return /* @__PURE__ */ s.jsx(H, { alignItems: "center", className: ce.placeholder, children: c });
    if (m) {
      const R = _ < t.length ? t.slice(0, _) : t, Ae = _ < t.length ? t.slice(_) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        R?.map((Ot, rs) => /* @__PURE__ */ s.jsx(
          ws,
          {
            onDelete: () => {
              os(Ot);
            },
            disabled: d,
            readOnly: h,
            children: g(Ot)
          },
          rs
        )),
        !!Ae.length && /* @__PURE__ */ s.jsx(
          re,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              H,
              {
                className: ce.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Ae?.map((Ot, rs) => /* @__PURE__ */ s.jsx(
                  ws,
                  {
                    onDelete: () => {
                      os(Ot);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(Ot)
                  },
                  rs
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              ws,
              {
                className: ce.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Ae.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(le, { className: ce.titleBox, children: g(t[0]) });
  }, [
    t,
    m,
    g,
    c,
    _,
    d,
    h,
    os
  ]), oe = N(
    (R) => {
      (h || d) && R || (R !== K && C?.(R), ii(R));
    },
    [d, K, C, h]
  ), Le = N(() => {
    (pt ? pn.current : De.current)?.focus();
  }, [pt]), gn = N(
    (R) => {
      if (!mn || !R)
        return !1;
      const Ae = `${p?.value ?? ""}${R}`;
      return p?.onChange?.({
        target: { value: Ae, name: p?.name },
        currentTarget: { value: Ae, name: p?.name }
      }), oe(!0), !0;
    },
    [p, mn, oe]
  ), ci = N(
    (R) => {
      K || oe(!0), p?.onChange?.(R);
    },
    [p, K, oe]
  ), At = N(
    ({ target: R }) => {
      co.current?.contains(R) || (ke.current?.contains(R) && Le(), oe(!1));
    },
    [Le, oe]
  ), $t = N(
    (R) => {
      Rt(R.key) && K && (oe(!1), Le());
    },
    [Le, K, oe]
  ), di = N(
    (R) => {
      R.relatedTarget && ke.current?.contains(R.relatedTarget) || (oe(!1), v?.(R));
    },
    [v, oe]
  ), hi = N(
    (R) => {
      K || R.stopPropagation(), oe(!0), S?.(R);
    },
    [K, S, oe]
  ), ui = N(
    (R) => {
      if (R.key.length === 1 && R.key !== " " && !R.metaKey && !R.ctrlKey && !R.altKey && !K && R.target === De.current && gn(R.key)) {
        R.preventDefault(), x?.(R);
        return;
      }
      Qn(R.key) && oe(!0), x?.(R);
    },
    [K, x, gn, oe]
  ), pi = N(
    (R) => {
      K || R.target !== De.current || gn(R.clipboardData.getData("text").trim()) && R.preventDefault();
    },
    [K, gn]
  ), mi = N(
    (R) => {
      R.stopPropagation(), oe(!K), Le();
    },
    [Le, K, oe]
  ), gi = N(
    (R) => {
      R.stopPropagation(), Le(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, Le, n, h]
  ), fi = N(
    (R) => {
      n?.(R), !y && !m ? (oe(!1), De.current?.focus()) : pn.current?.focus();
    },
    [m, y, n, oe]
  );
  return Z(() => (K ? (se.addEventListener("click", At), se.addEventListener("keydown", $t)) : (se.removeEventListener("click", At), se.removeEventListener("keydown", $t)), () => {
    se.removeEventListener("click", At), se.removeEventListener("keydown", $t);
  }), [At, $t, K, se]), ht(() => {
    !ns || d || h || Le();
  }), Z(() => {
    K && pn.current?.focus();
  }, [K]), tt(() => {
    se.removeEventListener("click", At), se.removeEventListener("keydown", $t);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Xb,
      ref: ke,
      className: f(ce.root, T, {
        [ce.rootHasWrapperIcon]: !!a,
        [ce.rootReadOnly]: h
      }),
      "aria-expanded": K,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Me,
          {
            ...ne,
            ref: De,
            className: f(i, ce.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: K,
            status: l,
            onClick: hi,
            onBlur: di,
            onKeyDown: ui,
            onPaste: pi,
            tabIndex: d ? -1 : b ?? (pt ? -1 : 0),
            children: /* @__PURE__ */ s.jsxs(H, { className: ce.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(H, { gap: "100", flexWrap: "wrap", className: ce.titleContainer, children: [
                ss && li,
                pt && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: pn,
                    onChange: ci,
                    className: f(ce.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: ai,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(H, { alignItems: "center", className: ce.iconContainer, children: [
                I && !d && !h && !!t?.length && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    className: ce.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: gi,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  q,
                  {
                    className: ce.iconButton,
                    variant: "tertiary",
                    icon: K ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: mi,
                    "aria-label": K ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        e && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: e,
            value: W(t)
          }
        ),
        /* @__PURE__ */ s.jsx(
          nt,
          {
            isOpen: K,
            ...E,
            className: f(E?.className, ce.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: co, style: { width: "100%" }, children: K && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              U,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Eb,
                {
                  ...A,
                  equalityFn: D,
                  defaultActiveItemIndex: F,
                  isActive: K,
                  isMultiple: m,
                  selectedValues: t,
                  onChange: fi,
                  children: u
                }
              ),
              ie
            ] }) })
          }
        )
      ]
    }
  );
}, Zb = Object.assign(M(ar), {
  name: ar.name
}), cD = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Zb,
      {
        name: t,
        value: e || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Jb = "h-slider--slider__rootWrapper", ey = "h-slider--slider__rootWrapperNoAnnotations", ty = "h-slider--slider__root", ny = "h-slider--slider__rootDark", sy = "h-slider--slider__rootDisabled", oy = "h-slider--slider__handle", ry = "h-slider--slider__trackWrapper", iy = "h-slider--slider__track", ay = "h-slider--slider__highlight", ly = "h-slider--slider__minValueIndicator", cy = "h-slider--slider__maxValueIndicator", fe = {
  rootWrapper: Jb,
  rootWrapperNoAnnotations: ey,
  root: ty,
  rootDark: ny,
  rootDisabled: sy,
  handle: oy,
  trackWrapper: ry,
  track: iy,
  highlight: ay,
  minValueIndicator: ly,
  maxValueIndicator: cy
};
var Fe = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(Fe || {});
const dy = (i) => {
  i.preventDefault();
}, hy = (i, e, t) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "3", children: [
  e,
  i,
  t
] }) : /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "3", children: [
  e,
  i[0],
  t,
  " - ",
  e,
  i[1],
  t
] });
class uy extends k {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: hy,
    hideAnnotations: !1
  };
  constructor(e) {
    super(e), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = B();
  isInterval(e) {
    return Array.isArray(e);
  }
  handleChange(e) {
    typeof e == "number" ? this.props.onChange?.(Math.round(e)) : this.props.onChange?.(
      e.map((t) => Math.round(t))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(e) {
    e.target instanceof Element && this.setState({
      currentIndex: parseInt(
        e.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(e) {
    e.preventDefault();
    const { startVal: t, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = t + (e.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(e) {
    const { step: t = 1, value: n } = this.props;
    e.preventDefault();
    const o = this.isInterval(n) && e.target instanceof Element ? parseInt(e.target.getAttribute("data-index") || "", 10) : null;
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(t, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-t, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(e) {
    if (!this.sliderRef.current) return;
    const { value: t } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (e.clientX - o.left) / o.width;
    this.setState({
      startX: e.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(t)) {
      const l = n ?? this.findTheNearestHandle(r, t);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(e, t) {
    const [n, o] = t.map(
      this.absoluteValueToRelativeValue
    );
    return e > o && e > n ? 1 : e < o && e < n ? 0 : Math.abs(n - e) > Math.abs(o - e) ? 1 : 0;
  }
  getAdjustedStep(e) {
    const { min: t, max: n } = this.props;
    return e / (n - t);
  }
  getAbsoluteValue(e, t) {
    const { value: n, step: o } = this.props;
    let r = An(e, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    t === 0 && c > l ? c = l : t === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof t == "number" && (d[t] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(e) {
    const { min: t, max: n } = this.props, o = t + (n - t) * e;
    return An(o, t, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(e) {
    const { min: t, max: n } = this.props, o = (e - t) / (n - t);
    return An(o, 0, 1);
  }
  increment(e, t) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[t ?? 0] = r[t ?? 0] + e, o = r;
    } else
      o = n + e;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: e, min: t } = this.props, n = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[1]) - this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(e), o = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(t);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(e) {
    const { value: t } = this.props;
    return {
      left: `${(this.isInterval(t) ? this.absoluteValueToRelativeValue(t[e ?? 0]) : this.absoluteValueToRelativeValue(t)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: e } = this.props;
    if (xe(e)) return {};
    const [t, n] = e.map(this.absoluteValueToRelativeValue);
    return {
      left: `${t * 100}%`,
      width: `${(n - t) * 100}%`
    };
  }
  render() {
    const {
      className: e,
      value: t,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: y,
      ...C
    } = this.props, w = f(
      fe.root,
      { [fe.rootDark]: l },
      { [fe.rootDisabled]: c },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(fe.rootWrapper, {
          [fe.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...C,
              className: w,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: fe.trackWrapper,
                    "data-testid": Fe.TrackBackground,
                    children: [
                      !xe(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: fe.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Fe.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: fe.track,
                          style: this.getTrackStyles(),
                          "data-testid": Fe.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(t) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": t,
                    className: fe.handle,
                    onClick: dy,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Fe.Handle
                  }
                ),
                this.isInterval(t) && /* @__PURE__ */ s.jsxs(et, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: fe.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Fe.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: fe.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Fe.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Fe.LowBoundIndicator,
                    className: fe.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: fe.maxValueIndicator,
                    "data-testid": Fe.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs($.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Fe.Value, children: h(t, p, m) })
        ]
      }
    );
  }
}
const $s = ln(uy, {
  fallback: null
}), py = "h-fieldSlider--fieldSlider__root", my = {
  root: py
};
class dD extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(e) {
    const t = new Event("change");
    Object.defineProperty(t, "target", {
      writable: !0,
      value: { value: e, name: this.props.input.name }
    }), this.props.input.onChange(t);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(e) {
    const { input: t } = this.props, n = new FocusEvent(
      "blur",
      e
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: t.value, name: t.name }
    }), t.onBlur?.(n);
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(my.root, e);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          $s,
          {
            ...t,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const gy = "h-switch--switch__root", fy = "h-switch--switch__input", by = "h-switch--switch__inner", yy = "h-switch--switch__pending", xy = "h-switch--switch__active", Ut = {
  root: gy,
  input: fy,
  inner: by,
  pending: yy,
  active: xy
}, lr = {
  input: "Switch-input",
  label: "Switch-label"
};
class _y extends k {
  render() {
    const { id: e, className: t, variant: n, ...o } = this.props, r = e || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(t, Ut.root), "data-testid": e, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ut.input,
          "data-testid": lr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ut.inner, {
            [Ut.active]: n === "active",
            [Ut.pending]: n === "pending"
          }),
          "data-testid": lr.label
        }
      )
    ] });
  }
}
class hD extends k {
  render() {
    const { input: e, ...t } = this.props, { ref: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(_y, { ...o, ...t });
  }
}
class uD extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          ti,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const pD = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = N(
    (b) => {
      n(b ?? "");
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        sn,
        {
          selectedItems: t ? [t] : [],
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, mD = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = N(
    (b) => {
      n({
        startTime: b.startTime ?? "",
        endTime: b.endTime ?? ""
      });
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        Bp,
        {
          endTime: t.endTime,
          startTime: t.startTime,
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, Cy = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", vy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", wy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", Sy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", jn = {
  root: Cy,
  rootAlpha: vy,
  indicator: wy,
  indicatorNoColor: Sy
}, Iy = ({
  color: i,
  alpha: e,
  className: t,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(jn.root, t, {
      [jn.rootAlpha]: e
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(jn.indicator, {
          [jn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), ky = "h-inputColorPicker--inputColorPicker__root", Dy = "h-inputColorPicker--inputColorPicker__inputContainer", Ty = "h-inputColorPicker--inputColorPicker__input", jy = "h-inputColorPicker--inputColorPicker__rootReadOnly", Ny = "h-inputColorPicker--inputColorPicker__iconContainer", Fy = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", Py = "h-inputColorPicker--inputColorPicker__clearIcon", Ry = "h-inputColorPicker--inputColorPicker__colorIndicator", Ye = {
  root: ky,
  inputContainer: Dy,
  input: Ty,
  rootReadOnly: jy,
  iconContainer: Ny,
  rootHasWrapperIcon: Fy,
  clearIcon: Py,
  colorIndicator: Ry
}, Ey = "inputColorPickerTestId", Ly = M(function({
  className: e,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: a,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: m,
  readOnly: g,
  children: b,
  ...y
}, C) {
  const w = Q(null), S = Q(null), v = Q(null), [x, _] = V(!1);
  Z(() => {
    x ? (window.addEventListener("click", D), window.addEventListener("keydown", F)) : (window.removeEventListener("click", D), window.removeEventListener("keydown", F)), x && I();
  }, [x]), tt(() => {
    window.removeEventListener("click", D), window.removeEventListener("keydown", F);
  });
  const I = () => {
    v.current?.querySelector("input")?.focus();
  }, D = ({ target: U }) => {
    S.current?.contains(U) || _(!1);
  }, F = (U) => {
    Rt(U.key) && x && (U.stopPropagation(), _(!1));
  }, W = () => {
    g || _(!0);
  }, T = ({ target: U }) => {
    S.current?.contains(U) || _(!1);
  }, E = () => {
    g || _(!0);
  }, A = ({ key: U }) => {
    Qn(U) && _(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Ey,
      ref: S,
      className: f(Ye.root, e, {
        [Ye.rootHasWrapperIcon]: !!c,
        [Ye.rootReadOnly]: g
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Me,
          {
            prefix: a,
            suffix: l,
            disabled: u,
            icon: c,
            active: x,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: Ye.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...y,
                  id: t,
                  name: t,
                  className: Ye.input,
                  ref: w,
                  onClick: E,
                  onFocus: W,
                  onBlur: T,
                  onKeyDown: A,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: Wn(n) ? void 0 : L,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Ye.iconContainer, children: m && n && /* @__PURE__ */ s.jsx(
                q,
                {
                  className: Ye.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                Iy,
                {
                  className: Ye.colorIndicator,
                  onClick: E,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(nt, { ...r, isOpen: x, children: /* @__PURE__ */ s.jsx("div", { ref: v, children: /* @__PURE__ */ s.jsx(
          Xn,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? L,
            children: b
          }
        ) }) })
      ]
    }
  );
}), gD = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Ly,
      {
        name: t,
        value: e,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Ay = "h-fieldAddonDropdown--fieldAddonDropdown__root", $y = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Oy = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", By = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", Nn = {
  root: Ay,
  prefix: $y,
  suffix: Oy,
  angleDown: By
}, fD = ({
  className: i,
  noArrow: e,
  ...t
}) => Ws(t) ? null : /* @__PURE__ */ s.jsx(zi.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  eo,
  {
    ...vr(t, "meta"),
    noStyle: !0,
    itemComponent: Wr,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          Nn.root,
          {
            [Nn.prefix]: n === "prefix",
            [Nn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || t.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: t.meta.selectedValue }),
          !e && /* @__PURE__ */ s.jsx(
            P,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", Nn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Hy = "h-countryFlag--countryFlag__flag", Wy = "h-countryFlag--countryFlag__ad", My = "h-countryFlag--countryFlag__ae", zy = "h-countryFlag--countryFlag__af", Vy = "h-countryFlag--countryFlag__ag", Ky = "h-countryFlag--countryFlag__ai", Uy = "h-countryFlag--countryFlag__al", qy = "h-countryFlag--countryFlag__am", Gy = "h-countryFlag--countryFlag__ao", Yy = "h-countryFlag--countryFlag__aq", Qy = "h-countryFlag--countryFlag__ar", Xy = "h-countryFlag--countryFlag__as", Zy = "h-countryFlag--countryFlag__at", Jy = "h-countryFlag--countryFlag__au", ex = "h-countryFlag--countryFlag__aw", tx = "h-countryFlag--countryFlag__ax", nx = "h-countryFlag--countryFlag__az", sx = "h-countryFlag--countryFlag__ba", ox = "h-countryFlag--countryFlag__bb", rx = "h-countryFlag--countryFlag__bd", ix = "h-countryFlag--countryFlag__be", ax = "h-countryFlag--countryFlag__bf", lx = "h-countryFlag--countryFlag__bg", cx = "h-countryFlag--countryFlag__bh", dx = "h-countryFlag--countryFlag__bi", hx = "h-countryFlag--countryFlag__bj", ux = "h-countryFlag--countryFlag__bl", px = "h-countryFlag--countryFlag__bm", mx = "h-countryFlag--countryFlag__bn", gx = "h-countryFlag--countryFlag__bo", fx = "h-countryFlag--countryFlag__bq", bx = "h-countryFlag--countryFlag__br", yx = "h-countryFlag--countryFlag__bs", xx = "h-countryFlag--countryFlag__bt", _x = "h-countryFlag--countryFlag__bv", Cx = "h-countryFlag--countryFlag__bw", vx = "h-countryFlag--countryFlag__by", wx = "h-countryFlag--countryFlag__bz", Sx = "h-countryFlag--countryFlag__ca", Ix = "h-countryFlag--countryFlag__cd", kx = "h-countryFlag--countryFlag__cf", Dx = "h-countryFlag--countryFlag__cg", Tx = "h-countryFlag--countryFlag__ch", jx = "h-countryFlag--countryFlag__ci", Nx = "h-countryFlag--countryFlag__ck", Fx = "h-countryFlag--countryFlag__cl", Px = "h-countryFlag--countryFlag__cm", Rx = "h-countryFlag--countryFlag__cn", Ex = "h-countryFlag--countryFlag__co", Lx = "h-countryFlag--countryFlag__cp", Ax = "h-countryFlag--countryFlag__cr", $x = "h-countryFlag--countryFlag__cu", Ox = "h-countryFlag--countryFlag__cv", Bx = "h-countryFlag--countryFlag__cw", Hx = "h-countryFlag--countryFlag__cy", Wx = "h-countryFlag--countryFlag__cz", Mx = "h-countryFlag--countryFlag__de", zx = "h-countryFlag--countryFlag__dj", Vx = "h-countryFlag--countryFlag__dk", Kx = "h-countryFlag--countryFlag__dm", Ux = "h-countryFlag--countryFlag__dz", qx = "h-countryFlag--countryFlag__ec", Gx = "h-countryFlag--countryFlag__ee", Yx = "h-countryFlag--countryFlag__eg", Qx = "h-countryFlag--countryFlag__eh", Xx = "h-countryFlag--countryFlag__er", Zx = "h-countryFlag--countryFlag__es", Jx = "h-countryFlag--countryFlag__et", e_ = "h-countryFlag--countryFlag__eu", t_ = "h-countryFlag--countryFlag__fi", n_ = "h-countryFlag--countryFlag__fj", s_ = "h-countryFlag--countryFlag__fm", o_ = "h-countryFlag--countryFlag__fo", r_ = "h-countryFlag--countryFlag__fr", i_ = "h-countryFlag--countryFlag__ga", a_ = "h-countryFlag--countryFlag__gb", l_ = "h-countryFlag--countryFlag__gd", c_ = "h-countryFlag--countryFlag__ge", d_ = "h-countryFlag--countryFlag__gg", h_ = "h-countryFlag--countryFlag__gh", u_ = "h-countryFlag--countryFlag__gi", p_ = "h-countryFlag--countryFlag__gl", m_ = "h-countryFlag--countryFlag__gm", g_ = "h-countryFlag--countryFlag__gn", f_ = "h-countryFlag--countryFlag__gp", b_ = "h-countryFlag--countryFlag__gq", y_ = "h-countryFlag--countryFlag__gr", x_ = "h-countryFlag--countryFlag__gt", __ = "h-countryFlag--countryFlag__gu", C_ = "h-countryFlag--countryFlag__gw", v_ = "h-countryFlag--countryFlag__gy", w_ = "h-countryFlag--countryFlag__hk", S_ = "h-countryFlag--countryFlag__hn", I_ = "h-countryFlag--countryFlag__hr", k_ = "h-countryFlag--countryFlag__ht", D_ = "h-countryFlag--countryFlag__hu", T_ = "h-countryFlag--countryFlag__id", j_ = "h-countryFlag--countryFlag__ie", N_ = "h-countryFlag--countryFlag__il", F_ = "h-countryFlag--countryFlag__im", P_ = "h-countryFlag--countryFlag__iq", R_ = "h-countryFlag--countryFlag__ir", E_ = "h-countryFlag--countryFlag__is", L_ = "h-countryFlag--countryFlag__it", A_ = "h-countryFlag--countryFlag__je", $_ = "h-countryFlag--countryFlag__jm", O_ = "h-countryFlag--countryFlag__jo", B_ = "h-countryFlag--countryFlag__jp", H_ = "h-countryFlag--countryFlag__ke", W_ = "h-countryFlag--countryFlag__kg", M_ = "h-countryFlag--countryFlag__kh", z_ = "h-countryFlag--countryFlag__ki", V_ = "h-countryFlag--countryFlag__km", K_ = "h-countryFlag--countryFlag__kn", U_ = "h-countryFlag--countryFlag__kp", q_ = "h-countryFlag--countryFlag__kr", G_ = "h-countryFlag--countryFlag__kw", Y_ = "h-countryFlag--countryFlag__ky", Q_ = "h-countryFlag--countryFlag__kz", X_ = "h-countryFlag--countryFlag__la", Z_ = "h-countryFlag--countryFlag__lb", J_ = "h-countryFlag--countryFlag__lc", eC = "h-countryFlag--countryFlag__li", tC = "h-countryFlag--countryFlag__lk", nC = "h-countryFlag--countryFlag__lr", sC = "h-countryFlag--countryFlag__ls", oC = "h-countryFlag--countryFlag__lt", rC = "h-countryFlag--countryFlag__lu", iC = "h-countryFlag--countryFlag__lv", aC = "h-countryFlag--countryFlag__ly", lC = "h-countryFlag--countryFlag__ma", cC = "h-countryFlag--countryFlag__mc", dC = "h-countryFlag--countryFlag__md", hC = "h-countryFlag--countryFlag__me", uC = "h-countryFlag--countryFlag__mf", pC = "h-countryFlag--countryFlag__mg", mC = "h-countryFlag--countryFlag__mh", gC = "h-countryFlag--countryFlag__mk", fC = "h-countryFlag--countryFlag__ml", bC = "h-countryFlag--countryFlag__mm", yC = "h-countryFlag--countryFlag__mn", xC = "h-countryFlag--countryFlag__mo", _C = "h-countryFlag--countryFlag__mq", CC = "h-countryFlag--countryFlag__mr", vC = "h-countryFlag--countryFlag__ms", wC = "h-countryFlag--countryFlag__mt", SC = "h-countryFlag--countryFlag__mu", IC = "h-countryFlag--countryFlag__mv", kC = "h-countryFlag--countryFlag__mw", DC = "h-countryFlag--countryFlag__mx", TC = "h-countryFlag--countryFlag__my", jC = "h-countryFlag--countryFlag__mz", NC = "h-countryFlag--countryFlag__na", FC = "h-countryFlag--countryFlag__nc", PC = "h-countryFlag--countryFlag__ne", RC = "h-countryFlag--countryFlag__ng", EC = "h-countryFlag--countryFlag__ni", LC = "h-countryFlag--countryFlag__nl", AC = "h-countryFlag--countryFlag__no", $C = "h-countryFlag--countryFlag__np", OC = "h-countryFlag--countryFlag__nq", BC = "h-countryFlag--countryFlag__nr", HC = "h-countryFlag--countryFlag__nu", WC = "h-countryFlag--countryFlag__nz", MC = "h-countryFlag--countryFlag__om", zC = "h-countryFlag--countryFlag__pa", VC = "h-countryFlag--countryFlag__pe", KC = "h-countryFlag--countryFlag__pf", UC = "h-countryFlag--countryFlag__pg", qC = "h-countryFlag--countryFlag__ph", GC = "h-countryFlag--countryFlag__pk", YC = "h-countryFlag--countryFlag__pl", QC = "h-countryFlag--countryFlag__pr", XC = "h-countryFlag--countryFlag__ps", ZC = "h-countryFlag--countryFlag__pt", JC = "h-countryFlag--countryFlag__pw", ev = "h-countryFlag--countryFlag__py", tv = "h-countryFlag--countryFlag__qa", nv = "h-countryFlag--countryFlag__re", sv = "h-countryFlag--countryFlag__ro", ov = "h-countryFlag--countryFlag__rs", rv = "h-countryFlag--countryFlag__ru", iv = "h-countryFlag--countryFlag__rw", av = "h-countryFlag--countryFlag__sa", lv = "h-countryFlag--countryFlag__sb", cv = "h-countryFlag--countryFlag__sc", dv = "h-countryFlag--countryFlag__sd", hv = "h-countryFlag--countryFlag__se", uv = "h-countryFlag--countryFlag__sg", pv = "h-countryFlag--countryFlag__sh", mv = "h-countryFlag--countryFlag__si", gv = "h-countryFlag--countryFlag__sj", fv = "h-countryFlag--countryFlag__sk", bv = "h-countryFlag--countryFlag__sl", yv = "h-countryFlag--countryFlag__sm", xv = "h-countryFlag--countryFlag__sn", _v = "h-countryFlag--countryFlag__so", Cv = "h-countryFlag--countryFlag__sr", vv = "h-countryFlag--countryFlag__ss", wv = "h-countryFlag--countryFlag__st", Sv = "h-countryFlag--countryFlag__sv", Iv = "h-countryFlag--countryFlag__sx", kv = "h-countryFlag--countryFlag__sy", Dv = "h-countryFlag--countryFlag__sz", Tv = "h-countryFlag--countryFlag__tc", jv = "h-countryFlag--countryFlag__td", Nv = "h-countryFlag--countryFlag__tg", Fv = "h-countryFlag--countryFlag__th", Pv = "h-countryFlag--countryFlag__tj", Rv = "h-countryFlag--countryFlag__tl", Ev = "h-countryFlag--countryFlag__tm", Lv = "h-countryFlag--countryFlag__tn", Av = "h-countryFlag--countryFlag__to", $v = "h-countryFlag--countryFlag__tr", Ov = "h-countryFlag--countryFlag__tt", Bv = "h-countryFlag--countryFlag__tv", Hv = "h-countryFlag--countryFlag__tw", Wv = "h-countryFlag--countryFlag__tz", Mv = "h-countryFlag--countryFlag__ua", zv = "h-countryFlag--countryFlag__ug", Vv = "h-countryFlag--countryFlag__us", Kv = "h-countryFlag--countryFlag__uy", Uv = "h-countryFlag--countryFlag__uz", qv = "h-countryFlag--countryFlag__va", Gv = "h-countryFlag--countryFlag__vc", Yv = "h-countryFlag--countryFlag__ve", Qv = "h-countryFlag--countryFlag__vg", Xv = "h-countryFlag--countryFlag__vi", Zv = "h-countryFlag--countryFlag__vn", Jv = "h-countryFlag--countryFlag__vu", ew = "h-countryFlag--countryFlag__ws", tw = "h-countryFlag--countryFlag__ye", nw = "h-countryFlag--countryFlag__yt", sw = "h-countryFlag--countryFlag__za", ow = "h-countryFlag--countryFlag__zm", rw = "h-countryFlag--countryFlag__zw", cr = {
  flag: Hy,
  ad: Wy,
  ae: My,
  af: zy,
  ag: Vy,
  ai: Ky,
  al: Uy,
  am: qy,
  ao: Gy,
  aq: Yy,
  ar: Qy,
  as: Xy,
  at: Zy,
  au: Jy,
  aw: ex,
  ax: tx,
  az: nx,
  ba: sx,
  bb: ox,
  bd: rx,
  be: ix,
  bf: ax,
  bg: lx,
  bh: cx,
  bi: dx,
  bj: hx,
  bl: ux,
  bm: px,
  bn: mx,
  bo: gx,
  bq: fx,
  br: bx,
  bs: yx,
  bt: xx,
  bv: _x,
  bw: Cx,
  by: vx,
  bz: wx,
  ca: Sx,
  cd: Ix,
  cf: kx,
  cg: Dx,
  ch: Tx,
  ci: jx,
  ck: Nx,
  cl: Fx,
  cm: Px,
  cn: Rx,
  co: Ex,
  cp: Lx,
  cr: Ax,
  cu: $x,
  cv: Ox,
  cw: Bx,
  cy: Hx,
  cz: Wx,
  de: Mx,
  dj: zx,
  dk: Vx,
  dm: Kx,
  do: "h-countryFlag--countryFlag__do",
  dz: Ux,
  ec: qx,
  ee: Gx,
  eg: Yx,
  eh: Qx,
  er: Xx,
  es: Zx,
  et: Jx,
  eu: e_,
  fi: t_,
  fj: n_,
  fm: s_,
  fo: o_,
  fr: r_,
  ga: i_,
  gb: a_,
  gd: l_,
  ge: c_,
  gg: d_,
  gh: h_,
  gi: u_,
  gl: p_,
  gm: m_,
  gn: g_,
  gp: f_,
  gq: b_,
  gr: y_,
  gt: x_,
  gu: __,
  gw: C_,
  gy: v_,
  hk: w_,
  hn: S_,
  hr: I_,
  ht: k_,
  hu: D_,
  id: T_,
  ie: j_,
  il: N_,
  im: F_,
  in: "h-countryFlag--countryFlag__in",
  iq: P_,
  ir: R_,
  is: E_,
  it: L_,
  je: A_,
  jm: $_,
  jo: O_,
  jp: B_,
  ke: H_,
  kg: W_,
  kh: M_,
  ki: z_,
  km: V_,
  kn: K_,
  kp: U_,
  kr: q_,
  kw: G_,
  ky: Y_,
  kz: Q_,
  la: X_,
  lb: Z_,
  lc: J_,
  li: eC,
  lk: tC,
  lr: nC,
  ls: sC,
  lt: oC,
  lu: rC,
  lv: iC,
  ly: aC,
  ma: lC,
  mc: cC,
  md: dC,
  me: hC,
  mf: uC,
  mg: pC,
  mh: mC,
  mk: gC,
  ml: fC,
  mm: bC,
  mn: yC,
  mo: xC,
  mq: _C,
  mr: CC,
  ms: vC,
  mt: wC,
  mu: SC,
  mv: IC,
  mw: kC,
  mx: DC,
  my: TC,
  mz: jC,
  na: NC,
  nc: FC,
  ne: PC,
  ng: RC,
  ni: EC,
  nl: LC,
  no: AC,
  np: $C,
  nq: OC,
  nr: BC,
  nu: HC,
  nz: WC,
  om: MC,
  pa: zC,
  pe: VC,
  pf: KC,
  pg: UC,
  ph: qC,
  pk: GC,
  pl: YC,
  pr: QC,
  ps: XC,
  pt: ZC,
  pw: JC,
  py: ev,
  qa: tv,
  re: nv,
  ro: sv,
  rs: ov,
  ru: rv,
  rw: iv,
  sa: av,
  sb: lv,
  sc: cv,
  sd: dv,
  se: hv,
  sg: uv,
  sh: pv,
  si: mv,
  sj: gv,
  sk: fv,
  sl: bv,
  sm: yv,
  sn: xv,
  so: _v,
  sr: Cv,
  ss: vv,
  st: wv,
  sv: Sv,
  sx: Iv,
  sy: kv,
  sz: Dv,
  tc: Tv,
  td: jv,
  tg: Nv,
  th: Fv,
  tj: Pv,
  tl: Rv,
  tm: Ev,
  tn: Lv,
  to: Av,
  tr: $v,
  tt: Ov,
  tv: Bv,
  tw: Hv,
  tz: Wv,
  ua: Mv,
  ug: zv,
  us: Vv,
  uy: Kv,
  uz: Uv,
  va: qv,
  vc: Gv,
  ve: Yv,
  vg: Qv,
  vi: Xv,
  vn: Zv,
  vu: Jv,
  ws: ew,
  ye: tw,
  yt: nw,
  za: sw,
  zm: ow,
  zw: rw
}, iw = 127365, aw = /^[a-z]{2}$/, lw = (i) => aw.test(i) ? String.fromCodePoint(
  ...i.split("").map((e) => iw + e.charCodeAt(0))
) : "", bD = ({
  className: i,
  countryCode: e,
  size: t = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(le, { style: { width: t, height: t }, children: /* @__PURE__ */ s.jsx(
  le,
  {
    className: f(cr.flag, cr[e], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${t} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: t }, children: lw(e) }), yD = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], cw = "h-formGrid--formGrid__root", dw = {
  root: cw
}, hw = "formGridTestId", xD = M(function({ className: e, children: t, ...n }, o) {
  const r = f(dw.root, e);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": hw,
      className: r,
      ...n,
      ref: o,
      children: t
    }
  );
}), uw = "h-formGrid-field--formField__root", pw = "h-formGrid-field--formField__rootSpan5", mw = "h-formGrid-field--formField__rootSpan4", gw = "h-formGrid-field--formField__rootSpan3", fw = "h-formGrid-field--formField__rootSpan2", bw = "h-formGrid-field--formField__rootSpan1", Dt = {
  root: uw,
  rootSpan5: pw,
  rootSpan4: mw,
  rootSpan3: gw,
  rootSpan2: fw,
  rootSpan1: bw
}, yw = "formFieldTestId", xw = {
  1: Dt.rootSpan1,
  2: Dt.rootSpan2,
  3: Dt.rootSpan3,
  4: Dt.rootSpan4,
  5: Dt.rootSpan5,
  6: void 0
};
class _D extends k {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: e, className: t, children: n, ...o } = this.props, r = f(
      Dt.root,
      t,
      xw[e]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": yw, className: r, ...o, children: n });
  }
}
const _w = "h-helperField--helperField__root", Cw = "h-helperField--helperField__label", vw = "h-helperField--helperField__helpIcon", ww = "h-helperField--helperField__error", Sw = "h-helperField--helperField__rootRequired", qt = {
  root: _w,
  label: Cw,
  helpIcon: vw,
  error: ww,
  rootRequired: Sw
};
class CD extends k {
  render() {
    const {
      className: e,
      label: t,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [qt.root]: !0,
        [qt.rootRequired]: n
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!t && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: qt.label,
          htmlFor: a,
          id: `${a}-label`,
          children: t
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Gs,
        {
          ...c,
          className: f(qt.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: qt.error, children: r }),
      l
    ] });
  }
}
const Iw = "h-inputDuration--inputDuration__root", kw = {
  root: Iw
}, Ss = (i, e = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const t = Math.floor(i / 1e3), n = {};
  let o = t;
  return e.includes("days") && (n.days = Math.floor(t / (24 * 3600)), o = t % (24 * 3600)), e.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), e.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), e.includes("seconds") && (n.seconds = o), n;
}, Is = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, Dw = [
  "hours",
  "minutes",
  "seconds"
], vD = M(
  function(e, t) {
    const n = Q(null);
    an(t, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = Dw,
      status: u,
      onChange: p,
      onBlur: m
    } = e, [g, b] = V(
      () => Ss(a, h)
    );
    Z(() => {
      const v = Is(g);
      if (a !== v) {
        const x = Ss(a, h);
        b(x);
      }
    }, [a, h]);
    const y = N(
      (v, x) => {
        const _ = Math.max(0, parseInt(x) || 0);
        if ((v === "minutes" || v === "seconds") && _ > 60)
          return;
        const I = { ...g, [v]: _ };
        b(I);
        const D = Is(I);
        p?.(D);
      },
      [g, p]
    ), C = N(() => {
      const v = Is(g), x = Ss(
        v,
        h
      );
      b(x), m?.();
    }, [g, h, m]), w = (v) => {
      const x = g[v] ?? 0, _ = x === 0;
      return {
        type: "number",
        id: `${r}-${v}`,
        name: `${r}-${v}`,
        value: _ ? "" : x,
        placeholder: _ ? "0" : void 0,
        suffix: {
          type: "custom",
          value: v.charAt(0).toUpperCase() + v.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: C,
        onChange: (I) => y(v, I.target.value)
      };
    }, S = f(o, kw.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: S, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Xe, { ...w("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Xe, { ...w("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Xe, { ...w("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Xe, { ...w("seconds"), max: 60 })
    ] });
  }
), Gt = /* @__PURE__ */ new Map();
function Tw({
  containerId: i,
  children: e
}) {
  const [t, n] = V(null), o = (a) => {
    const l = Gt.get(i);
    l !== void 0 && Gt.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return Z(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Gt.set(i, 0)), n(a), o(1), () => {
      o(-1), Gt.get(i) === 0 && a && (Gt.delete(i), a.remove());
    };
  }, [i]), t ? Ji.createPortal(e, t) : null;
}
const jw = "h-modal--modal__root", Nw = "h-modal--modal__rootSkipAnimation", Fw = "h-modal--modal__modalContainer", Pw = "h-modal--modal__modalContent", Rw = "h-modal--modal__rootDisplayed", Ew = "h-modal--modal__rootOpened", Lw = "h-modal--modal__modal", Aw = "h-modal--modal__modalStacked", $w = "h-modal--modal__ghostPanel", Ow = "h-modal--modal__ghostLabel", Te = {
  root: jw,
  rootSkipAnimation: Nw,
  modalContainer: Fw,
  modalContent: Pw,
  rootDisplayed: Rw,
  rootOpened: Ew,
  modal: Lw,
  modalStacked: Aw,
  ghostPanel: $w,
  ghostLabel: Ow
}, Bw = Ie(!1);
class Hw extends k {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(e) {
    super(e), this.rootRef = B(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: e } = this.props;
    e && this.animateOpening();
  }
  componentDidUpdate(e) {
    const { isOpen: t, allowEscClose: n } = this.props, { isOpen: o } = e;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), t !== o && (t ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(e) {
    const { isOpen: t, onClose: n } = this.props;
    t && Rt(e.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (e.preventDefault(), e.stopPropagation(), this.animateClosing(), n(e)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: e } = this.rootRef;
    e && e.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: e } = this.props;
    e ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: e } = this.props;
    this.removeKeyDownEventListener(), e ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: e,
      isOpen: t,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(Te.root, c?.className, {
      [Te.rootDisplayed]: m,
      [Te.rootOpened]: g,
      [Te.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(Tw, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: Te.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          Dr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: Te.modalContent, children: /* @__PURE__ */ s.jsx(Bw.Consumer, { children: (y) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(Te.modal, e, {
                  [Te.modalStacked]: y
                }),
                onClick: (C) => r && C.stopPropagation(),
                children: [
                  y && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: Te.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: Te.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(P, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const Ww = "h-lightbox--lightbox__lightSource", Mw = "h-lightbox--lightbox__closeButton", zw = "h-lightbox--lightbox__downloadButton", Vw = "h-lightbox--lightbox__image", Kw = "h-lightbox--lightbox__loadingContainer", Uw = "h-lightbox--lightbox__navButton", qw = "h-lightbox--lightbox__navButtonPrevious", Gw = "h-lightbox--lightbox__navButtonNext", Yw = "h-lightbox--lightbox__counter", je = {
  lightSource: Ww,
  closeButton: Mw,
  downloadButton: zw,
  image: Vw,
  loadingContainer: Kw,
  navButton: Uw,
  navButtonPrevious: qw,
  navButtonNext: Gw,
  counter: Yw
};
class wD extends k {
  render() {
    const {
      className: e,
      src: t,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      Hw,
      {
        className: e,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: je.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: je.loadingContainer, children: /* @__PURE__ */ s.jsx(zs, { size: 64 }) }) : t && /* @__PURE__ */ s.jsx(Ks, { className: je.image, alt: n, src: t }),
          r && /* @__PURE__ */ s.jsx(
            q,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: je.closeButton
            }
          ),
          t && typeof t == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: t,
              target: "_blank",
              download: !0,
              className: je.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                P,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${je.navButton} ${je.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${je.navButton} ${je.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: je.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const Qw = "h-list-items--item__root", Xw = "h-list-items--item__rootWithHoverEffect", Zw = "h-list-items--item__rootDense", Jw = "h-list-items--item__rootLarge", eS = "h-list-items--item__contentLeft", tS = "h-list-items--item__contentRight", nS = "h-list-items--item__titles", sS = "h-list-items--item__title", oS = "h-list-items--item__titleSecondary", rS = "h-list-items--item__arrow", Ne = {
  root: Qw,
  rootWithHoverEffect: Xw,
  rootDense: Zw,
  rootLarge: Jw,
  contentLeft: eS,
  contentRight: tS,
  titles: nS,
  title: sS,
  titleSecondary: oS,
  arrow: rS
};
class ts extends k {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: e, titleSecondary: t } = this.props;
    return e || t ? /* @__PURE__ */ s.jsxs("div", { className: Ne.titles, children: [
      !!e && /* @__PURE__ */ s.jsx($.Paragraph, { as: "div", variant: "2", className: Ne.title, children: e }),
      !!t && /* @__PURE__ */ s.jsx(
        $.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Ne.titleSecondary,
          children: t
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Ne.contentLeft, children: e }) : null;
  }
  renderContentRight() {
    const { contentRight: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Ne.contentRight, children: e }) : null;
  }
  renderIcon() {
    const { isLink: e, contentRight: t } = this.props;
    return e && !t ? /* @__PURE__ */ s.jsx(
      P,
      {
        className: f(Ne.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(et, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: e,
      children: t,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Ne.root, e, {
      [Ne.rootDense]: d === "dense",
      [Ne.rootLarge]: d === "large",
      [Ne.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const iS = "h-list-items--keyValue__root", aS = {
  root: iS
};
class lS extends k {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: e, className: t, pair: n, ...o } = this.props, r = f(aS.root, t);
    return e && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ts,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx($.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const cS = "h-list-items--text__root", dS = {
  root: cS
};
class hS extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(dS.root, t);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx($.Paragraph, { variant: "2", children: e })
      }
    );
  }
}
const uS = "h-list-items--user__root", pS = "h-list-items--user__avatarWrapper", dr = {
  root: uS,
  avatarWrapper: pS
};
class mS extends k {
  getTitle() {
    const { user: e, title: t } = this.props;
    return t || e.display_name || e.name || e.phone_number || e.id;
  }
  getSubTitle() {
    const { user: e, titleSecondary: t } = this.props;
    return t || e.email;
  }
  render() {
    const { className: e, user: t, title: n, titleSecondary: o, ...r } = this.props, a = f(e, dr.root);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: dr.avatarWrapper, children: /* @__PURE__ */ s.jsx(kr, { user: t }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const gS = "h-list--list__root", fS = {
  root: gS
};
class bS extends k {
  static Item = ts;
  static Text = hS;
  static User = mS;
  static KeyValue = lS;
  render() {
    const { className: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...t, className: f(fS.root, e) });
  }
}
const SD = ln(bS, {
  fallback: null
}), yS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, xS = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, _S = (i) => document.fullscreenElement === i;
class CS extends Error {
  status;
  url;
  response;
  constructor(e) {
    super(`NetworkError ${e.status} ${e.url}`), this.status = e.status, this.url = e.url, this.response = e;
  }
}
const vS = {
  fetch: (i, ...e) => fetch(i, ...e).then((t) => {
    if (!(t.status >= 200 && t.status < 300))
      throw new CS(t);
    return t;
  })
}, wS = "h-mediaPlayer--mediaPlayer__root", SS = "h-mediaPlayer--mediaPlayer__controls", IS = "h-mediaPlayer--mediaPlayer__unstyled", kS = "h-mediaPlayer--mediaPlayer__rootFullScreen", DS = "h-mediaPlayer--mediaPlayer__rootHideControls", TS = "h-mediaPlayer--mediaPlayer__control", jS = "h-mediaPlayer--mediaPlayer__progress", NS = "h-mediaPlayer--mediaPlayer__progressSlider", FS = "h-mediaPlayer--mediaPlayer__volumeSlider", PS = "h-mediaPlayer--mediaPlayer__timestamp", RS = "h-mediaPlayer--mediaPlayer__videoWrapper", ES = "h-mediaPlayer--mediaPlayer__rootWaiting", LS = "h-mediaPlayer--mediaPlayer__rootAudio", AS = "h-mediaPlayer--mediaPlayer__video", $S = "h-mediaPlayer--mediaPlayer__volume", OS = "h-mediaPlayer--mediaPlayer__volumeMuteControl", BS = "h-mediaPlayer--mediaPlayer__downloadLink", J = {
  root: wS,
  controls: SS,
  unstyled: IS,
  rootFullScreen: kS,
  rootHideControls: DS,
  control: TS,
  progress: jS,
  progressSlider: NS,
  volumeSlider: FS,
  timestamp: PS,
  videoWrapper: RS,
  rootWaiting: ES,
  rootAudio: LS,
  video: AS,
  volume: $S,
  volumeMuteControl: OS,
  downloadLink: BS
};
function HS(i) {
  const e = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - e, e);
}
class ID extends k {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(e) {
    super(e), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: e } = this.props, { current: t } = this.playerRef;
    t && t.addEventListener("fullscreenchange", this.handleFullscreenChange), e ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(e, t) {
    const {
      mediaFile: { src: n }
    } = e, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(t);
  }
  componentWillUnmount() {
    const { current: e } = this.playerRef;
    e && e.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = B();
  playerRef = B();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: e },
      isPrivateFile: t
    } = this.props;
    this.tryStopPlayer(), t ? this.fetchFile() : this.setSrc(e);
  }
  setSrc(e) {
    this.setState({
      src: e
    });
  }
  handleIntersection([e]) {
    const { src: t, asyncStatus: n } = this.state;
    !t && !(n === "loading") && e.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: e } = this.playerRef;
    e && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(e));
  }
  tryStopPlayer() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    e.currentTime = 0;
    const { playing: t, actuallyPlaying: n } = this.state;
    t && n && (e.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(e) {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { src: n } = this.state;
    n !== e.src && t.load();
  }
  fetchFile(e) {
    const {
      mediaFile: { src: t },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    vS.fetch(t, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      e ? Wi.saveAs(
        a,
        o || decodeURIComponent(t.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: e } = this.videoRef;
    e && this.setState({
      time: e.currentTime,
      duration: e.duration
    });
  }
  updateBuffer() {
    const { current: e } = this.videoRef, { time: t, duration: n } = this.state;
    if (e) {
      let o = null;
      const r = e.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= t && t <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: e, actuallyPlaying: t } = this.state, { current: n } = this.videoRef;
    n && (e && t ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : e || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: e } = this.playerRef, t = _S(e);
    this.setState({
      isFullScreen: t
    }), t ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: e } = this.playerRef, { isFullScreen: t } = this.state;
    e && (t ? yS() : xS(e));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(e) {
    const { current: t } = this.videoRef, { duration: n } = this.state;
    t && e && !Number.isNaN(e) && (t.currentTime = n * e);
  }
  handleVolume = (e) => {
    const { current: t } = this.videoRef;
    !t || typeof e > "u" || !Number.isFinite(e) || this.setState({ volume: e }, () => {
      this.setPlayerVolume(e);
    });
  };
  handleMute() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { volume: t, prevVolume: n } = this.state, o = t === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : t
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(e) {
    const { current: t } = this.videoRef;
    t && (t.volume = e / 100);
  }
  render() {
    const {
      className: e,
      mediaFile: { type: t },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: y,
      buffer: C,
      asyncStatus: w
    } = this.state, S = a?.play ?? !0, v = a?.download ?? !0, x = a?.progress ?? !0, _ = a?.volume ?? !0, I = a?.maximize ?? !0, D = S || v || x || _ || I, F = typeof t == "string" && t.startsWith("audio"), W = !d || w === "loading", T = b ? "primary" : "secondary", E = f(
      J.root,
      {
        [J.rootFullScreen]: b,
        [J.rootHideControls]: g,
        [J.rootWaiting]: h && y,
        [J.rootAudio]: F
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: E,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: J.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: J.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          D && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(J.controls, {
                [J.unstyled]: l
              }),
              children: [
                S && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: J.control,
                    disabled: W,
                    icon: h ? "pause" : "play",
                    variant: T
                  }
                ),
                v && (o ? /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: T,
                    className: J.control,
                    disabled: W,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: J.downloadLink,
                        children: /* @__PURE__ */ s.jsx(P, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  q,
                  {
                    icon: "download",
                    variant: T,
                    className: J.control,
                    disabled: W,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                x && /* @__PURE__ */ s.jsxs("div", { className: J.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    $s,
                    {
                      hideAnnotations: !0,
                      className: J.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (A) => !Array.isArray(A) && this.seek(A / u),
                      dark: b,
                      highlightRange: C?.map((A) => A * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: J.timestamp, children: HS(u) })
                ] }),
                _ && /* @__PURE__ */ s.jsxs("div", { className: J.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    P,
                    {
                      className: J.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    $s,
                    {
                      hideAnnotations: !0,
                      className: J.volumeSlider,
                      value: m,
                      onChange: (A) => !Array.isArray(A) && this.handleVolume(A),
                      dark: b
                    }
                  )
                ] }),
                I && !F && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    variant: T,
                    onClick: this.handleFullscreenToggle,
                    className: J.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const WS = "h-modalBody--modalBody__root", MS = {
  root: WS
};
class kD extends k {
  render() {
    const { className: e, children: t, ...n } = this.props, o = f(
      {
        [MS.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: t });
  }
}
const zS = "h-modalFoot--modalFoot__root", VS = "h-modalFoot--modalFoot__confirm", KS = "h-modalFoot--modalFoot__confirmSecondary", US = "h-modalFoot--modalFoot__cancel", Fn = {
  root: zS,
  confirm: VS,
  confirmSecondary: KS,
  cancel: US
};
class qS extends k {
  static defaultProps;
  render() {
    const {
      className: e,
      confirmOnClick: t,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Fn.root]: !0
      },
      e
    ), g = f(
      {
        [Fn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Fn.confirm]: !0
      },
      c?.className
    ), y = f(
      {
        [Fn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          ...d,
          className: y,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      t && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: t,
          children: r
        }
      )
    ] });
  }
}
qS.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const GS = "h-modalHead--modalHead__root", YS = "h-modalHead--modalHead__top", QS = "h-modalHead--modalHead__title", XS = "h-modalHead--modalHead__buttons", ZS = "h-modalHead--modalHead__caption", Yt = {
  root: GS,
  top: YS,
  title: QS,
  buttons: XS,
  caption: ZS
}, DD = ({
  className: i,
  title: e,
  children: t,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: a,
  ...l
}) => {
  const c = f(
    {
      [Yt.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Yt.top, children: [
      /* @__PURE__ */ s.jsx($.Heading, { className: Yt.title, children: e }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Yt.buttons, r), children: [
        a,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(re, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          q,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          q,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ s.jsx(
      $.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Yt.caption,
        children: t
      }
    )
  ] });
}, JS = "h-page-body--pageBody__root", eI = {
  root: JS
}, tI = M(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    ue.Row,
    {
      ...n,
      ref: o,
      className: f(eI.root, t),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: e
    }
  );
}), nI = "h-page-head--pageHead__root", sI = {
  root: nI
}, oI = M(function({ className: e, title: t, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    ue.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(sI.root, e),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(ue.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-2", as: "h1", children: t }) }),
        n && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), rI = "h-page-section--pageSection__root", iI = "h-page-section--pageSection__head", aI = "h-page-section--pageSection__callout", lI = "h-page-section--pageSection__content", Pn = {
  root: rI,
  head: iI,
  callout: aI,
  content: lI
}, cI = M(function({
  children: e,
  className: t,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    ue.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Pn.root, t),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          ue.Row,
          {
            className: Pn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(H, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx($.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(ue.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          ue.Row,
          {
            className: Pn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          ue.Row,
          {
            className: Pn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: e
          }
        )
      ]
    }
  );
}), dI = M(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    ue.Row,
    {
      ...n,
      ref: o,
      className: t,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: e
    }
  );
}), hr = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx($c, { ...t, ref: n, as: "article", className: e, children: /* @__PURE__ */ s.jsx(ue, { children: i }) }), TD = Object.assign(M(hr), {
  name: hr.name,
  Head: oI,
  Body: tI,
  Section: cI,
  Tabs: dI
}), hI = "h-radio--radio__radio", uI = "h-radio--radio__radioDisabled", pI = "h-radio--radio__radioChecked", mI = "h-radio--radio__input", Rn = {
  radio: hI,
  radioDisabled: uI,
  radioChecked: pI,
  input: mI
}, jD = M(function(e, t) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = e, d = f(
    Rn.radio,
    { [Rn.radioChecked]: o },
    { [Rn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: t,
          id: h,
          onChange: c.onChange || L,
          checked: o,
          disabled: r,
          type: "radio",
          className: Rn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), gI = "h-reverseScroll--reverseScroll__root", fI = "h-reverseScroll--reverseScroll__column", bI = "h-reverseScroll--reverseScroll__row", yI = "h-reverseScroll--reverseScroll__scrollHandle", Qt = {
  root: gI,
  column: fI,
  row: bI,
  scrollHandle: yI
}, xI = "reverse-scroll", ND = M(function({
  children: e,
  className: t,
  direction: n = "column",
  ...o
}, r) {
  const a = Q(null), l = Q(null), c = Q(null), d = es(e), h = G(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return an(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": xI,
      ref: a,
      className: f(t, Qt.root, {
        [Qt.row]: n === "row",
        [Qt.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Qt.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Qt.scrollHandle })
      ]
    }
  );
}), _I = "h-removableCard--removableCard__root", CI = "h-removableCard--removableCard__close", vI = "h-removableCard--removableCard__title", wI = "h-removableCard--removableCard__titleIcon", Xt = {
  root: _I,
  close: CI,
  title: vI,
  titleIcon: wI
};
class FD extends k {
  render() {
    const { icon: e, title: t, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [Xt.root]: Xt.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      le,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            le,
            {
              as: "button",
              "aria-label": "Remove",
              className: Xt.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(P, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            H,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Xt.title,
              children: [
                e && /* @__PURE__ */ s.jsx(P, { name: e, className: Xt.titleIcon }),
                t
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(le, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const ur = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, SI = "h-sandboxIframe--sandboxIframe__frame", II = {
  frame: SI
};
class ri extends k {
  frameRef;
  static defaultProps;
  constructor(e) {
    super(e), this.state = {
      iframeHeight: 0
    }, this.frameRef = B(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(e) {
    const { content: t, headContent: n, colorMode: o } = this.props;
    (e.content !== t || e.headContent !== n || e.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: e, headContent: t = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      e.indexOf("</body>") !== -1 ? r = e.replace(
        "</body>",
        `${ur({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${t}</head><body>${e}${ur(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(e) {
    const { current: t } = this.frameRef;
    if (t && e.source === t.contentWindow) {
      const { data: n } = e;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: e,
      content: t,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, e);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? ri.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: II.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const kI = "h-scrollbar--scrollbar__track", DI = "h-scrollbar--scrollbar__handle", pr = {
  track: kI,
  handle: DI
};
class PD extends k {
  constructor(e) {
    super(e), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: e } = this.props;
    e.current && e.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: e } = this.props;
    e.current && e.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: e } = this.props;
    if (e.current) {
      const { current: t } = e;
      this.setState({
        size: t.offsetHeight / t.scrollHeight,
        progress: t.scrollTop / t.scrollHeight
      });
    }
  };
  handleTrackClick(e) {
    const { container: t } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), t.current) {
      const o = t.current.getBoundingClientRect();
      let r = (e.clientY - o.top) / t.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), t.current.scrollTop = r * t.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(e) {
    const { size: t } = this.state;
    if (e.stopPropagation(), !(e.target instanceof Element)) return;
    const n = e.target.getBoundingClientRect();
    this.setState({
      offset: (e.clientY - n.top) / n.height * t
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(e) {
    e.preventDefault();
    const { container: t } = this.props, { size: n, offset: o } = this.state;
    if (t.current) {
      const r = t.current.getBoundingClientRect();
      let a = (e.clientY - r.top) / t.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), t.current.scrollTop = a * t.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: e, thumbClassName: t, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(e);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(pr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(pr.handle, t),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const TI = "h-scrollShadow--scrollShadow__wrapper", jI = "h-scrollShadow--scrollShadow__content", mr = {
  wrapper: TI,
  content: jI
}, RD = ({
  className: i,
  children: e,
  ...t
}) => {
  const n = f(mr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...t, children: /* @__PURE__ */ s.jsx("div", { className: mr.content, children: e }) });
}, NI = "h-searchInput--searchInput__root", FI = "h-searchInput--searchInput__input", PI = "h-searchInput--searchInput__inputButton", En = {
  root: NI,
  input: FI,
  inputButton: PI
}, RI = 275, gr = 300, ED = ({
  className: i,
  initialSearch: e,
  maxWidth: t = RI,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = Q(null), [d, h] = V(!!e), [u, p] = V(!1), [m, g] = V(e ?? "");
  Xi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    gr,
    [u]
  ), Je(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = N(() => {
    h(!0);
  }, []), y = N(() => {
    p(!0);
  }, []), C = N(
    (x) => {
      x.preventDefault(), r(m);
    },
    [r, m]
  ), w = N(
    (x) => {
      const {
        target: { value: _ }
      } = x;
      g(_), o?.(_);
    },
    [o]
  ), S = N(
    ({ key: x }) => {
      x === "Enter" && b();
    },
    [b]
  ), v = N(
    ({ key: x }) => {
      (x === "Esc" || x === "Escape") && y();
    },
    [y]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(En.root, i),
      style: {
        "--max-width": `${d && !u ? t : 32}px`,
        "--transition-delay": `${gr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: C, children: /* @__PURE__ */ s.jsx(
        Xe,
        {
          className: En.input,
          ref: c,
          onChange: w,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: C,
              className: En.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: y,
              className: En.inputButton
            }
          },
          onKeyDown: v
        }
      ) }) : /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: S,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, EI = "h-selectOption--selectOption__root", LI = "h-selectOption--selectOption__checkbox", AI = "h-selectOption--selectOption__content", ks = {
  root: EI,
  checkbox: LI,
  content: AI
}, LD = (i) => {
  const e = f(ks.root);
  return /* @__PURE__ */ s.jsxs("label", { className: e, children: [
    /* @__PURE__ */ s.jsx(
      cn,
      {
        ...i,
        className: f(ks.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: ks.content, children: i.name })
  ] });
}, $I = "h-simpleProgressBar--simpleProgressBar__container", OI = "h-simpleProgressBar--simpleProgressBar__progressBar", BI = "h-simpleProgressBar--simpleProgressBar__progressBarFill", Ds = {
  container: $I,
  progressBar: OI,
  progressBarFill: BI
}, HI = "simpleProgressBarId";
function AD({
  progress: i,
  base: e = 100,
  progressColor: t = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  Z(() => c(i), [i]);
  const h = e >= l ? l / e : 1, u = () => d / h, p = {
    backgroundColor: en(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: en(t)
  };
  return /* @__PURE__ */ s.jsx(
    H,
    {
      "test-id": HI,
      "align-items": "center",
      "justify-content": "center",
      className: Ds.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        re,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: Ds.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: Ds.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const WI = "h-tabsWithContent--tabsWithContent__container", MI = "h-tabsWithContent--tabsWithContent__containerTop", zI = "h-tabsWithContent--tabsWithContent__containerLeft", VI = "h-tabsWithContent--tabsWithContent__containerRight", KI = "h-tabsWithContent--tabsWithContent__containerBottom", UI = "h-tabsWithContent--tabsWithContent__childrenContainer", It = {
  container: WI,
  containerTop: MI,
  containerLeft: zI,
  containerRight: VI,
  containerBottom: KI,
  childrenContainer: UI
};
class Os extends me {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.state = { activeTab: e.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(e) {
    this.ensureTabIsValid(e) && (this.setState({ activeTab: e }), this.props.onChange?.(e));
  }
  ensureTabIsValid(e) {
    return this.props.tabs.some((t) => t.id === e);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: e }) => e === this.state.activeTab);
  }
  render() {
    const {
      className: e,
      tabsClassName: t,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Ee.toArray(l);
    if (h.length !== a.length) {
      const g = `${Os.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Os.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(e, It.container, {
      [It.containerTop]: c === "top",
      [It.containerLeft]: c === "left",
      [It.containerBottom]: c === "bottom",
      [It.containerRight]: c === "right"
    }), m = f(
      r,
      It.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        If,
        {
          className: t,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const qI = "h-tagsInput--tagsInput__root", GI = "h-tagsInput--tagsInput__wrapper", YI = "h-tagsInput--tagsInput__input", QI = "h-tagsInput--tagsInput__inputIsHidden", XI = "h-tagsInput--tagsInput__placeholder", ZI = "h-tagsInput--tagsInput__placeholderText", JI = "h-tagsInput--tagsInput__iconBox", ek = "h-tagsInput--tagsInput__iconText", tk = "h-tagsInput--tagsInput__tag", nk = "h-tagsInput--tagsInput__tagIsActive", sk = "h-tagsInput--tagsInput__tagButton", be = {
  root: qI,
  wrapper: GI,
  input: YI,
  inputIsHidden: QI,
  placeholder: XI,
  placeholderText: ZI,
  iconBox: JI,
  iconText: ek,
  tag: tk,
  tagIsActive: nk,
  tagButton: sk
};
function fr(i = [], e) {
  switch (e) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const ok = 255, $D = ({
  className: i,
  disabled: e,
  limit: t,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = Q(null), c = Q(null), [d, h] = V(""), [u, p] = V(
    fr(o, r)
  ), [m, g] = V(""), [b, y] = V(!1);
  Ir(l, () => y(!1)), Je(() => a(u), [u, a]), Je(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const C = (I) => {
    h(I.target.value ?? "");
  }, w = (I) => {
    const D = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((F) => {
          const W = Array.from(/* @__PURE__ */ new Set([...F, d]));
          return h(""), fr(W, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (S(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && D > 0 && g(u[D - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && D < u.length - 1 && g(u[D + 1]);
        break;
      default:
        m && g("");
    }
  }, S = (I) => {
    p((D) => {
      const F = [...D];
      return F.splice(F.indexOf(I), 1), F;
    });
  }, v = b ? u.length : t || u.length, x = v < u.length, _ = u.slice(0, v);
  return /* @__PURE__ */ s.jsx(
    Me,
    {
      ref: l,
      className: f(be.root, i),
      onClick: () => y(!0),
      disabled: e,
      children: /* @__PURE__ */ s.jsxs("div", { className: be.wrapper, "data-testid": "tags-wrapper", children: [
        _.map((I) => /* @__PURE__ */ s.jsx(
          Nt,
          {
            className: f(be.tag, {
              [be.tagIsActive]: I === m
            }),
            onDelete: () => S(I),
            "data-testid": "tag",
            children: I
          },
          I
        )),
        !b && x && /* @__PURE__ */ s.jsxs(
          Nt,
          {
            className: f(be.tag, be.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - v
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(H, { className: be.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx($.Paragraph, { className: be.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx($.Paragraph, { className: be.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: be.iconBox, children: [
            /* @__PURE__ */ s.jsx(P, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx($.Paragraph, { className: be.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(be.input, {
              [be.inputIsHidden]: !b
            }),
            onChange: C,
            onKeyDown: w,
            maxLength: ok,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, rk = "h-textWithHighlight--textWithHighlight__highlight", ik = {
  highlight: rk
}, ak = ({
  text: i,
  highlight: e,
  className: t,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!e?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    Ms(e.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: t, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(ik.highlight, n), children: a[d] })
  ] }, d)) });
}, lk = wr(ak);
lk.name = "TextWithHighlight";
const ck = "h-timestamp--timestamp__timestamp", dk = "h-timestamp--timestamp__print", hk = "h-timestamp--timestamp__screen", Ts = {
  timestamp: ck,
  print: dk,
  screen: hk
}, uk = 1e4;
class OD extends me {
  interval;
  static defaultProps = {
    refreshRate: uk
  };
  constructor(e) {
    super(e);
    const { relative: t, counter: n, initialFormat: o } = e;
    let r = o ?? "absolute";
    t ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: e } = this.state;
    (e === "ago" || e === "counter") && this.startTicker();
  }
  componentDidUpdate(e) {
    const { relative: t, initialFormat: n } = this.props, { pristine: o } = this.state;
    t !== e.relative && o && this.setState({
      format: t ? "ago" : "absolute"
    }), n && n !== e.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(e) {
    const { onClick: t } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), t?.(o, e);
  }
  getTimeString(e) {
    let { time: t } = this.props;
    const { isSecondsDisplayed: n, customFormatters: o } = this.props;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (e === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, y = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        y.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (e === "full") {
      const l = o?.full ?? (n ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (e === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = o?.absolute ?? `D MMMM LT${n ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = o?.absolute ?? `LT${n ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = Th(a);
    return r;
  }
  render() {
    const {
      className: e,
      relative: t,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [Ts.timestamp]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          ...h,
          ...Yn(this.handleClick),
          className: f(u, Ts.screen),
          children: this.getTimeString(this.state.format)
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: f(u, Ts.print), "aria-hidden": !0, children: this.getTimeString("full") })
    ] });
  }
}
const pk = "h-token--token__root", mk = "h-token--token__select", gk = "h-token--token__label", fk = "h-token--token__rootReadonly", bk = "h-token--token__rootPrimary", yk = "h-token--token__rootWithError", xk = "h-token--token__value", _k = "h-token--token__icon", Be = {
  root: pk,
  select: mk,
  label: gk,
  rootReadonly: fk,
  rootPrimary: bk,
  rootWithError: yk,
  value: xk,
  icon: _k
};
class BD extends k {
  render() {
    const {
      onDelete: e,
      id: t,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Be.root]: !0,
        [Be.rootPrimary]: a,
        [Be.rootWithError]: c?.error,
        [Be.rootReadonly]: !o && !e
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Be.select, id: t, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Be.label, htmlFor: t, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Be.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(P, { className: Be.icon, name: "angle-down" }),
        !!e && /* @__PURE__ */ s.jsx("span", { ...Yn(e), children: /* @__PURE__ */ s.jsx(P, { className: Be.icon, name: "close", onClick: e }) })
      ] })
    ] });
  }
}
const Ck = "h-skeleton--skeleton__root", vk = "h-skeleton--skeleton__rootAnimationPulse", wk = "h-skeleton--skeleton__rootAnimationWave", js = {
  root: Ck,
  rootAnimationPulse: vk,
  rootAnimationWave: wk
};
function br({ className: i, animation: e = "pulse", ...t }, n) {
  const o = f(
    {
      [js.root]: !0,
      [js.rootAnimationPulse]: e === "pulse",
      [js.rootAnimationWave]: e === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(le, { className: o, ...t, ref: n });
}
const HD = Object.assign(M(br), {
  name: br.name
}), Sk = "h-breadcrumbs--breadcrumbs__root", Ik = "h-breadcrumbs--breadcrumbs__list", kk = "h-breadcrumbs--breadcrumbs__item", Dk = "h-breadcrumbs--breadcrumbs__separator", Ln = {
  root: Sk,
  list: Ik,
  item: kk,
  separator: Dk
}, WD = M(function({
  className: e,
  children: t,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(P, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Ee.toArray(t).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Ln.root, e),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Ln.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(et, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.item,
              "aria-current": p ? "page" : void 0,
              children: m
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  hg as AddonTriggerContext,
  ug as AddonTriggerEvents,
  Ok as Attachment,
  kr as Avatar,
  Su as AvatarSelectItem,
  Hk as Badge,
  Wk as Banner,
  le as Box,
  WD as Breadcrumbs,
  te as Button,
  Mk as ButtonGroup,
  fo as ButtonList,
  Zk as CheckableAvatarSelectItem,
  Xs as CheckableBaseItem,
  Yk as CheckableSelectItem,
  Xk as CheckableTagSelectItem,
  cn as Checkbox,
  Vu as Chip,
  Vk as CollapseCard,
  Kk as Collapsible,
  Xn as ColorPicker,
  ue as Column,
  $c as Columns,
  td as CopyToClipboard,
  Uk as CopyToClipboardButton,
  bD as CountryFlag,
  qk as DataTable,
  nm as DatePicker,
  Zt as DatePickerOld,
  Gp as DateRangePicker,
  Ru as DeselectItem,
  tD as Dialer,
  Gn as Divider,
  nt as Dropdown,
  ut as DropdownButton,
  dn as DropdownButtonContext,
  Qs as DropdownInfinite,
  Lo as DropdownItem,
  eo as DropdownSelect,
  zr as DropdownSelectContainer,
  nD as DropdownSelectMultiple,
  Mi as EMOJIS,
  VD as EmojiPicker,
  hn as EmptySelectItem,
  Td as EmptyState,
  Pt as ErrorBoundary,
  ma as ErrorBoundaryContext,
  fD as FieldAddonDropdown,
  Jn as FieldAlert,
  sD as FieldButton,
  gD as FieldColorPicker,
  oD as FieldDatePicker,
  rD as FieldDateRangePicker,
  Ys as FieldLabel,
  aD as FieldRichText,
  lD as FieldSelect,
  cD as FieldSelectionList,
  dD as FieldSlider,
  hD as FieldSwitch,
  Rs as FieldText,
  uD as FieldTextarea,
  pD as FieldTimePicker,
  mD as FieldTimeRangePicker,
  z as FieldWrapper,
  H as FlexBox,
  Dr as FocusScope,
  _D as FormField,
  xD as FormGrid,
  Gs as HelpIcon,
  CD as HelperField,
  P as Icon,
  q as IconButton,
  Ks as Image,
  Ly as InputColorPicker,
  Em as InputDatePicker,
  on as InputDateRangePicker,
  vD as InputDuration,
  ao as InputRichText,
  Zb as InputSelectionList,
  Xe as InputText,
  Me as InputWrapper,
  wD as Lightbox,
  SD as List,
  SD as ListV2,
  ID as MediaPlayer,
  Hw as Modal,
  kD as ModalBody,
  qS as ModalFoot,
  DD as ModalHead,
  Bw as ModalStackContext,
  KD as NavigationButton,
  TD as Page,
  _d as Pagination,
  Tw as Portal,
  Hr as Presets,
  jD as Radio,
  FD as RemovableCard,
  ND as ReverseScroll,
  ri as SandboxIframe,
  RD as ScrollShadow,
  PD as Scrollbar,
  ED as SearchInput,
  _p as Select,
  Wr as SelectItem,
  LD as SelectOption,
  Eb as SelectionList,
  od as SimplePagination,
  AD as SimpleProgressBar,
  HD as Skeleton,
  $s as Slider,
  zs as Spinner,
  _y as Switch,
  pe as Table,
  Zn as TableContext,
  If as Tabs,
  Os as TabsWithContent,
  Nt as Tag,
  eD as TagDeselectItem,
  Qk as TagSelectItem,
  Jk as TagSelectSuggestion,
  $D as TagsInput,
  $ as Text,
  lk as TextWithHighlight,
  ti as Textarea,
  sn as TimePicker,
  Bp as TimeRangePicker,
  OD as Timestamp,
  BD as Token,
  re as Tooltip,
  qn as WindowContext,
  $k as WindowProvider,
  UD as addSvgIconsToDocument,
  za as badgeTestId,
  Rc as colorPickerTestId,
  yD as countryCodes,
  Gk as datepickerDisableWeekends,
  qD as defaultElementType,
  so as formatShortcut,
  Qm as formattingOptions,
  Lt as getSelectionListContext,
  GD as iconMeta,
  Yo as inputRichTextCommands,
  Xb as inputSelectionListTestId,
  xI as reverseScrollTestId,
  Vs as useWindowContext,
  ln as withErrorBoundary
};
//# sourceMappingURL=index.js.map
